export const sv = {
  app: {
    home: 'Hem',
    playerScout: 'Spelarscout',
    playerComparison: 'Spelarjämförelse',
    playerRecruitment: 'Radar',
    collections: 'Samlingar',
    favoritePlayers: 'Favoritspelare',
    teamAnalytics: 'Laganalys',
    gameAnalysis: 'Matchanalys',
    seasonStats: 'Säsongsstatistik',
    leagueTable: 'Ligatabell',
    scoresAndFixtures: 'Resultat & Spelschema',
    notifications: 'Aviseringar',
    administration: 'Administration',
    inbox: 'Inkorg',
    teamStats: 'Lagstatistik',
    blog: 'Blogg',
    leagues: 'Ligor',
    squadBuilder: 'Lagbyggare',
    playerAlerts: 'Spelarvarningar',
    searchAlerts: 'Sökvarningar',
    videoUploadTool: 'Verktyg för videouppladdning',
    videoPlaylists: 'Spellistor',
    uploadedGames: 'Uppladdade matcher',
    favoriteTeams: 'Favoritlag',
    arrigo: 'Arrigo',
    validateEvents: 'Validera händelser'
  },
  playerRecruitment: {
    title: 'Spelarprofil',
    subtitle: 'Fördjupa dig i spelarens egenskaper och statistik',
    league: 'Liga',
    selectedSeason: 'Vald säsong',
    year: 'År',
    radar: 'Radar',
    positions: 'Positioner',
    numberOfPlayers: 'Antal spelare',
    template: 'Mall',
    compareWith: 'Jämför med',
    previousPerformance: 'Tidigare prestation',
    xGames: '{0} matcher',
    average: 'Genomsnitt',
    leagueAverage: 'Ligagenomsnitt',
    selectSeason: 'Välj en säsong',
    positionsPlayed: 'Spelade positioner',
    minMax: 'Min & Max',
    top5Leagues: 'Topp 5-ligor',
    infoMessage: 'Markera endast en säsong för att aktivera Säsong Min & Max',
    infoMessage2: 'Välj samma säsong för båda spelarna',
    dataPer90MinText: 'Data per 90 minuter',
    adjustToPossessionText: '* Justerat för bollinnehav',
    text: 'Text',
    lollipop: 'Lollipop',
    polar: 'Polar',
    noGamesBetweenDates: 'Inga matcher hittades mellan de valda datumen',
    radarTemplates: {
      Goalkeeper: 'Målvakt',
      GoalkeeperCustom: 'Målvakt Anpassad',
      GoalkeeperCustom1: 'Målvakt Anpassad 1',
      GoalkeeperCustom2: 'Målvakt Anpassad 2',
      GoalkeeperCustom3: 'Målvakt Anpassad 3',
      GoalkeeperCustom4: 'Målvakt Anpassad 4',
      GoalkeeperCustom5: 'Målvakt Anpassad 5',
      GoalkeeperCustom6: 'Målvakt Anpassad 6',
      Defender: 'Försvarare',
      DefenderCustom: 'Försvarare Anpassad',
      DefenderCustom1: 'Försvarare Anpassad 1',
      DefenderCustom2: 'Försvarare Anpassad 2',
      DefenderCustom3: 'Försvarare Anpassad 3',
      DefenderCustom4: 'Försvarare Anpassad 4',
      DefenderCustom5: 'Försvarare Anpassad 5',
      DefenderCustom6: 'Försvarare Anpassad 6',
      FullBack: 'Ytterback',
      FullBackCustom: 'Ytterback Anpassad',
      FullBackCustom1: 'Ytterback Anpassad 1',
      FullBackCustom2: 'Ytterback Anpassad 2',
      FullBackCustom3: 'Ytterback Anpassad 3',
      FullBackCustom4: 'Ytterback Anpassad 4',
      FullBackCustom5: 'Ytterback Anpassad 5',
      FullBackCustom6: 'Ytterback Anpassad 6',
      FullBackPredictive: 'Ytterback',
      Midfielder: 'Mittfältare',
      MidfielderCustom: 'Mittfältare Anpassad',
      MidfielderCustom1: 'Mittfältare Anpassad 1',
      MidfielderCustom2: 'Mittfältare Anpassad 2',
      MidfielderCustom3: 'Mittfältare Anpassad 3',
      MidfielderCustom4: 'Mittfältare Anpassad 4',
      MidfielderCustom5: 'Mittfältare Anpassad 5',
      MidfielderCustom6: 'Mittfältare Anpassad 6',
      MidfielderPredictive: 'Mittfältare',
      MidfielderDefensive: 'Defensiv mittfältare',
      MidfielderOffensive: 'Offensiv mittfältare',
      AttackingMidfielder: 'Offensiv mittfältare',
      MidfielderWing: 'Yttermittfältare',
      Winger: 'Ytter',
      WingerCustom: 'Ytter Anpassad',
      WingerCustom1: 'Ytter Anpassad 1',
      WingerCustom2: 'Ytter Anpassad 2',
      WingerCustom3: 'Ytter Anpassad 3',
      WingerCustom4: 'Ytter Anpassad 4',
      WingerCustom5: 'Ytter Anpassad 5',
      WingerCustom6: 'Ytter Anpassad 6',
      WingerOffensive: 'Offensiv ytter',
      Forward: 'Anfallare',
      ForwardCustom: 'Anfallare Anpassad',
      ForwardCustom1: 'Anfallare Anpassad 1',
      ForwardCustom2: 'Anfallare Anpassad 2',
      ForwardCustom3: 'Anfallare Anpassad 3',
      ForwardCustom4: 'Anfallare Anpassad 4',
      ForwardCustom5: 'Anfallare Anpassad 5',
      ForwardCustom6: 'Anfallare Anpassad 6',
      ForwardPredictive: 'Anfallare',
      WingBack: 'Vingback',
      WingBackCustom: 'Vingback Anpassad',
      WingBackCustom1: 'Vingback Anpassad 1',
      WingBackCustom2: 'Vingback Anpassad 2',
      WingBackCustom3: 'Vingback Anpassad 3',
      WingBackCustom4: 'Vingback Anpassad 4',
      WingBackCustom5: 'Vingback Anpassad 5',
      WingBackCustom6: 'Vingback Anpassad 6',
      WingBackMedia: 'Vingback (Sociala medier)',
      FullBackMedia: 'Ytterback (Sociala medier)',
      MidfielderMedia: 'Mittfältare (Sociala medier)',
      WingerMedia: 'Ytter (Sociala medier)',
      ForwardMedia: 'Anfallare (Sociala medier)',
      PhysicalWingBack: 'Fysisk Vingback',
      PhysicalForward: 'Fysisk anfallare',
      PhysicalWinger: 'Fysisk ytter',
      PhysicalMidfielder: 'Fysisk mittfältare',
      PhysicalFullBack: 'Fysisk ytterback',
      PhysicalDefender: 'Fysisk försvarare',
      PhysicalWingBackLMO: 'Fysisk Vingback',
      PhysicalForwardLMO: 'Fysisk anfallare',
      PhysicalWingerLMO: 'Fysisk ytter',
      PhysicalMidfielderLMO: 'Fysisk mittfältare',
      PhysicalFullBackLMO: 'Fysisk ytterback',
      PhysicalDefenderLMO: 'Fysisk försvarare'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Målvakt',
      Defender: 'Försvarare',
      FullBack: 'Ytterback',
      FullBackPredictive: 'Ytterback',
      Midfielder: 'Mittfältare',
      MidfielderPredictive: 'Mittfältare',
      MidfielderDefensive: 'Defensiv mittfältare',
      MidfielderOffensive: 'Offensiv mittfältare',
      AttackingMidfielder: 'Offensiv mittfältare',
      MidfielderWing: 'Yttermittfältare',
      Winger: 'Ytter',
      WingerOffensive: 'Offensiv ytter',
      Forward: 'Anfallare',
      ForwardPredictive: 'Anfallare',
      WingBack: 'Vingback',
      WingBackMedia: 'Vingback (Sociala medier)',
      FullBackMedia: 'Ytterback (Sociala medier)',
      MidfielderMedia: 'Mittfältare (Sociala medier)',
      WingerMedia: 'Ytter (Sociala medier)',
      ForwardMedia: 'Anfallare (Sociala medier)',
      PhysicalWingBack: 'Fysisk Vingback',
      PhysicalForward: 'Fysisk anfallare',
      PhysicalWinger: 'Fysisk ytter',
      PhysicalMidfielder: 'Fysisk mittfältare',
      PhysicalFullBack: 'Fysisk ytterback',
      PhysicalDefender: 'Fysisk försvarare',
      PhysicalWingBackLMO: 'Fysisk Vingback',
      PhysicalForwardLMO: 'Fysisk anfallare',
      PhysicalWingerLMO: 'Fysisk ytter',
      PhysicalMidfielderLMO: 'Fysisk mittfältare',
      PhysicalFullBackLMO: 'Fysisk ytterback',
      PhysicalDefenderLMO: 'Fysisk försvarare'
    },
    radarDescription: {
      basicStatistics: {
        title: 'GRUNDLÄGGANDE STATISTIK',
        minutes: 'minuter',
        goals: 'mål',
        assists: 'assist',
        redCards: 'röda kort',
        yellowCards: 'gula kort',
        games: 'matcher',
        goalsReceived: 'insläppta mål (utan straff)',
        xGFaced: 'xG emot'
      },
      profiles: {
        3: {
          1: 'Skicklig målvakt med bollen vid fötterna, både i korta och långa passningar.',
          2: 'Förmåga att spela med fötterna och vara viktig i initieringen av spelet, med bra passningsprocent både kort och lång.',
          3: 'Bra fotarbete som gör den här profilen till ett intressant alternativ på grund av dess godkända mätvärden.',
          4: 'Profil som sticker ut för sina passningar, vare sig det är i det egna fältet eller i motståndarens fält.',
          5: 'Stor säkerhet med bollen vid fötterna och hög passningsförmåga.',
          6: 'Bra fotarbete, ger trygghet vid avfyrning av bollen och genomför en hög andel korta och långa passningar.',
          7: 'Hög andel genomförda pass, både korta och långa, ger kvalitet i omlopp.'
        },
        5: {
          1: 'Försvarare som utmärker sig i en-mot-en och gör många tacklingar och interceptioner.',
          2: 'Mycket effektiv mittback i individuella dueller, både över och i tacklingen, med bra läsning att förutse.',
          3: 'Mittförsvar med bra prestationer i individuella defensiva dueller, vilket leder till en stor volym av återhämtningar.',
          4: 'Profil med hög defensiv nivå, kapabel att återhämta en stor volym bollar tack vare tacklingar och interceptions.',
          5: 'Mycket effektivt försvar i tacklingen och med ett stort antal interceptions, som sticker ut i individuell konfrontation.',
          6: 'Mittback med ett stort antal återhämtningar per match, skicklig på att läsa rivaliserande spel och skära, med hög precision och frekvens i tacklingar.',
          7: 'Defensiv profil med en hög volym av återhämtning tack vare effektiviteten och frekvensen av tacklingar och bra läsning att förutse.'
        },
        6: {
          1: 'Försvarare med stor betydelse i chansskapandet och god speluppfattning.'
        },
        7: {
          1: 'Spelare med balanserat spel mellan offensiv (stor insats i "xG Buildup") och defensiv (hög volym bollvinster).'
        },
        8: {
          1: 'Solid i defensiva en-mot-en och hög volym av bollvinster, både via tacklingar och interceptioner.'
        },
        9: {
          1: 'Spelare med stort offensivt bidrag som skapar farliga aktioner och målchanser.'
        },
        10: {
          1: 'Komplett spelare som täcker stora ytor, bidrar i bollvinster och står för en relevant andel av lagets totala "xG Buildup".'
        },
        11: {
          1: 'Mittfältare med hög defensiv nivå och stor passningssäkerhet trots begränsat offensivt inflytande.'
        },
        12: {
          1: 'Komplett mittfältare som skapar chanser, är stark i luften och gör många interceptioner och tacklingar.'
        },
        15: {
          1: 'Ytter skicklig i en-mot-en med bra nivå på inlägg; genererar mer förväntade assist än skott.'
        },
        16: {
          1: 'Spelare med stor volym djupledsbollar och bollprogression, skapar chanser och påverkar spelet centralt mer än en typisk ytter.'
        },
        17: {
          1: 'Spelare med bra dribbling som söker inåt i banan för att generera fler skott (xG) än nyckelpassningar (xA).'
        },
        18: {
          1: 'Anfallare som arbetar hårt utan boll och väljer väl mellan avslut och passning.'
        },
        22: {
          1: 'Rörlig anfallare som löper i djupled, droppar ut på kanten och skapar många chanser. Hög andel balltouch utanför straffområdet i förhållande till totala antalet touch per match.'
        }
      },
      description: 'BESKRIVNING',
      conjuction: ' och ',
      conjuction2: ' och ',
      over: 'över',
      under: 'under',
      respectively: ', respektive',
      Defending1: {
        1: 'Den defensiva prestationen är bland de sämsta i topp 5-ligorna'
      },
      Defending2: {
        1: 'Den defensiva prestationen är inte bra eftersom nivån ligger under genomsnittet'
      },
      Defending3: {
        1: 'En medelnivå hålls, något over_under_average genomsnittet'
      },
      Defending4: {
        1: 'Framstående i defensiva uppgifter med över genomsnittlig prestation'
      },
      Defending5: {
        1: 'Utmärkt i defensiva uppgifter, i nivå med de bästa player_positions i topp 5-ligorna'
      },
      Saving1: {
        1: 'Målvakt med mycket låg nivå, har stora svårigheter att blockera bollen'
      },
      Saving2: {
        1: 'Håller inte en god nivå som målvakt då prestationen är under genomsnittet'
      },
      Saving3: {
        1: 'Målvakt med acceptabel nivå, kring snittet i topp 5-ligorna, men behöver förbättra metric_name'
      },
      Saving4: {
        1: 'Målvakt med bra nivå, över snittet i topp 5-ligorna, utmärker sig särskilt i metric_name'
      },
      Saving5: {
        1: 'Väldigt komplett målvakt; alla metriker placerar spelaren inom topp 20% jämfört med målvakter i Europas topp 5-ligor.'
      },
      Passing1: {
        1: 'Med boll är nivån bland de sämsta'
      },
      Passing2: {
        1: 'I passningsspelet är prestationen under genomsnittet'
      },
      Passing3: {
        1: 'Passningsnivån är acceptabel, något over_under_average genomsnittet'
      },
      Passing4: {
        1: 'Mycket bra nivå i passningsspelet, klart över genomsnittet'
      },
      Passing5: {
        1: 'Stor effektivitet i passningsspelet, bättre än de flesta'
      },
      Aerial1: {
        1: 'Mycket svag i luftspelet, bland de sämsta på sin position i detta avseende'
      },
      Aerial2: {
        1: 'När det gäller att vinna luftdueller är nivån under genomsnittet'
      },
      Aerial3: {
        1: 'Acceptabel nivå i luftspelet, något over_under_average genomsnittet'
      },
      Aerial4: {
        1: 'Hög nivå i luftspelet, med stor effektivitet i detta avseende'
      },
      Aerial5: {
        1: 'Luftspelsmetrikerna placerar spelaren bland de bästa'
      },
      Shooting1: {
        1: 'Mycket svaga siffror framför mål, bland de sämsta i detta avseende'
      },
      Shooting2: {
        1: 'Avslutsnivån behöver förbättras avsevärt, under genomsnittet'
      },
      Shooting3: {
        1: 'Acceptabel offensiv prestation, något over_under_average genomsnittet'
      },
      Shooting4: {
        1: 'Presterar mycket bra i boxen, bättre än över 60% av spelarna'
      },
      Shooting5: {
        1: 'Stora offensiva kvaliteter och spektakulär prestation; placerar spelaren bland de bästa'
      },
      Association1: {
        1: 'Prestationen i kombinationsspelet är mycket låg, bland de sämsta i topp 5-ligorna'
      },
      Association2: {
        1: 'Mycket att förbättra med bollen; under genomsnittet i detta avseende'
      },
      Association3: {
        1: 'Bra i kombinationsspelet, något over_under_average genomsnittet'
      },
      Association4: {
        1: 'Väldigt bra i kombinationsspelet med en påtagligt hög nivå'
      },
      Association5: {
        1: 'Exceptionell förmåga i kombinationsspelet, bland de bästa'
      },
      BallHandling1: {
        1: 'Mycket svag bollbehandling, bland de sämsta jämfört med topp 5-ligorna'
      },
      BallHandling2: {
        1: 'Bollbehandlingen är under genomsnittet'
      },
      BallHandling3: {
        1: 'Acceptabel bollbehandling, något over_under_average genomsnittet'
      },
      BallHandling4: {
        1: 'Hög nivå i bollbehandling, siffror nära de bästa i detta avseende'
      },
      BallHandling5: {
        1: 'Exceptionell bollbehandling, bland de bästa i topp 5-ligorna'
      },
      Crosses1: {
        1: 'Låg nivå på inlägg; bland de sämsta i inläggsmetriker'
      },
      Crosses2: {
        1: 'Under genomsnittet när det gäller att skapa fara via inlägg'
      },
      Crosses3: {
        1: 'Acceptabel nivå på inlägg in i boxen, något over_under_average'
      },
      Crosses4: {
        1: 'Bra siffror i inläggsspelet, klart över genomsnittet'
      },
      Crosses5: {
        1: 'Mycket hög nivå på inlägg in i boxen; bland de 20% mest effektiva i denna kategori'
      },
      Carries1: {
        1: 'Bland de 20% av spelarna med sämst siffror i bolltransport'
      },
      Carries2: {
        1: 'Bolltransporten ligger långt under snittet för positionen'
      },
      Carries3: {
        1: 'Nära genomsnittet i bolltransport, något over_under_average'
      },
      Carries4: {
        1: 'Framstående spelare med mycket bra djup och siffror i bolltransport'
      },
      Carries5: {
        1: 'Mycket skicklig i bolltransport, med höga värden i denna kategori'
      },
      Turnovers1: {
        1: 'Mycket negativ prestation med hög volym bolltapp som underlättar för motståndaren att skapa fara. Bland de sämsta i denna metric'
      },
      Turnovers2: {
        1: 'De många farliga bolltappen gynnar motståndarna; det krävs en avsevärd förbättring och en minskning av dessa bolltapp'
      },
      Turnovers3: {
        1: 'Spelaren ligger något over_under_average vad gäller bolltapp; det finns tydlig förbättringspotential'
      },
      Turnovers4: {
        1: 'Anmärkningsvärt låg frekvens av bolltapp; bättre än 60% av spelarna'
      },
      Turnovers5: {
        1: 'De få bolltapp som sker är värda att notera och placerar spelaren bland de bästa i bollinnehav för laget'
      },
      SequenceInvolvement1: {
        1: 'I bollinnehav är siffrorna inte gynnsamma; anfall avslutas sällan med skott'
      },
      SequenceInvolvement2: {
        1: 'Avslut på anfall är klart förbättringsbart; anfall avslutas sällan med skott och nivån ligger tydligt under genomsnittet'
      },
      SequenceInvolvement3: {
        1: 'Acceptabel nivå i avslut av anfall; percentil något over_under_average av snittet och tydlig förbättringsmöjlighet'
      },
      SequenceInvolvement4: {
        1: 'God förmåga att avsluta lagets anfall med skott, ibland med mål; anmärkningsvärd nivå i denna kategori'
      },
      SequenceInvolvement5: {
        1: 'Bland de mest framstående när det gäller att avsluta lagets anfall med farliga skott'
      },
      OutPlay1: {
        1: 'Spelaren har minimal påverkan när det gäller att störa defensiva strukturer'
      },
      OutPlay2: {
        1: 'Bidraget till progression och att bryta linjer är under positionsstandard'
      },
      OutPlay3: {
        1: 'Kan ibland skapa fördelar; presterar kring snittet för sin position'
      },
      OutPlay4: {
        1: 'Bidrar ofta till att bryta defensiva linjer och skapa obalans'
      },
      OutPlay5: {
        1: 'Bland de mest framstående på sin position när det gäller att eliminera motståndare och driva progression'
      },
      LineBreakingPasses1: {
        1: 'Försöker sällan eller lyckas med linjebrytande passningar; mycket begränsat bidrag i dessa aktioner'
      },
      LineBreakingPasses2: {
        1: 'Har svårt att konsekvent hitta lagkamrater mellan linjer eller bakom press; under standard för positionen'
      },
      LineBreakingPasses3: {
        1: 'Står för vissa linjebrytande passningar; kring genomsnittet på sin position'
      },
      LineBreakingPasses4: {
        1: 'Spelaren bryter ofta linjer med sina passningar och hjälper till att rubba motståndarens block'
      },
      LineBreakingPasses5: {
        1: 'Bland de mest effektiva passningsspelarna i ligan på att bryta linjer och spela ur press; en av de största styrkorna'
      },
      PassUnderPressure1: {
        1: 'Har svårt att behålla lugn och effektivitet när spelaren pressas'
      },
      PassUnderPressure2: {
        1: 'Har problem att bibehålla passningsprecision under hård press'
      },
      PassUnderPressure3: {
        1: 'Kring snittet i passningsspel under press; pressen hanteras okej men utan konsekvent rent utförande'
      },
      PassUnderPressure4: {
        1: 'Lyckas ofta hitta lagkamrater trots press; ligger över genomsnittet i den typen av passningar'
      },
      PassUnderPressure5: {
        1: 'Visar exceptionellt lugn och precision i passningsspelet under hård press; tillhör de bästa på sin position i detta avseende'
      },
      BallReceived1: {
        1: 'Får väldigt få passningar i avancerade ytor; opererar sällan mellan linjerna'
      },
      BallReceived2: {
        1: 'Tar emot en del obevakade passningar på offensiv planhalva men utan större konsekvens'
      },
      BallReceived3: {
        1: 'Noterar medelstor volym obevakade mottagningar i offensiva zoner'
      },
      BallReceived4: {
        1: 'Tar ofta emot mellan linjer och i ytor fria från press'
      },
      BallReceived5: {
        1: 'Ackumulerar många mottagningar mellan linjerna, fria från försvarare och i potentiellt avgörande ytor'
      },
      OnBallPressure1: {
        1: 'Pressar sällan och nästan aldrig nära bollhållaren. Inte en intensiv spelare'
      },
      OnBallPressure2: {
        1: 'Går in i vissa hårda pressmoment men inte ofta. Övergripande intensitet är ganska låg'
      },
      OnBallPressure3: {
        1: 'Noterar medelhög volym press nära motståndare i bollinnehav'
      },
      OnBallPressure4: {
        1: 'Disciplinerad presspelare som regelbundet kommer nära bollhållaren'
      },
      OnBallPressure5: {
        1: 'Mycket intensiv utan boll, högdisciplinerad och arbetar hårt i presspelet'
      },
      SpatialCoverage1: {
        1: 'Spelaren bidrar mycket begränsat till yttäckning och kontroll, med minimalt deltagande i lagets formation och taktiska struktur. Yttäckningen är svag både med och utan boll, vilket speglar liten påverkan på kollektiv organisation och kompakthet'
      },
      SpatialCoverage2: {
        1: 'Spelaren har yttäckning under genomsnittet; viss närvaro i ytorna men med brister i positionskontinuitet och koordination med laget. Påverkan på den taktiska strukturen är ojämn och mindre konsekvent än hos högre rankade spelare'
      },
      SpatialCoverage3: {
        1: 'Spelaren visar genomsnittlig yttäckning och bidrar stabilt till ytbemanning och kontroll. Positioneringen är i regel korrekt och funktionell med måttlig påverkan i både offensiv och defensiv'
      },
      SpatialCoverage4: {
        1: 'Spelaren erbjuder yttäckning över genomsnittet, med hög delaktighet i positionsspel och lagets struktur. Förmågan att hålla formen och anpassa sig i omställningar bidrar starkt till kompakthet och kontroll av nyckelytor'
      },
      SpatialCoverage5: {
        1: 'Spelaren når utmärkt yttäckning och optimerar positioneringen för att tydligt påverka lagets formation och taktiska struktur. Spelförståelse och synk med laget maximerar bemanning av strategiska ytor i både anfall och försvar'
      },
      OffBallPressure1: {
        1: 'Spelaren applicerar mycket begränsat defensivt tryck utan boll och stör sällan motståndarnas aktioner. Bidraget till press och defensiv struktur är minimalt'
      },
      OffBallPressure2: {
        1: 'Spelaren ligger under genomsnittet i defensivt tryck utan boll; deltar ibland men med inkonsekvent tajming eller positionering. Begränsad påverkan på bollvinster eller att störa motståndarens uppbyggnad'
      },
      OffBallPressure3: {
        1: 'Spelaren visar genomsnittlig nivå i press utan boll och bidrar stabilt defensivt. Positionering och tajming är överlag effektiva och begränsar motståndarens alternativ'
      },
      OffBallPressure4: {
        1: 'Spelaren håller över genomsnittet i press utan boll, stör ofta motståndaren och reducerar tid och yta. Insatserna är väl tajmade och koordinerade och stärker lagets defensiva struktur'
      },
      OffBallPressure5: {
        1: 'Spelaren excellerar i defensivt tryck utan boll; pressar konsekvent, tvingar fram bolltapp och stänger passningsvägar. Intensitet, positionering och spelförståelse höjer lagets defensiva effektivitet'
      },
      Distance1: {
        1: 'Spelaren täcker avsevärt mindre yta än genomsnittet (rörelsemönstret på planen är mycket begränsat)'
      },
      Distance2: {
        1: 'Distansen som täcks per match är under vad som vanligtvis ses i toppfotboll (mindre aktiv än genomsnittet)'
      },
      Distance3: {
        1: 'Spelaren täcker en rimlig mängd yta, med siffror kring ligasnittet (balanserad fysisk insats)'
      },
      Distance4: {
        1: 'Spelaren täcker konsekvent stora distanser med siffror som speglar stark uthållighet (solid fysisk kapacitet)'
      },
      Distance5: {
        1: 'Den fysiska volymen är exceptionell. Bland de mest aktiva i topp 5-ligorna mätt i täckt yta'
      },
      Sprint1: {
        1: 'Spelaren gör väldigt få högfartslöpningar jämfört med genomsnittet (minimalt sprintarbete över matcher)'
      },
      Sprint2: {
        1: 'Sprintfrekvensen är lägre än snittet för positionen (begränsad explosivitet i högfartsrörelser)'
      },
      Sprint3: {
        1: 'Genomför ett måttligt antal sprintar per match, inom förväntat snitt (värden kring ligasnitt)'
      },
      Sprint4: {
        1: 'Utmärker sig med hög sprintfrekvens, klart över genomsnittet. Visar konsekvent explosivitet med högfartslöpningar genom matchen'
      },
      Sprint5: {
        1: 'Tillhör topp 20% vad gäller flest sprintar per 90 minuter. Toppnivå i upprepade högfartsinsatser'
      },
      Acceleration1: {
        1: 'Förmågan att ändra tempo är klart under snittet; mycket få explosiva accelerationer under match'
      },
      Acceleration2: {
        1: 'Antalet accelerationer är under snittet jämfört med liknande spelare; begränsad frekvens av korta rusningar'
      },
      Acceleration3: {
        1: 'Spelaren registrerar ett rättvist antal accelerationer, nära ligasnittet. Tempoväxlingarna sticker inte ut men siffrorna är godkända'
      },
      Acceleration4: {
        1: 'Visar stark förmåga att accelerera snabbt och upprepade gånger; accelerationsfrekvensen är klart över snittet med frekventa korta rusningar'
      },
      Acceleration5: {
        1: 'Tillhör de 20% mest explosiva vad gäller upprepade accelerationer; ligger klart över snittet i snabba starter och tempoväxlingar'
      },
      Speed1: {
        1: 'Troligen fysiskt långsam spelare eller en som sparar på högintensiva insatser'
      },
      Speed2: {
        1: 'Toppfarter något under det konkurrenskraftiga snittet'
      },
      Speed3: {
        1: 'Håller genomsnittliga toppfarter genom matchen'
      },
      Speed4: {
        1: 'Når ofta höga hastigheter, vilket tyder på att spelaren är snabb och kraftfull'
      },
      Speed5: {
        1: 'Når mycket höga toppfarter. Troligen en spelare som gör skillnad med sin snabbhet'
      },
      LineBreakingCarries1: {
        1: 'Bryter sällan linjer genom bolltransport; brister i initiativ att avancera med bollen'
      },
      LineBreakingCarries2: {
        1: 'Genomför vissa linjebrytande transporter men utan större regelbundenhet'
      },
      LineBreakingCarries3: {
        1: 'Snittar ett måttligt antal lyckade linjebrytande transporter'
      },
      LineBreakingCarries4: {
        1: 'Bidrar i uppbyggnaden genom att ofta bära förbi linjer och stödja progression'
      },
      LineBreakingCarries5: {
        1: 'En verklig specialist i bolltransport; bryter konsekvent linjer med bollen och i hög volym'
      },
      LineBreakingActions1: {
        1: 'Registrerar mycket få linjebrytande aktioner (passningar och transporter). Tar sällan risker'
      },
      LineBreakingActions2: {
        1: 'Producerar vissa progressiva aktioner (passningar och transporter), men sällan. Tenderar att spela mer horisontellt'
      },
      LineBreakingActions3: {
        1: 'Kombinerar passningar och transporter som regelbundet bryter linjer. Bidrar till progression'
      },
      LineBreakingActions4: {
        1: 'Tekniskt skicklig och intelligent i att producera många aktioner (passningar och transporter) som bryter motståndarens linjer'
      },
      LineBreakingActions5: {
        1: 'En sann progressionsspecialist. Har stor påverkan i laget och bryter ständigt linjer med passningar och transporter'
      },
      OffBallRuns1: {
        1: 'Spelaren gör väldigt få syftesdrivna löpningar utan boll och bidrar begränsat i offensiven. Löpen skapar sällan yta, stör defensiva linjer eller förbättrar lagets koordination i anfallsspelet'
      },
      OffBallRuns2: {
        1: 'Spelaren erbjuder löpningar utan boll under genomsnittet; stödjer ibland anfallet men saknar konsekvens i tajming, riktning eller taktisk intention. Löpen har begränsad påverkan på ytskapande och struktur'
      },
      OffBallRuns3: {
        1: 'Spelaren visar genomsnittlig nivå av syftesdrivna löpningar utan boll och bidrar stabilt i anfallsspelet. Rörelsemönstren är oftast väl tajmade och funktionella'
      },
      OffBallRuns4: {
        1: 'Spelaren ligger över snittet i löpningar utan boll och gör ofta syftesdrivna löpningar som stör försvar, skapar passningsalternativ och öppnar ytor. Rörelsemönstren bidrar starkt till lagets koordination i anfall'
      },
      OffBallRuns5: {
        1: 'Spelaren excellerar i syftesdrivna löpningar utan boll; läser spelet tidigt och gör intelligenta löp som maximerar anfallshot. Tajming, positionering och rumsuppfattning skapar ständiga hot och förbättrar lagets flyt'
      },
      OverMaxValue: {
        1: 'Spelaren har extrem förmåga i over_max_metric_name, med prestation över maxvärdet, vilket placerar hen i topp 10% i topp 5-ligorna i detta avseende'
      },
      OverAverageSeason: {
        1: 'Gällande prestationen i over_average_metric_name ligger spelaren över ligasnittet league_name (over_average_metric_value vs average_metric_value)',
        2: 'Jämför man siffrorna med league_name i over_average_metric_name är prestationen över snittet (over_average_metric_value vs average_metric_value)'
      },
      UnderMinValue: {
        1: 'När det gäller under_min_metric_name behöver prestationen förbättras avsevärt då den placerar spelaren i lägsta percent_metric_name i topp 5-ligorna'
      },
      Over70Percent: {
        1: ', särskilt framträdande i over_70_metric_name med over_70_metric_value per 90 minuter, respektive',
        2: ', över 70% i over_70_metric_name med over_70_metric_value per 90 minuter, respektive',
        3: ', mer än anmärkningsvärd nivå i over_70_metric_name med over_70_metric_value per 90 minuter, respektive'
      },
      Under30Percent: {
        1: ', behöver arbeta hårdare i under_30_metric_name då prestationen med under_30_metric_value per 90 minuter, respektive, är låg',
        2: ', behöver förbättra sig markant i under_30_metric_name eftersom prestationen med under_30_metric_value per 90 minuter, respektive, är under förväntan',
        3: ', i under_30_metric_name med under_30_metric_value per 90 minuter, respektive, måste spelaren anstränga sig mer för bättre siffror'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'Värt att lyfta att prestationen överstiger ligasnittet league_name i '
      },
      OverAverageStats: {
        1: 'over_average_metric_name (over_average_metric_value vs average_metric_value i snitt)'
      },
      Over70PercentIndividualPressure: {
        1: ', mycket bra individuell press för att återerövra bollen',
        2: ', hög press på motståndaren för att vinna tillbaka bollen'
      },
      Under30PercentIndividualPressure: {
        1: ', behöver intensifiera pressen för att återvinna bollen',
        2: ', behöver lägga mer kraft på att pressa motståndaren'
      }
    },
    himSelf: 'sig själv',
    ownSeason: 'Egen säsong',
    minMaxTooltip: 'Anpassa minimi- och maximivärden för radarn',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: 'Logga in',
    latestBlogPosts: 'Senaste blogginlägg',
    signIn: 'Logga in',
    username: 'Användarnamn',
    password: 'Lösenord',
    passwordForgotten: 'Glömt lösenord',
    signUp: 'Registrera dig',
    enter: 'Gå in',
    forceTitle: 'Konto i användning',
    forceMessage: 'Kontot är redan anslutet på en annan enhet. Vill du koppla bort där och ansluta på denna enhet?',
    forgotMyPassword: 'Glömt mitt lösenord',
    firstLogin: 'Första inloggning',
    firstLoginMessage: 'Av säkerhetsskäl måste du ange ett nytt lösenord vid första inloggningen, samt välja ett föredraget språk för appen',
    firstLoginOverview: 'Här är en översikt av ditt konto, samt de ligor och produkter du har tillgång till.',
    passwordConfirmation: 'Bekräfta lösenord',
    forgotPasswordMessage: 'Skriv in din e‑post. Om det finns ett giltigt konto kopplat till e‑posten får du instruktioner i inkorgen för hur du återställer lösenordet',
    resetPassword: 'Återställ lösenord',
    resetPasswordLinkInvalid: 'Den här länken är ogiltig eller har utgått. Begär en ny återställning av lösenord från inloggningssidan.',
    skipSettings: 'Hoppa över inställningar',
    contact: 'Kontakt',
    cookiesText: 'Denna sida använder Googles cookies för att tillhandahålla sina tjänster och analysera trafik för att säkerställa kvalitet, generera användningsstatistik och upptäcka samt åtgärda missbruk.',
    contactUs: 'Kontakta oss',
    newsTitle: 'Nytt: Fysiska poäng!',
    newsText: 'Vi har lagt till två nya poäng för fysisk prestation vid sidan av vår ursprungliga poäng baserad på händelsedata: Uthållighetspoäng och Hastighets- & Kraftpoäng. Uthållighet lyfter fram spelare som täcker ytor konsekvent och klarar hög arbetsbelastning, medan Hastighet & Kraft fokuserar på topphastighet, sprinter och explosiva accelerationer. Båda går från 0 till 100 och inkluderar percentiler per liga och position för direkt jämförelse med liknande spelare.'
  },
  settings: {
    pageSubtitle: 'Anpassa din applikationsupplevelse',
    language: 'Språk',
    availableLeagues: 'Tillgängliga ligor',
    availableSeasons: 'Tillgängliga säsonger',
    availableProducts: 'Tillgängliga produkter',
    organization: 'Företag',
    changePassword: 'Byt lösenord',
    seasonTemplates: 'Säsongsmallar',
    seasonTemplatesSubtitle: 'Skapa egna säsongsmallar som senare kan väljas i Spelarranking och Spelarscout',
    templateName: 'Mallnamn',
    selectTemplate: 'Välj befintlig mall att redigera',
    radarDefault: 'Standardradar',
    default: 'Standard',
    tabs: {
      options: 'Alternativ',
      templates: 'Mallar',
      availableLeagues: 'Tillgängliga ligor',
      contactData: 'GBE kontaktuppgifter'
    },
    contactData: {
      userDetails: 'Användaruppgifter',
      firstName: 'Förnamn',
      lastName: 'Efternamn',
      contactDetails: 'Kontaktuppgifter för GBE',
      name: 'Namn',
      phone: 'Telefon',
      mobile: 'Mobil',
      email: 'E‑post',
      representativeDetails: 'Representantuppgifter för GBE'
    },
    currency: 'Valuta',
    fieldPreferences: 'Planinställningar',
    visualizationsPreferences: 'Visualiseringsinställningar',
    fieldColor: 'Planfärg',
    fieldColors: {
      green: 'Grön',
      blue: 'Blå',
      white: 'Vit',
      black: 'Svart',
      grey: 'Grå'
    },
    defaultPlayerVisualization: 'Standardvisualisering för spelare',
    appPreferences: 'Applikationsinställningar',
    darkMode: 'Mörkt läge',
    showTour: 'Visa guidad rundtur',
    customStats: 'Anpassad statistik',
    radarTemplates: 'Radarmallar',
    radarTemplatesSubtitle: 'Skapa egna metrikmallar som senare kan väljas i Radar och Ranking',
    radarCategories: {
      Custom1: 'Anpassad 1',
      Custom2: 'Anpassad 2',
      Custom3: 'Anpassad 3',
      Custom4: 'Anpassad 4',
      Custom5: 'Anpassad 5',
      Custom6: 'Anpassad 6',
      Physical: 'Fysisk',
      CustomPhysical1: 'Anpassad fysisk 1',
      CustomPhysical2: 'Anpassad fysisk 2',
      CustomPhysical3: 'Anpassad fysisk 3',
      CustomPhysical4: 'Anpassad fysisk 4',
      CustomPhysical5: 'Anpassad fysisk 5',
      CustomPhysical6: 'Anpassad fysisk 6'
    },
    templateRemoveTitle: 'Ta bort mall',
    templateRemoveMsg: 'Vill du ta bort denna mall?',
    templateEditTitle: 'Spara mall',
    templateEditMsg: 'Det finns en osparad mall, vill du spara den innan du laddar en annan mall?',
    category: 'Kategori',
    playerRadar: 'Spelarradar',
    teamRadar: 'Lagradar',
    statsAlert: 'Lägg till minst en statistik för att spara',
    recommended: 'Rekommenderad',
    warning: 'Vissa positioner har nått maximalt antal tillåtna radar. Ta bort eller redigera en mall',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'Spansk',
      numeric: 'Numerisk'
    },
    showMediaMode: 'Visa medieläge',
    statTemplates: 'Statistikmallar',
    statTemplatesSubtitle: 'Skapa din egen statistikmall genom att välja bland flera metriker',
    ratingFormat: {
      ratingFormat: 'Betygsformat',
      numbers: 'Tal',
      letters: 'Bokstäverna A-F'
    }
  },
  playerDetail: {
    passport: 'Pass',
    secondPassport: 'Andra pass',
    age: 'Ålder',
    dateOfBirth: 'Födelsedatum',
    height: 'Längd',
    weight: 'Vikt',
    wage: 'Lön',
    history: 'Historik',
    positions: 'Positioner',
    injuries: 'Skador',
    transfers: 'Övergångar',
    nationalTeam: 'Landslag',
    addFavorite: 'Lägg till i favoriter',
    removeFavorite: 'Ta bort från favoriter',
    contractEnd: 'Kontraktsslut',
    yearsOld: ' år gammal',
    playerAvailability: 'Tillgänglighet',
    playerUsage: 'Spelade minuter',
    usage: 'Användning',
    addToCollection: 'Lägg till i samling',
    performance: 'Prestation',
    info: 'Info',
    career: 'Karriär',
    playerStyle: 'Spelstil',
    radar: 'Radar',
    finishingMap: 'Avslutskarta',
    threatMap: 'Hotkarta',
    keyPassMap: 'Nyckelpassningskarta',
    beeswarm: 'Ranking',
    allGames: 'Alla matcher',
    eventsMap: 'Händelsekarta',
    lbpMap: 'Linjebrytningspass',
    obpMap: 'På bolltryck',
    pupMap: 'Passerar under tryck',
    obrMap: 'Bollkvitton',
    fullName: 'Fullständigt namn',
    academy: 'Akademi',
    name: 'Namn',
    lastName: 'Efternamn',
    playerAvailabilityLong: '% av säsongen utan skador eller avstängningar',
    playerUsageLong: 'Spelade minuter',
    playerAvailability1: 'matcher utan skador eller avstängningar',
    playerAvailability2: 'matcher denna säsong',
    playerUsage1: 'spelade minuter',
    playerUsage2: 'lagets totala minuter',
    notMinutesThisSeason: 'Har inte spelat minuter denna säsong',
    seasonPlaceholder: 'Det finns ingen aktiv säsong',
    inactivePlayer: 'Inaktiv spelare',
    inactivePlayerMessage: 'Om du behöver mer information kan du be om en rapport',
    goRequest: 'Gå till förfrågan',
    warningMinutes: 'Varning: Mindre än 450 minuter spelade, analysen kan vara missvisande',
    scoreWarningMinutes: 'Spelare med minst 450 totalt spelade minuter',
    pdScoreWarningMinutes: 'Spelare med minst 450 totalt spelade minuter (minst 60 minuter per match)',
    warningSeasonGames: 'Säsongen har färre än 5 spelade matcher, därför är Min & Max \'Topp 5-ligor\'',
    warningStatsRemoved: 'Vissa statistik visas inte eftersom de inte finns för vald säsong',
    warningBeeswarm: 'Spelare visas inte eftersom det saknas data för denna stat i vald säsong',
    warningPlayersZeroValue: 'Visar inte {x} spelare med 0 ',
    onlyPlayersThatFit: 'Endast spelare som passar in i radarmallen',
    gamesPlayedNotEnough: 'Alternativ inaktiverade på grund av för få spelade matcher',
    gbe: 'GBE',
    analysis: 'Analys',
    documents: 'Dokument',
    rankDefensive: 'Defensiv',
    rankBallHandling: 'Bollbehandling',
    rankGoal: 'Målbidrag',
    rankXt: 'Hot',
    rankIndex: 'Index',
    visitHistory: 'Besökshistorik',
    placer: 'Plan',
    touchesMap: 'Touchkarta',
    heatMap: 'Värmekarta',
    ageProfile: 'Åldersprofil',
    strongFoot: 'Stark fot',
    player: 'Spelare',
    outOf: 'av',
    in: 'i',
    radius: 'Radie',
    blur: 'Oskärpa',
    careerTable: {
      nationalTeamCareer: 'Landslagskarriär',
      nationalTeamCompetitions: 'Landslagsturneringar'
    },
    physicalProgression: 'Fysisk utveckling',
    gpi: 'Global Player Index',
    warningGPI: 'Tillgänglig endast för spelare aktiva i ELO-ligor de senaste 30 dagarna',
    diffGPI: 'Förändring från senaste match',
    rankingInTheWorld: '#{0} i världen',
    rankingInTheLeague: '#{0} i {1}',
    max: 'Max',
    gpiChart: 'Graf baserad på Global Player Index från de senaste {0} matcherna',
    percentileRange: 'Percentiler {0} till {1}',
    months: 'månader',
    month: 'månad',
    contractExpOver4Years: 'Kontraktet löper ut kl',
    contractExpSoon: 'Kontraktet går snart ut',
    contractFinalYear: 'Sista året av kontraktet',
    freeAgent: 'Fri agent',
    gpiDescription: 'Global Player Index (GPI) är ett standardiserat spelarbetygssystem som utvärderar fotbollsspelare baserat på deras lagstyrka, motståndarstyrka, matchprestationer och tillgänglighet. Inspirerad av Elo-betygssystemet säkerställer det att spelarbetyg återspeglar faktiska konkurrensmiljöer snarare än godtyckliga baslinjer.',
    turnoversMap: 'Omsättnings- och återvinningskarta',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    },
    sucessfulTouch: 'Framgångsrika beröringar',
    unsuccessfulTouch: 'Misslyckade beröringar',
    showLegend: 'Visa legend'
  },
  finishingMap: {
    typesOfShot: 'Skotttyper',
    shotStrategy: 'Skottstrategi',
    strategiesCount: '{count} strategier',
    areas: 'Ytor',
    bodyPart: 'Kroppsdel',
    more: 'mer',
    selectAll: 'Välj alla',
    minutes: 'Minuter',
    circles: 'Cirklar',
    boxes: 'Värmekarta över straffområdet',
    lines: 'Linjer',
    games: 'Matcher',
    perShot: 'per skott',
    goal: 'Mål',
    missedShot: 'Missat skott',
    savedShot: 'Räddat skott',
    shotOnPost: 'Skott i stolpe/ribba',
    missedChance: 'Missad chans',
    openPlay: 'Öppet spel',
    regularPlay: 'Ordinarie spel',
    fastBreak: 'Kontring',
    individualPlay: 'Individuell aktion',
    setPiece: 'Fast situation',
    fromCorner: 'Från hörna',
    freeKick: 'Frispark',
    indirectFreeKick: 'Indirekt frispark',
    throwInSetPiece: 'Inkast (fast situation)',
    inBox: 'I straffområde',
    goalArea: 'Målområde',
    boxLeft: 'Straffområde vänster',
    boxCenter: 'Straffområde centralt',
    boxRight: 'Straffområde höger',
    outOfBox: 'Utanför straffområdet',
    outBoxDeepLeft: 'Utanför box djup vänster',
    outBoxDeepRight: 'Utanför box djup höger',
    outBoxLeft: 'Utanför box vänster',
    outBoxCentreLeft: 'Utanför box centralt vänster',
    outBoxCentre: 'Utanför box centralt',
    outBoxCentreRight: 'Utanför box centralt höger',
    outBoxRight: 'Utanför box höger',
    left35: '+35 Vänster',
    centreLeft35: '+35 Centralt vänster',
    centre35: '+35 Centralt',
    centreRight35: '+35 Centralt höger',
    right35: '+35 Höger',
    head: 'Huvud',
    rightFooted: 'Högerfotad',
    leftFooted: 'Vänsterfotad',
    otherBodyPart: 'Annan kroppsdel',
    chart: {
      shots: 'Skott',
      xGPerShot: 'xG per skott',
      exceptionTextPenaltyGoals: '* Straffskott = 0,765 xG',
      exceptionTextGKPenaltyGoals: '* Straffskott = 0,765 xGOT',
      exceptionTextOwnGoals: '* Självmål räknas ej',
      og: 'OG',
      penaltiesExcluded: 'Straffmål exkluderade',
      ownGoalsExcluded: 'Självmål exkluderade',
      sumOfxG: 'Summa av xG',
      exceptionShotsOutOfRange: '* Visar inte skott utanför räckvidd'
    },
    inGoal: 'I mål',
    outOfGoal: 'Utanför mål',
    highLeft: 'Högt vänster',
    highCenter: 'Högt centralt',
    highRight: 'Högt höger',
    lowLeft: 'Lågt vänster',
    lowCenter: 'Lågt centralt',
    lowRight: 'Lågt höger',
    outHighLeft: 'Utanför högt vänster',
    high: 'Utanför högt centralt',
    outHighRight: 'Utanför högt höger',
    closeHighLeft: 'Nära högt vänster',
    closeHigh: 'Nära högt centralt',
    closeHighRight: 'Nära högt höger',
    closeLeft: 'Nära lågt vänster',
    closeRight: 'Nära lågt höger',
    finishingTable: 'Avslutstabell',
    onGoal: 'På mål',
    distributionFilters: 'Distributionsfilter',
    penalty: 'Straff',
    penaltyShootout: 'Straffläggning',
    onlyPercentage: 'Visa procent',
    showAll: 'Visa alla',
    chanceMissed: 'Chansen missad'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Nyckelpassningar',
      xAPerPass: 'xA per pass',
      xAOpenPlay: 'xA öppet spel',
      xASetPiece: 'xA fast situation'
    }
  },
  beeswarm: {
    template: 'Mall',
    templates: {
      Goalkeeper: 'Målvakt',
      Defender: 'Försvarare',
      'Full-Back': 'Ytterback',
      FullBack: 'Ytterback',
      'Wing-Back': 'Vingback',
      WingBack: 'Vingback',
      Midfielder: 'Mittfältare',
      AttackingMidfielder: 'Offensiv mittfältare',
      Winger: 'Ytter',
      Forward: 'Anfallare',
      Physical: 'Fysisk'
    },
    compareWith: 'Jämför med',
    highlightPlayersOf: 'Markera spelare från',
    highlightPlayers: 'Markera spelare',
    per90: 'Data per 90 minuter',
    highlightTeams: 'Markera lag',
    filterTeams: 'Filtrera lag',
    warningZeros: 'Endast för icke inverterade stats'
  },
  collections: {
    newCollection: 'Ny samling',
    editCollection: 'Redigera samling',
    name: 'Namn',
    visibility: 'Synlighet',
    privacity: {
      publicTitle: 'Offentlig',
      publicDescription: 'Synlig för dig och din klubb',
      privateTitle: 'Privat',
      privateDescription: 'Endast synlig för dig',
      supervisedTitle: 'Övervakad',
      supervisedDescription: 'Endast synlig för dig och din handledare'
    },
    addSuccess: 'Tillagd utan problem',
    createAddSuccess: 'Skapad och tillagd utan problem',
    editSuccess: 'Uppdaterad utan problem',
    deleteSuccess: 'Borttagen utan problem',
    title: 'Samlingar av spelare',
    publics: 'Offentliga',
    privates: 'Privata',
    supervised: 'Övervakade',
    totalMarketValue: 'Totalt marknadsvärde',
    avgMarketValue: 'Genomsnittligt marknadsvärde',
    avgAge: 'Genomsnittsålder',
    searchBarPlaceholder: 'För att lägga till i samlingen, sök och välj spelare',
    deleteCollection: 'Ta bort samling',
    deleteCollectionMessage: 'Samlingen kommer tas bort, är du säker?',
    removePlayer: 'Ta bort spelare',
    removePlayerMessage: 'Spelaren tas bort från samlingen, är du säker?',
    subtitle: 'Organisera din scouting',
    notExitingTemplate: 'Det finns inga mallar ännu'
  },
  searchbar: {
    placeholder: 'Skriv för att söka (t.ex. `david arsenal`)',
    players: 'Spelare',
    teams: 'Lag',
    games: 'Matcher',
    leagues: 'Ligor',
    explore: 'Utforska fler resultat',
    placeholderNoResults: 'Inga resultat för mallen',
    teamPlaceholder: 'För att jämföra ett lag, sök och välj det'
  },
  favorites: {
    showOnly: 'Visa endast',
    selfFavorites: 'Mina favoriter',
    clubFavorites: 'Klubbfavoriter',
    contractExpiration: 'Kontraktets utgång',
    groupBy: 'Gruppera efter',
    noGrouped: 'Ingen',
    maxSelection: 'Kan endast välja',
    selectAtleastOne: 'Välj minst en',
    comparePlayers: 'Jämför spelare',
    selectedPlayers: 'spelare valda',
    subtitle: 'Hantera dina favoriter',
    generateXlsx: 'Generera XLSX',
    generating: 'Genererar...',
    subscribed: 'Prenumererar',
    subscribedTooltip: 'Prenumerera för att få e‑post när en match har spelats',
    deleteSelected: 'Ta bort markerade'
  },
  expiration: {
    summer: 'Sommar',
    winter: 'Vinter'
  },
  positions: {
    noposition: 'Ingen position',
    goalkeeper: 'Målvakt',
    goalkeepers: 'Målvakter',
    defender: 'Försvarare',
    defenders: 'Försvarare',
    defenses: 'Försvarare',
    fullback: 'Ytterback',
    fullbacks: 'Ytterbackar',
    midfielder: 'Mittfältare',
    midfielders: 'Mittfältare',
    winger: 'Ytter',
    wingers: 'Yttrar',
    forward: 'Anfallare',
    forwards: 'Anfallare',
    wingback: 'Vingback',
    wingbacks: 'Vingbacks'
  },
  dPos: {
    1: {
      name: 'Målvakt',
      alias: ''
    },
    2: {
      name: 'Höger ytterback',
      alias: 'RFB'
    },
    3: {
      name: 'Höger mittback',
      alias: 'RCB'
    },
    4: {
      name: 'Vänster mittback',
      alias: 'LCB'
    },
    5: {
      name: 'Vänster ytterback',
      alias: 'LFB'
    },
    6: {
      name: 'Defensiv mittfältare',
      alias: 'DM'
    },
    7: {
      name: 'Höger ytter',
      alias: 'RW'
    },
    8: {
      name: 'Central mittfältare',
      alias: 'CM'
    },
    9: {
      name: 'Anfallare',
      alias: 'ST'
    },
    10: {
      name: 'Offensiv mittfältare',
      alias: 'AM'
    },
    11: {
      name: 'Vänster ytter',
      alias: 'LW'
    }
  },
  charts: {
    seasonsCompareSelectLabel: 'Jämför med',
    lastSeasonSelectText: 'Förra säsongen',
    lastAndCurrentSeasonSelectText: 'Förra + nuvarande säsong',
    currentSeasonSelectText: 'Nuvarande säsong',
    lastNgamesSelectText: 'Ostatnie {x} meczów',
    npgVsXGTitle: 'Icke-straffmål vs xG',
    totalXGLabel: 'Total xG',
    xGLabel: 'xG',
    totalNPGLabel: 'Totalt antal icke-straffmål',
    xGAgainstvsNPGAgainstTitle: 'xG emot vs icke-straffmål emot',
    totalXGAgainstLabel: 'Total xG emot',
    xGAgainstLabel: 'xG emot',
    totalNPGAgainstLabel: 'Totalt antal icke-straffmål emot',
    xGvsxGAgainstTitle: 'xG vs xG emot',
    pointsVsXPointsTitle: 'Poäng vs förväntade poäng',
    xTTitle: 'Spelflöde',
    totalXPoints: 'Totala xPoints',
    totalPoints: 'Totala poäng',
    requestedReports: 'Begärda rapporter',
    playersScouted: 'Scoutade spelare',
    performanceVSAverageChart: 'Prestation vs genomsnitt',
    perPositions: 'Per position',
    perLeagues: 'Per ligor',
    perMonths: 'Per månader',
    perClients: 'Per kunder',
    ofPreposition: 'av',
    idJChartTitle: 'Spelinitiativ',
    idJChartLabel: 'Index GI',
    vJOChartTitle: 'Volym i offensivt spel',
    vJOChartLabel: 'Index OGV',
    preJOChartTitle: 'Precision i offensivt spel',
    preJOChartLabel: 'Index OGPre',
    proJOChartTitle: 'Progression i offensivt spel',
    proJOChartLabel: 'Index OGPro',
    chart: 'Diagram',
    table: 'Tabell',
    showLeaguesWithAtLeast: 'Visa ligor med minst',
    playersScoutedSuffix: 'spelare scoutade'
  },
  table: {
    history: {
      season: 'Säsong',
      team: 'Lag',
      position: 'Position',
      side: 'Sida',
      games: 'Matcher',
      minutes: 'Min',
      goals: 'NPG (G)',
      assists: 'A',
      yellowCards: 'YC',
      redCards: 'RC',
      gameLost: 'GM',
      gamesMissed: 'Missade matcher',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'Säsong',
      team: 'Lag',
      injury: 'Skada',
      dateFrom: 'Startdatum',
      dateTo: 'Slutdatum',
      daysLost: 'Dagar borta',
      gamesLost: 'Missade matcher',
      allInjuries: 'Alla skador'
    },
    transfers: {
      season: 'Säsong',
      date: 'Datum',
      teamFrom: 'Från lag',
      teamTo: 'Till lag',
      marketValue: 'Marknadsvärde',
      fee: 'Övergångssumma',
      type: 'Typ'
    },
    caps: {
      team: 'Lag',
      debut: 'Debut',
      games: 'Matcher',
      goals: 'Mål',
      coachDuringDebut: 'Tränare vid debut',
      debutAge: 'Debutålder'
    },
    roster: {
      country: 'Land',
      player: 'Spelare',
      positions: 'Positioner',
      minutes: 'Minuter',
      games: 'Matcher',
      goals: 'Mål',
      assists: 'Assist',
      cards: 'Kort',
      gamesExplicit: 'Spelade matcher'
    },
    league: {
      title: 'Ligaprofil',
      subtitle: 'Fördjupa dig i ligans ranking och statistik',
      team: 'Lag',
      games: 'GP',
      gamesExplicit: 'Spelade matcher',
      gamesRanking: 'GP',
      gamesRankingExplicit: 'Spelade matcher',
      points: 'Pts',
      pointsExplicit: 'Poäng',
      expectedPoints: 'xP',
      expectedPointsExplicit: 'Förväntade poäng',
      goalsScored: 'NPG',
      goalsScoredExplicit: 'Icke-straffmål',
      xG: 'xG',
      xGExplicit: 'Förväntade mål',
      goalsAgainst: 'NPGA',
      goalsAgainstExplicit: 'Icke-straffmål emot',
      xGAgainst: 'xGA',
      xGAgainstExplicit: 'Förväntade mål emot',
      xGAgainstDiff: 'xGA diff',
      xGAgainstDiffExplicit: 'Skillnad i förväntade mål emot',
      form: 'Form',
      sos: 'SoS',
      sosExplicit: 'Spelschemats svårighet',
      sosHfa: 'SoS HFA',
      sosHfaExplicit: 'Hemmaplansfördel',
      difficultyAboveAvg: 'Svårighet över genomsnittet',
      differentGames: '* Olika antal spelade matcher',
      berth: 'Plats'
    },
    usersOfClient: {
      userName: 'Namn',
      userRole: 'Användare',
      devRole: 'Utvecklare',
      adminRole: 'Admin',
      servicesRole: 'Tjänster',
      xgRole: 'XG',
      radarRole: 'Radar',
      beeswarmRole: 'Ranking',
      elevenRole: 'Startelvor',
      similarityRole: 'Likhet',
      gameAnalysisRole: 'Matchanalys',
      clientStatsRole: 'Kundstatistik',
      created: 'Skapad',
      type: 'Typ',
      logins: 'Inloggningar',
      lastLogin: 'Senaste inloggning',
      trialDate: 'Testdatum'
    },
    clientLeagues: {
      league: 'Liga',
      area: 'Område',
      tier: 'Nivå',
      seasons: 'Säsonger',
      currentMatchDay: 'Omgång',
      regular: 'Grundserie',
      youthLeague: 'Ungdom',
      clientActive: 'Aktiv',
      visibleLeagues: 'Synliga ligor',
      male: 'Herrligan',
      female: 'Damligan'
    },
    connections: {
      title: 'Vanliga kombinationer',
      playerFrom: 'Från spelare',
      playerTo: 'Till spelare',
      passes: 'Passningar',
      passesTooltip: 'Totalt antal lyckade passningar',
      passesFinalThird: 'PF â…“',
      passesFinalThirdTooltip: 'Passningar sista tredjedelen'
    },
    playerPassMapData: {
      title: 'Passningsstatistik',
      player: 'Spelare',
      passes: 'Passningar',
      passesPct: '% Passningar',
      xA: 'xA',
      xG: 'xG',
      xT: 'xThreat',
      playerTooltip: 'Spelarens namn',
      passesTooltip: 'Totalt antal passningar',
      passesPctTooltip: '% lyckade passningar',
      xATooltip: 'Förväntade assist',
      xGTooltip: 'Förväntade mål',
      xTTooltip: 'Förväntat hot'
    },
    playerAllGames: {
      gameDate: 'Datum',
      game: 'Match',
      team: 'Lag',
      positionsPlayed: 'Positioner',
      minsPlayed: 'Minuter',
      gameActions: 'Händelser',
      gameDateTooltip: 'Matchdatum',
      gameTooltip: 'Match',
      positionsPlayedTooltip: 'Spelade positioner',
      minsPlayedTooltip: 'Spelade minuter',
      gameActionsTooltip: 'Mål, assist, kort',
      from: 'Början',
      to: 'Slut',
      goalText: 'Mål vid',
      assistText: 'Assist vid',
      penaltyText: 'Straff vid',
      ownGoalText: 'Självmål vid',
      yellowCardText: 'Gult kort vid',
      secondYellowCardText: 'Andra gula kortet vid',
      redCardText: 'Rött kort vid',
      substitutionIN: 'In vid',
      substitutionOUT: 'Ut vid',
      suspendedText: 'Avstängning',
      Team: 'Utrustning'
    },
    gameFlow: {
      phase: 'Fas ',
      mins: 'Minuter',
      team: 'Lag',
      period: 'Period',
      possession: '%Bollinnehav',
      possessionTooltip: '% Bollinnehav',
      xT: 'xThreat',
      xTTooltip: 'Förväntat hot',
      pft: 'PF â…“',
      pftTooltip: 'Passningar sista tredjedelen',
      xG: 'xG',
      xGTooltip: 'Förväntade mål'
    }
  },
  game: {
    title: 'Matchprofil',
    subtitle: 'Fördjupa dig i matchens egenskaper och statistik',
    header: {
      gameDetails: 'Detaljer',
      gameStats: 'Statistik',
      gameFinishingMap: 'Avslutskarta',
      gameKeyPassMap: 'Nyckelpassningskarta',
      gamePassMap: 'Passningskarta',
      gameThreat: 'Matchhot',
      gameFlow: 'Spelflöde',
      gameAnalysis: 'Matchanalys',
      gamePhysicalStats: 'Fysiska stats',
      possessions: 'Bollinnehav',
      bench: 'Bänk',
      video: 'Videohöjdpunkter',
      preGame: 'Före match',
      postGame: 'Efter match',
      areaCoverage: 'Områdestäckning'
    },
    passMap: {
      typeOfPlay: 'Speltyp:',
      passes: 'Passningar:',
      team: 'Lag',
      minutes: 'Minuter:',
      select: 'Välj',
      all: 'Alla',
      attacking: 'Anfall',
      defending: 'Försvar',
      forwards: 'Framåt',
      backwards: 'Bakåt',
      sideways: 'Sidled',
      longBall: 'Lång boll',
      successfullPasses: 'Lyckade passningar',
      homeTeam: 'Hemma',
      awayTeam: 'Borta',
      passingMatrix: 'Passningsmatris',
      passer: 'Passare',
      receiver: 'Mottagare',
      passOutcome: 'Passningsresultat',
      passDirection: 'Passningsriktning',
      half: 'Halva',
      offensive: 'Offensiv',
      defensive: 'Defensiv',
      passingConnections: 'Passningskopplingar',
      pitchView: 'Plan',
      passSingular: 'Passning',
      passPlural: 'Passningar',
      playerLocation: 'Spelarens plats',
      passLegend: 'Genomsnittlig beröringsposition',
      minuteRange: 'Minutintervall'
    },
    stats: {
      summary: 'Sammanfattning',
      attacking: 'Anfall',
      defending: 'Försvar',
      contribution: 'Bidrag',
      possession: 'Bollinnehav',
      expectedPoints: 'Förväntade poäng',
      directness: 'Direkthet',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG fast situation',
      xA: 'xA',
      xASetPiece: 'xA fast situation',
      xT: 'xT',
      xTSetPiece: 'xT fast situation',
      touchesInOppBox: 'Toucher i motståndarens straffområde',
      passesFinalThird: 'Passningar sista tredjedelen',
      interceptions: 'Interceptioner',
      recoveries: 'Återerövringar',
      recoveriesOppHalf: 'Återerövringar på offensiv planhalva',
      tackles: 'Tacklingar',
      tacklesWasDribbled: 'Vunna defensiva 1-mot-1-dueller',
      fouls: 'Fouls',
      yellowCards: 'Gula kort',
      redCards: 'Röda kort',
      passes: 'Passningar',
      passing: 'Passnings %',
      crosses: 'Inlägg',
      crossing: 'Inlägg %',
      shots: 'Skott',
      shotsOnTarget: 'Skott på mål',
      ppdaExplicit: 'Tillåtna passningar per defensiv aktion',
      xgExplicit: 'Förväntade mål',
      xp: 'xP',
      ExpectedPassing: 'xP %',
      seasonAvg: 'Tävlingssnitt',
      winChanceTooltip: 'Vinstsannolikhet baserat på genererad och insläppt xG',
      drawChance: 'Oavgjort',
      xgAgainst: 'xG emot',
      averagePossession: 'Bollinnehav',
      averageShots: 'Skott',
      averagexG: 'XG',
      fieldTilt: 'Field Tilt',
      fieldTiltExplicit: 'Field Tilt',
      recoveriesRate: 'Återvinningsgrad',
      turnoversRate: 'Omsättningshastighet'
    },
    detail: {
      halfTime: 'Halvtid',
      overTime: 'Förlängning',
      showStats: 'Visa statistik',
      hideStats: 'Dölj statistik',
      bench: 'Bänk',
      showShotOptions: 'Visa skottalternativ',
      hideShotOptions: 'Dölj skottalternativ',
      showPassOptions: 'Visa passningsalternativ',
      hidePassOptions: 'Dölj passningsalternativ',
      endGame: 'Full tid',
      penalties: 'Straffar'
    },
    timeline: {
      events: {
        goal: 'Mål',
        goal_ownGoal: 'Självmål',
        goal_penalty: 'Straffmål',
        card: 'Kort',
        card_yellowCard: 'Gult kort',
        card_secondYellowCard: 'Andra gula kortet',
        card_redCard: 'Rött kort',
        formationChange: 'Formationsändring',
        substitution: 'Byte',
        saveShot: 'Räddat skott',
        saveShot_penalty: 'Räddad straff',
        missedShot: 'Missat skott',
        missedShot_penalty: 'Missad straff',
        shotOnPost: 'Skott i stolpe/ribba',
        shotOnPost_penalty: 'Skott i stolpe vid straff',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: 'Mål av ',
      redCardTo: 'Rött kort till ',
      missedPenalty: 'Missad straff'
    },
    gameThreat: {
      typeOfPlay: 'Typ av aktion',
      regularPlay: 'Ordinarie spel',
      setPiece: 'Fast situation',
      setPiecePlay: 'Fast situation',
      throwInSetPiecePlay: 'Inkastsituation',
      throwInPlay: 'Inkastsituation',
      gkThrow: 'Målvaktsutkast',
      gkKick: 'Målvaktsspark',
      kickOff: 'Avspark',
      actionEnding: 'Aktionens avslut',
      pass: 'Passning',
      shot: 'Skott',
      foul: 'Foul',
      other: 'Övrigt',
      threat: 'Hot',
      legendSumOfXT: 'Summa xT',
      legendPass: 'Passning',
      legendShot: 'Skott',
      legendCarryAndAction: 'Drivning och aktion',
      legendCarryAndPass: 'Drivning och passning',
      legendOnlyShowing: 'Visar endast individuella aktioner med xT > ',
      legendOnlyShowingPart1: 'Visar endast individuella',
      legendOnlyShowingPart2: 'aktioner med xT > ',
      legendOnlyShowingSetPiece: 'Visar endast fasta situationer med xT > ',
      legendOnlyShowingOpenPlay: 'Visar endast öppet spel-aktioner med xT > ',
      legendPlays: 'Aktioner',
      legendPerPlay: 'per aktion',
      legendCarry: 'Drivning',
      penaltyPlay: 'Straff',
      freeKickTakenPlay: 'Frisparkssekvens',
      cornerTakenPlay: 'Hörnsekvens',
      fromCornerPlay: 'Hörnsekvens',
      keeperThrowPlay: 'Utkastsekvens',
      fastBreakPlay: 'Kontringssekvens',
      indirectPlay: 'Indirekt spel',
      minutes: 'Minuter',
      games: 'Matcher',
      xT: 'xT',
      xTPer90: 'xT per 90\''
    },
    gameAnalysis: {
      next: 'Nästa',
      previous: 'Föregående',
      phaseLabel: 'Fas',
      phasesLabel: 'Faser',
      dot: '. ',
      comma: ', ',
      from: 'Från',
      to: 'Till',
      and: ' och ',
      steps: {
        finishingMapFullGame: 'Avslutskarta',
        keyPassMapFullGame: 'Nyckelpassningskarta',
        gameFlow: 'Spelflöde',
        finishingMapPerPhases: 'Avslutskarta per fas',
        keyPassMapPerPhases: 'Nyckelpassningskarta per fas',
        passMapPerPhases: 'Passningskarta per fas'
      },
      step1: {
        table: {
          draw: 'Oavgjort',
          win: 'Vinst',
          lose: 'Förlust',
          possession: 'Bollinnehav',
          xP: 'Förväntade poäng',
          directness: 'Direkthet',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG Open Play',
          xGSetPiece: 'xG Set Piece',
          xA: 'xA',
          xAOpenPlay: 'xA Open Play'
        },
        text: {
          firstParagraph: {
            1: 'Kartan till höger visar de förväntade målen som genererats av home_team_name och away_team_name. De ifyllda cirklarna är skotten som resulterade i mål. Cirklarnas storlek beror på xG‑värdet för varje skott. '
          },
          lastParagraph: {
            1: 'Sannolikheten för utfall och antalet förväntade poäng beräknas genom skottsimulering (100 000 simuleringar av skotten genomförs och sannolikheten för olika resultat och poäng utvärderas prediktivt). '
          },
          targetHighTeamXG: {
            1: 'target_team_name, liksom rival_team_name, lyckades skapa en hög volym förväntade mål'
          },
          targetHighTeamOpenPlayXG: {
            1: 'I den här matchen kom de flesta av target_team_name chanser från öppet spel'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'I den här matchen uppstod de flesta av target_team_name chanser i öppet spel (till skillnad från rival_team_name)'
          },
          targetHighTeamSetPieceXG: {
            1: 'I den här matchen kom de flesta av target_team_name chanser från fasta situationer'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'I den här matchen uppstod de flesta av target_team_name chanser på fasta situationer (till skillnad från rival_team_name)'
          },
          targetHighTeamCornerXG: {
            1: 'I den här matchen kom de flesta av target_team_name chanser från hörnor'
          },
          targetLowTeamGoalConversion: {
            1: ' men måleffektiviteten var låg'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name skapade en hög volym förväntade mål både i öppet spel och på fasta situationer'
          },
          targetHighTeamGoalConversion: {
            1: ' och hade även hög måleffektivitet. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', utan att kunna göra mål på någon av chanserna'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' men skapade hot för att kunna göra fler mål'
          },
          targetHighTeamXGvsGameRival: {
            1: 'I den här matchen skapade target_team_name större hot än rival_team_name'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' och hade kunnat göra fler mål. '
          },
          targetHighTeamXGZeroGoals: {
            1: ' men lyckades inte göra mål på de skapade chanserna. '
          },
          targetHighTeamXGGoalDiff: {
            1: ' vilket motsvarar en vinstchans på team_winning_chance enligt vår eftermatch‑simulering. '
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' De flesta av target_team_name chanser kom från öppet spel. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' De flesta av target_team_name chanser uppstod på fasta situationer. '
          },
          startTargetHighTeamCornerXG: {
            1: ' De flesta chanserna kom från hörnor. '
          },
          targetSimilarTeamXG: {
            1: 'I den här matchen skapade båda lagen liknande mängd hot mot motståndaren i termer av xG, '
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'men target_team_name var bättre på att avsluta chanserna. '
          },
          targetLowTeamXGGoalDiff: {
            1: 'Oavsett resultat skapade target_team_name inte mycket hot mot motståndaren i termer av förväntade mål. '
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name skapade inte tillräckligt hot i förväntade mål för att vinna matchen'
          },
          rivalHighTeamXG: {
            1: 'och lät rival_team_name skapa alltför mycket hot. '
          },
          rivalHighTeamXGGoalDiff: {
            1: ' Med den skapelsen skulle target_team_name bara vinna team_winning_chance av gångerna enligt vår eftermatch‑simulering. '
          },
          targetHighTeamGoalConversion2: {
            1: ' med hög måleffektivitet'
          },
          winningChance: {
            1: 'Givet antalet skott och xG för båda lagen borde target_team_name ha vunnit denna match team_winning_chance av gångerna. '
          },
          highPlayerXGManyShots: {
            1: 'Värt att notera är att player_name genererade xg_value xG på shots_value skott'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' och behövde xg_value xG för att göra ett mål. '
          },
          highPlayerXGOneGoal: {
            1: ' för att göra målet. '
          },
          highPlayerXGAnyGoal: {
            1: ', även om han inte lyckades göra mål. '
          },
          highPlayerXGNotManyShots: {
            1: 'Det är värt att nämna att player_name genererade xg_value xG på få skott'
          },
          highManyPlayerXG: {
            1: 'Intressant nog genererade player_name och player_name2 xg_value respektive xg_value2 <b>xG</b>. '
          },
          highTeamXGPerShot: {
            1: 'Urvalet av skott från target_team_name var mycket bra sett till sannolikheten att bli mål, med ett genomsnittligt xG per skott på xg_per_shot_value. '
          },
          highTeamXGPerShotVSGameRival: {
            1: 'target_team_name hade ett betydligt bättre skotturval än rival_team_name med ett genomsnitt på xg_per_shot_value xG per skott. '
          },
          xGTimesNotAfter70xG: {
            1: 'Trots hög genererad xG hade target_team_name problem att skapa hot i slutet av matchen. '
          },
          xGTimesBefore25xG: {
            1: 'target_team_name skapade mycket hot särskilt i början av båda halvlekarna. '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name skapade mycket hot särskilt i slutet av båda halvlekarna. '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name skapade mest hot i början av första halvlek. '
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name skapade mest hot i slutet av första halvlek. '
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name skapade mest hot i början av andra halvlek. '
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name skapade mest hot i slutet av andra halvlek. '
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name började matchen stabilt med chanser som genererade xg_value förväntade mål. '
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name avslutade första halvlek med chanser som genererade xg_value förväntade mål. '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name kom ut efter halvtid med chanser som genererade xg_value förväntade mål. '
          },
          xGTimesAfter70xG: {
            1: 'target_team_name avslutade andra halvlek med chanser som genererade xg_value förväntade mål. '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name skapade mycket hot i slutet av andra halvlek. '
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name skapade mycket hot i början av andra halvlek. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name skapade mycket hot i slutet av första halvlek. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name skapade mycket hot i början av första halvlek. '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name skapade mest hot i första halvlek medan rival_team_name gjorde detsamma i andra. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name skapade mest hot i andra halvlek medan rival_team_name gjorde detsamma i första. '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: 'Detta är en match där mestadels av hotet i förväntade mål skapades under första halvlek. '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'Detta är en match där mestadels av hotet i förväntade mål skapades under andra halvlek. '
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name skapade mest hot i första halvlek. '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name skapade mest hot under andra halvlek. '
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name släppte till mest hot i förväntade mål i första halvlek. '
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name släppte till mest hot i förväntade mål under andra halvlek. '
          },
          highInBoxXG: {
            1: 'Skottkartan visar att det mesta av hotet kom från skott inne i straffområdet. '
          },
          highOutOfBoxXG: {
            1: 'Skottkartan visar att target_team_name i den här matchen skapade mycket hot från utsidan av straffområdet. '
          },
          highInBoxXGRival: {
            1: 'Vi vill påpeka att det mesta av hotet som target_team_name släppte till kom från skott inne i straffområdet. '
          },
          highInBoxXGRival2: {
            1: ' Det är också intressant att framhålla att det mesta av hotet target_team_name släppte till kom från skott inne i straffområdet. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name gjorde det bra med att undvika hot inne i straffområdet. '
          },
          highTeamChancesHighPPDARival: {
            1: 'Bristen på press från target_team_name, som tillät ppda_value passningar per defensiv aktion, var en nyckel till att rival_team_name kunde skapa många chanser. '
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name tillät endast ppda_value passningar per defensiv aktion, vilket var en av nycklarna till segern. '
          },
          lowPPDA: {
            1: 'target_team_name gjorde ett utmärkt jobb med att störa rival_team_name spel och tillät i snitt endast ppda_value passningar per defensiv aktion. '
          },
          highPossession: {
            1: 'target_team_name kontrollerade bollen med possession_value i bollinnehav'
          },
          highPPDARival: {
            1: ' samt en flytande bollfördelning'
          },
          chancesCreated: {
            1: ', vilket gav många chanser i öppet spel (chances_value). '
          },
          chancesCreatedRival: {
            1: ', även om rival_team_name också skapade många chanser i öppet spel (chances_value). '
          },
          xGPerShotRival: {
            1: ', även om rival_team_name skapade farligare chanser med xg_per_shot_value xG per skott. '
          },
          winGame: {
            1: ' vilket var en av nycklarna till segern. '
          },
          notEnoughWinGame: {
            1: ' vilket inte räckte för att vinna matchen. '
          },
          goalsFromErrorsFirstGoal: {
            1: 'Det första målet kom efter ett misstag av player_error_name som utnyttjades av player_name'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'Det första och enda målet kom efter ett misstag av player_error_name som utnyttjades av player_name'
          },
          lastPhaseOfGame: {
            1: ' i slutskedet av matchen. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: 'Det avgörande målet kom efter ett misstag av player_error_name som ledde till player_name mål. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'Kvitteringsmålet kom efter ett misstag av player_error_name som ledde till player_name mål. '
          },
          goalsFromErrorsGoalToTie: {
            1: 'Ett misstag av player_error_name gav target_team_name en chans att kvittera. '
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name tog ledningen efter att ha utnyttjat ett misstag av player_error_name'
          },
          xGChance: {
            1: ' med en chans på xg_value xG. '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'rival_team_name avgjorde matchen efter ett misstag av player_error_name som ledde till player_name mål. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'Ett misstag av player_error_name gav rival_team_name en chans att kvittera. '
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name tog ledningen efter att ha utnyttjat ett misstag av player_error_name'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name gjorde mål på den enda stora chansen som skapades under matchen, nämligen player_name mål på xG‑kartan med xG xg_value. '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name gjorde mål på alla stora chanser som skapades under matchen'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name hade target_team_name enda stora chans att göra mål med xG xg_value. '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name lyckades inte göra mål på någon av de chances_value chanserna över 40% sannolikhet att bli mål. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name hade en stor chans på xg_value xG att ta ledningen. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name hade chances_value chanser med xG över 40% att ta ledningen. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name hade chances_value chanser med hög xG att ta ledningen. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name hade en chans på xg_value xG att ta ledningen som tog i ramen. '
          },
          beforeEndOfGame: {
            1: 'Innan matchen var slut, '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name hade en chans på xg_value xG att vinna matchen. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name hade chances_value chanser med xG över 40% att vinna matchen. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name hade chances_value chanser med hög xG att vinna matchen. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name hade en stor chans på xg_value xG att ta ledningen. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name hade chances_value chanser med xG över 40% att ta ledningen. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name hade chances_value chanser med hög xG att ta ledningen. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name hade en chans på xg_value xG att ta ledningen som tog i ramen. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name hade en chans på xg_value xG att kvittera men utan framgång. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name hade chances_value chanser att kvittera med mål­sannolikhet över 30%. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name hade en chans på xg_value xG att kvittera som slutade i ramen. '
          }
        }
      },
      step2: {
        table: {
          draw: 'Oavgjort',
          win: 'Vinst',
          possession: 'Bollinnehav',
          xP: 'Förväntade poäng',
          directness: 'Direkthet',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA Open Play',
          xASetPiece: 'xA Set Piece',
          chancesCreated: 'Skapade chanser',
          shotsOnTarget: 'Skott på mål'
        },
        text: {
          firstParagraph: {
            1: 'Denna bild visar förväntade assist för <b style=\'color:home_color\'>home_team_name</b> och <b>away_team_name</b>.'
          },
          xAPerKeyPass: {
            1: ' xA per nyckelpassning. '
          },
          keyPassesGeneratedFrom: {
            1: ', särskilt nyckelpassningar genererade från '
          },
          highTeamXAvsXG: {
            1: 'Som xA‑kartan visar kommer det mesta av target_team_name hot från kombinationsspel snarare än individuella aktioner'
          },
          openPlay: {
            1: 'öppet spel'
          },
          setPiece: {
            1: 'fasta situationer'
          },
          cornerKicks: {
            1: 'hörnor'
          },
          combinationPlays: {
            1: 'kombinationsspel'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'I denna match skapade target_team_name hot både via kombinationsspel'
          },
          individualActions: {
            1: ' och individuella aktioner. '
          },
          dangerFromIndividualActions: {
            1: 'I denna match kom det mesta av target_team_name hot från individuella aktioner.'
          },
          highTeamXAvsXGRival: {
            1: ' Chanserna som target_team_name släppte till under matchen kom från kombinationsspel, vilket xA‑kartan visar.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name var starka i nyckelpassningar från '
          },
          manyPlayerKeyPasses: {
            1: 'Värt att notera är att player_name skapade xa_value xA i key_passes nyckelpassningar'
          },
          playerAssists: {
            1: ' och behövde xa_per_assist xA per assist.'
          },
          giveAssist: {
            1: ' för att leverera assisten.'
          },
          noAssists: {
            1: ', även om ingen av hans passningar blev assist.'
          },
          highXANotManyShots: {
            1: 'Intressant nog skapade player_name xa_value xA på ett fåtal passningar'
          },
          manyPlayersHighXA: {
            1: 'Intressant nog genererade player_name och player_name2 xa_value respektive xa_value2 xA.'
          },
          xATimes: {
            1: 'target_team_name skapade mest hot i första halvlek medan rival_team_name gjorde detsamma i '
          },
          firstHalf: {
            1: ' första halvlek. '
          },
          secondHalf: {
            1: ' andra halvlek. '
          },
          left: {
            1: 'vänster sida '
          },
          center: {
            1: 'centralt '
          },
          right: {
            1: 'höger sida '
          },
          xAFirstHalfFirstHalfRival: {
            1: 'Detta är en match där det mesta av hotet i förväntade mål skapades under '
          },
          xAFirstHalf: {
            1: 'target_team_name skapade mest hot under '
          },
          xATimesXARival: {
            1: 'target_team_name släppte till för mycket hot i förväntade mål under '
          },
          xASides: {
            1: ' Det mesta av target_team_name hot producerades från side_name (xa_value <b>xA</b>)'
          },
          xASidesRival: {
            1: 'medan rival_team_name genererade merparten från side_name (xa_value <b>xA</b>)'
          },
          dangerCreationRival: {
            1: 'rival_team_name skapade framför allt hot från side_name (xa_value <b>xA</b>). '
          },
          speciallyEffective: {
            1: 'target_team_name var särskilt effektivt på '
          },
          xAPerChanceCreated: {
            1: ' med ett snitt på xa_value'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name var särskilt effektivt på '
          }
        }
      },
      step3: {
        text: {
          chance: ' chans',
          chances: ' chanser',
          goal: ' mål',
          goals: ' mål',
          home: 'hemma',
          away: 'borta',
          last: 'sista',
          first: 'första',
          goalScorer: 'målskytt',
          goalScorers: 'målskyttar',
          lastPhase: 'Sista fasen av matchen, ',
          phase: {
            1: 'I denna phase_position fas av spelet, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b> genererade mer förväntat hot (<b style=\'color:more_color\'>more_xt_team_value xT</b>) än <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)'
          },
          sameTeamMoreMinutes: {
            1: 'och gjorde det under fler minuter i denna period (<b style=\'color:more_color\'>more_time_xt_minutes min</b> mot <b style=\'color:less_color\'>less_time_xt_minutes min</b> för motståndaren)'
          },
          rivalTeamMoreMinutes: {
            1: 'dock var det motståndaren som skapade hot under längre tid (<b style=\'color:more_color\'>more_time_xt_minutes min</b> mot <b style=\'color:less_color\'>less_time_xt_minutes min</b>) i denna period'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> var laget som skapade mest hot (<b style=\'color:max_color\'>max_xt_team_value xT</b>) vid <b style=\'color:max_color\'>max_xt_team_minute\'</b>'
          },
          maxXTValueRival: {
            1: ', medan <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> skapade sitt största hot (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) vid <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b>'
          },
          bothTeamsScoreButDraw: {
            1: 'Båda lagen har lyckats överlista motståndarmålvakten <b>number_of_goals_each_team</b> var. Hemmalaget genom <b style=\'color:#3366FF\'>home_player_name_goals</b> och bortalaget genom <b>away_player_name_goals</b>'
          },
          oneTeamTakesTheLead: {
            1: 'När det gäller mål överträffade <b style=\'color:replace_color\'>goal_scored_team_name</b> motståndaren med <b style=\'color:replace_color\'>difference_number_of_goals</b> mål, där <b style=\'color:replace_color\'>home_player_name_goals</b> var goal_scorer_word'
          }
        }
      },
      step4: {
        table: {
          team: 'Lag',
          period: 'Period',
          possession: 'Bollinneh.',
          ppda: 'PPDA',
          xGOpenPlay: 'xG OP',
          tooltip: {
            team: 'Lag',
            period: 'Period',
            possession: 'Bollinnehav',
            ppda: 'Tillåtna passningar per defensiv aktion',
            xGOpenPlay: 'xG öppet spel'
          }
        },
        text: {
          clearly: 'tydligt',
          very: 'väldigt ',
          haveGotText1: 'fick bara',
          haveGotText2: 'borde ha fått mer än',
          gaveUpPoss: 'gav upp bollinnehavet',
          lostPoss: 'tappade bollinnehavet',
          too: 'för ',
          possession: {
            1: 'Under denna fas av spelet kontrollerade <b style=\'color:team_color\'>team_name</b> clearly_text bollinnehavet'
          },
          equalPossession: {
            1: 'I denna fas dominerade inget lag; bollinnehavet var ganska jämnt, men <b style=\'color:team_color\'>team_name</b> var något bättre med <b style=\'color:team_color\'>possession_value%</b> i bollinnehav'
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color\'>target_team_name</b> med svag press tillät <b style=\'color:rival_team_color\'>rival_team_name</b> att slå <b style=\'color:target_team_color\'>ppda_value passningar per defensiv aktion</b>'
          },
          lowPossessionLowPPDA: {
            1: ', men <b style=\'color:target_team_color\'>target_team_name</b> pressade bra när rival_team_name hade bollen, med <b>PPDA</b> <b>ppda_value</b>'
          },
          highPossessionLowPPDA: {
            1: ' och kunde spela tack vare very_textlow pressintensitet från rival_team_name'
          },
          highPossessionHighPPDA: {
            1: ' trots att rival_team_name hade very_texthigh pressintensitet'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> utnyttjade ett högt bollinnehav och slog <b>pft_value</b> <b>Passningar i sista tredjedelen</b>. '
          },
          highPossessionMidLowPFT: {
            1: 'Trots högt bollinnehav have_got_text <b style=\'color:target_team_color\'>target_team_name</b> <b>pft_value</b> <b>Passningar i sista tredjedelen</b>. '
          },
          lowPossessionHighPFT: {
            1: 'Även om <b style=\'color:target_team_color\'>target_team_name</b> possession_text i denna fas kunde laget slå <b>pft_value</b> <b>Passningar i sista tredjedelen</b>. '
          },
          midPossessionHighPFT: {
            1: 'Ett ganska jämnt bollinnehav hindrade inte <b style=\'color:target_team_color\'>target_team_name</b> från att slå <b>pft_value</b> <b>Passningar i sista tredjedelen</b>. '
          },
          highPFTHighTouchesIOB: {
            1: ' Förutom att kontrollera spelet i sista tredjedelen hade <b style=\'color:target_team_color\'>target_team_name</b> också stor närvaro i motståndarens straffområde. '
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> kontrollerade bollen i sista tredjedelen men fick inte in många bollar i motståndarens straffområde'
          },
          highPFTMidTouchesIOB: {
            1: 'Givet antalet <b>Passningar i sista tredjedelen</b> borde <b style=\'color:target_team_color\'>target_team_name</b> ha skapat mer hot i motståndarens straffområde'
          },
          lowPFTHighTouchesIOB: {
            1: 'Även om <b style=\'color:target_team_color\'>target_team_name</b> inte slog många passningar i sista tredjedelen nådde laget ofta motståndarens straffområde. '
          },
          midPFTHighTouchesIOB: {
            1: 'Givet antalet passningar i sista tredjedelen nådde <b style=\'color:target_team_color\'>target_team_name</b> ofta motståndarens straffområde. '
          },
          maxDirectness: {
            1: 'Det är värt att påpeka att detta var fasen då <b style=\'color:max_dir_color\'>target_team_name</b> spelade mer vertikalt med <b>Direkthet</b> <b>directness_value</b>. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> skapade mer xG än i andra faser av spelet '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> lyckades generera en hög volym förväntade mål'
          },
          highXG: {
            1: 'skapade en god volym förväntade mål'
          },
          highXGLowPossession: {
            1: ' trots att laget inte hade kontroll över bollen'
          },
          highXGLowShots: {
            1: ' men endast på ett fåtal skott, med <b>xG per skott</b> <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ' även om xG per skott var too_textlow. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> lyckades inte skapa något hot mot motståndaren'
          },
          lowXGMinXG: {
            1: 'När det gäller skapande av förväntade mål var detta en svag fas för <b style=\'color:target_team_color\'>target_team_name</b>'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> genererade en mycket låg volym förväntade mål'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> kunde inte generera en bra volym förväntade mål'
          },
          lowXGHighPossession: {
            1: ' trots att laget hade kontroll över bollen. '
          },
          lowXGHighShots: {
            1: ' trots många avslut'
          },
          lowXGHighPFT: {
            1: ' trots <b>pft_value</b> <b>Passningar i sista tredjedelen</b>. '
          },
          midXGQuintileMinXG: {
            1: 'Även om xG‑skapandet inte var dåligt var detta den svagaste fasen för <b style=\'color:target_team_color\'>target_team_name</b> i det avseendet'
          },
          midXGQuintileMaxXG: {
            1: 'Detta var fasen då <b style=\'color:target_team_color\'>target_team_name</b> genererade högst <b>xG (xg_value)</b>'
          }
        }
      },
      step5: {
        table: {
          team: 'Lag',
          period: 'Period',
          possession: 'Bollinneh.',
          directness: 'Dir.',
          passesFinalThird: 'PF â…“',
          tooltip: {
            team: 'Lag',
            period: 'Period',
            possession: 'Bollinnehav',
            directness: 'Direkthet',
            passesFinalThird: 'Passningar i sista tredjedelen'
          }
        },
        text: {
          last: 'sista',
          goal: 'mål',
          goals: 'mål',
          chance: 'chans',
          chances: 'chanser',
          first: 'första',
          homeTeam: 'hemmalag',
          awayTeam: 'bortalag',
          home: 'hemma',
          away: 'borta',
          clearly: 'tydligt',
          slightly: 'något',
          firstOrLastPhase: {
            1: 'I denna phase_position fas av spelet, ',
            2: 'Under phase_position delen av matchen, '
          },
          phase: {
            1: 'Under denna period av matchen, '
          },
          bothZeroGoalsScored: {
            1: 'utan att något lag lyckades ändra resultatet.'
          },
          equalGoalsScored: {
            1: 'och gjorde <b>number_goals</b>'
          },
          differentGoalsScored: {
            1: 'och gjorde <b>number_goals</b>'
          },
          equalPossesion: {
            1: 'båda lagen hade bollen exakt <b>poss_value%</b> av tiden'
          },
          morePossesion: {
            1: '<b style=\'color:more_color\'>more_poss_team_name</b> hade bollen längre (<b style=\'color:more_color\'>more_poss_team_value%</b> av tiden) än motståndaren <b style=\'color:less_color\'>less_poss_team_name</b> (<b style=\'color:less_color\'>less_poss_team_value%</b> av tiden)'
          },
          equalDirectness: {
            1: 'båda lagen spelade med samma direkthet (<b>directness_value</b> var)'
          },
          moreDirectnessSameTeam: {
            1: 'de var också mer vertikala än motståndaren och spelade med direkthet <b style=\'color:more_color\'>more_dir_team_value</b> mot <b style=\'color:less_color\'>less_dir_team_value</b>'
          },
          moreDirectnessDifferentTeam: {
            1: 'dock var det home_away‑laget som spelade mer vertikalt (<b style=\'color:more_color\'>more_dir_team_value</b>) än motståndaren (<b style=\'color:less_color\'>less_dir_team_value</b>)'
          },
          equalChancesCreated: {
            1: 'Båda lagen skapade lika många chanser, exakt <b>chances_created_value</b> chance_text.'
          },
          moreChancesCreated: {
            1: '<b style=\'color:less_color\'>less_cc_team_name</b> skapade bara <b style=\'color:less_color\'>less_cc_team_value less_chance_text</b> och blev adverb_text utpresterade av motståndaren (<b style=\'color:more_color\'>more_cc_team_value more_chance_text skapade</b>). '
          },
          equalXA: {
            1: 'Lagen hade lika stora möjligheter, vilket återspeglas i <b>xa_value förväntade assist</b>, '
          },
          moreXA: {
            1: 'home_away‑laget genererade <b>diff_xa_team_value förväntade assist</b> (<b style=\'color:more_color\'>more_xa_team_value</b> mot <b style=\'color:less_color\'>less_xa_team_value</b>) mer än motståndaren, '
          },
          xAOpenPlay: {
            1: 'och skapade, respektive, <b style=\'color:more_color\'>more_xa_op_value</b> och <b style=\'color:less_color\'>less_xa_op_value xA öppet spel</b>.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' var och en ',
          respectively: ', respektive',
          with: ' (med <b style=\'color:replace_color\'>other_player_name</b>)',
          playerWas: 'spelaren var',
          playerWere: 'spelarna var',
          firstPhase: {
            1: 'I den första delen av matchen var den viktigaste player_text ',
            2: 'När det gäller första delen av matchen stack följande ut: '
          },
          otherPhase: {
            1: 'Mellan <b style=\'color:replace_color\'>min_from\'</b> och <b style=\'color:replace_color\'>min_to\'</b> bör nämnas '
          },
          lastPhase: {
            1: 'I slutdelen av matchen kan nämnas ',
            2: 'När det gäller sista fasen av matchen, '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b> då han slog flest lyckade passningar i laget, exakt <b style=\'color:replace_color\'>successfull_passes_value passningar</b> '
          },
          playerMaxTotalPasses: {
            1: 'vilket blir än mer värdefullt när siffrorna visar att han också var'
          },
          playerMaxTotalPasses2: {
            1: 'with_text spelaren med flest försökte passningar (<b style=\'color:replace_color\'>total_passes_value passningar</b>). '
          },
          playerNotMaxTotalPasses: {
            1: 'även om han inte försökte flest passningar (<b style=\'color:replace_color\'>player_name</b> med <b style=\'color:replace_color\'>total_passes_value passningar</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: 'och försökte under denna period <b style=\'color:replace_color\'>total_passes_value passningar</b> var. '
          },
          playerMaxPctPasses: {
            1: 'När det gäller <b style=\'color:replace_color\'>% lyckade passningar</b> har <b style=\'color:replace_color\'>player_name</b> höga <b style=\'color:replace_color\'>max_pct_passes_value%</b>. ',
            2: 'Med avseende på passningsprecision är det värt att nämna <b style=\'color:replace_color\'>player_name</b> med <b style=\'color:replace_color\'>max_pct_passes_value%</b> lyckade passningar</b>. '
          },
          playerSumTotalXG: {
            1: 'Under detta tidsfönster genererade laget totalt <b style=\'color:replace_color\'>sum_xg_value xG</b>, ',
            2: 'Under denna period skapade <b style=\'color:replace_color\'>team_name</b> en <b style=\'color:replace_color\'>xG</b> på <b style=\'color:replace_color\'>sum_xg_value</b>, '
          },
          ZeroSumXG: {
            1: 'Trots totalt <b style=\'color:replace_color\'>all_team_total_passes</b> passningar av laget var det förgäves då man inte skapade en enda chans. ',
            2: 'De <b style=\'color:replace_color\'>all_team_total_passes</b> passningar som gjordes i denna period skapade inte en enda målchans. '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: 'där <b style=\'color:replace_color\'>player_xg_name</b> med <b style=\'color:replace_color\'>xg_value xG</b> och <b style=\'color:replace_color\'>player_xa_name</b> med <b style=\'color:replace_color\'>xa_value xA</b> var de farligaste i chansskapande. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: 'där <b style=\'color:replace_color\'>player_name</b> med <b style=\'color:replace_color\'>xg_value xG</b> och <b style=\'color:replace_color\'>xa_value xA</b> låg bakom de flesta av lagets chanser. '
          },
          playersMaxXGMaxXA: {
            1: 'tack vare bland annat <b style=\'color:replace_color\'>players_name</b> som skapade <b style=\'color:replace_color\'>xa_value xA</b> var genom sina nyckelpassningar. '
          },
          playerMaxXGZeroXA: {
            1: 'där <b style=\'color:replace_color\'>player_xg_name</b> med <b style=\'color:replace_color\'>xg_value xG</b> bar huvudansvaret för chanserna och fick skapa dem själv då han inte fick några nyckelpassningar. '
          },
          playersMaxXGZeroXA: {
            1: 'där <b style=\'color:replace_color\'>player_xg_name</b> med <b style=\'color:replace_color\'>xg_value xG</b> hade chanserna och fick skapa dem själv då inga nyckelpassningar mottogs. '
          },
          oneMaxConnections: {
            1: 'Paret som slog flest passningar mellan sig i detta skede var <b style=\'color:replace_color\'>couple_name</b>, totalt <b style=\'color:replace_color\'>connections_value passningar</b>. ',
            2: 'Duon <b style=\'color:replace_color\'>couple_name</b> bytte boll <b style=\'color:replace_color\'>connections_value</b> gånger. ',
            3: 'Duon <b style=\'color:replace_color\'>couple_name</b> var de som passade mest i detta skede, till och med i <b style=\'color:replace_color\'>connections_value</b> sekvenser. '
          },
          twoMaxConnections: {
            1: 'De två paren <b style=\'color:replace_color\'>couple_name</b> och <b style=\'color:replace_color\'>couple_name2</b> var de mest frekventa kopplingarna i denna period och passade varandra <b style=\'color:replace_color\'>connections_value</b> gånger. '
          },
          moreThanTwoMaxConnections: {
            1: 'Flera par spelare, såsom <b style=\'color:replace_color\'>couple_name</b>, slog <b style=\'color:replace_color\'>connections_value passningar</b> till varandra. '
          },
          oneMinConnections: {
            1: 'Å andra sidan var det <b style=\'color:replace_color\'>couple_name</b> som passade varandra minst, endast <b style=\'color:replace_color\'>connections_value passningar</b>. ',
            2: 'I andra änden var duon <b style=\'color:replace_color\'>couple_name</b> bara sammanlänkade <b style=\'color:replace_color\'>connections_value</b> gånger. '
          },
          twoMinConnections: {
            1: 'Å andra sidan bytte <b style=\'color:replace_color\'>couple_name</b> och <b style=\'color:replace_color\'>couple_name2</b> knappt passningar mellan sig (<b style=\'color:replace_color\'>connections_value passningar</b>). '
          },
          moreThanTwoMinConnections: {
            1: 'Flera kombinationer kopplade inte ihop tillräckligt, såsom duon <b style=\'color:replace_color\'>couple_name</b>, som med <b style=\'color:replace_color\'>connections_value passningar</b> tillhör de minst vanliga kombinationerna. '
          }
        }
      },
      step7: {
        ballPossession: 'Bollinnehav',
        gamePossessionDist: 'Fördelning av bollinnehav'
      }
    },
    gamePossessionMap: {
      of: 'av',
      to: 'till',
      and: 'och',
      endsWith: 'Slutar med',
      time: 'Tid',
      touches: 'Toucher',
      passes: 'Passningar',
      threat: 'Hot',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Minuter',
      duration: 'Varaktighet',
      endsGoal: 'Slutar med mål',
      endsInBox: 'Slutar i straffområde',
      withShot: 'Med skott',
      withCross: 'Med inlägg',
      possession: 'Bollinnehav',
      events: 'Händelser',
      filters: 'Filter',
      filtersWarning: 'Hot gäller endast bollinnehav utan skott',
      sumWarning: 'Filtret gäller summan av xG för alla skott i sekvensen, därför kan den vara större än 1',
      show: 'Visa',
      sequenceNumbers: 'Sekvensnummer',
      jerseyNumbers: 'Tröjnummer',
      pass: 'Passning',
      carryAndPass: 'Drivning & Passning',
      carryAndAction: 'Drivning & Aktion',
      carryAndShot: 'Drivning & Skott',
      shotFailed: 'Misslyckat skott',
      goal: 'Mål',
      savedShot: 'Räddat skott',
      missedShot: 'Missat skott',
      shotOnPost: 'Skott i stolpe/ribba',
      headerGoal: 'Nickmål',
      headerFailed: 'Misslyckad nick',
      failed: 'misslyckad',
      with: 'med'
    },
    report: {
      title: 'Matchrapport',
      maps: 'Kartor',
      xGRace: 'xG‑race',
      lineups: 'Startelvor',
      button: 'Generera en fullständig PDF‑rapport av matchen',
      mobileButton: 'PDF‑rapport',
      most: 'Mest',
      topXPlayers: 'Topp {x} spelare',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: 'Spelets fysiska datarapport'
    },
    avgScoreTooltip: 'Genomsnittlig poäng per minut',
    status: {
      scheduled: 'Schemalagt',
      postponed: 'Uppskjuten',
      cancelled: 'Avbruten',
      inPlay: 'Bo',
      finished: 'Färdig',
      awarded: 'Tilldelas',
      dataAvailable: 'Data kommer att finnas tillgängliga under de närmaste timmarna'
    },
    preGameAnalysis: {
      showExpectations: 'Visa förväntningar',
      hideExpectations: 'Dölj förväntningar',
      goalsPeriods: 'Målperioder',
      synergyIndex: 'Synergiindex',
      synergyIndexSubtitle: 'Övergripande styrka hos passer-finisher-anslutningen'
    }
  },
  general: {
    1: 'En',
    2: 'Två',
    3: 'Tre',
    4: 'Fyra',
    5: 'Fem',
    8: 'Vänster',
    9: 'Båda',
    10: 'Höger',
    create: 'Skapa',
    save: 'Spara',
    cancel: 'Avbryt',
    delete: 'Ta bort',
    edit: 'Redigera',
    reset: 'Återställa',
    go: 'Gå',
    formErrors: {
      required: 'Fältet är obligatoriskt',
      passwordMatch: 'Lösenord matchar inte',
      minLength: 'Minsta längd',
      maxLength: 'Högsta längd',
      emailValid: 'E‑post måste vara giltig',
      youthAge: 'Åldern måste vara mellan 10 och 23',
      seasonYear: 'Året måste vara mellan 2016 och 2050',
      integer: 'Decimaltal är inte tillåtna'
    },
    confirmationTitle: 'Är du säker?',
    confirmationMessage: 'Vänligen bekräfta om du vill utföra åtgärden',
    yes: 'Ja',
    no: 'Nej',
    search: 'Sök',
    clearFilters: 'Rensa filter',
    minimum: 'Minsta',
    maximum: 'Maximalt',
    minimumPercent: '(%)Min procentsats',
    period: 'Period',
    exclude: 'Exkludera',
    team: 'Lag',
    clear: 'Rensa',
    all: 'Alla',
    ground1: 'Alla',
    ground2: 'Hemma',
    ground3: 'Borta',
    filter: 'Filter',
    noData: 'Inga resultat hittades',
    noDataGivenFilters: 'Inga resultat med valda filter',
    similarityMinutesWarning: 'Ingen data på grund av färre än 450 spelade minuter',
    templateOnlyEditable: 'Mall kan endast redigeras av ',
    close: 'Stäng',
    load: 'Ladda',
    filters: 'Filter',
    players: 'spelare',
    teams: 'lag',
    compare: 'Jämför',
    seeMore: 'Visa mer',
    seeLess: 'Visa mindre',
    request: 'Förfrågan',
    notes: 'Anteckningar',
    closeSession: 'Logga ut',
    settings: 'Inställningar',
    player: 'Spelare',
    state: 'Status',
    updated: 'Uppdaterad',
    file: 'Fil',
    uploadFile: 'Ladda upp fil',
    reports: 'Rapporter',
    download: 'Ladda ner',
    new: 'Ny',
    comparison: 'Jämförelse',
    scout: 'Scout',
    favorites: 'Favoriter',
    moreOptions: 'Fler alternativ',
    lessOptions: 'Färre alternativ',
    today: 'Idag',
    home: 'Hemma',
    away: 'Borta',
    until: 'till',
    firstHalf: 'Första halvlek',
    secondHalf: 'Andra halvlek',
    firstPeriodOT: 'Första förl.',
    secondPeriodOT: 'Andra förl.',
    postponed: 'Uppskjuten',
    stats: 'Statistik',
    yesterday: 'Igår',
    last: 'Senaste',
    startDate: 'Startdatum',
    active: 'Aktiv',
    playerLimit: 'Spelargräns',
    type: 'Typ',
    successMessage: 'Åtgärden lyckades',
    failMessage: 'Åtgärden misslyckades',
    by: 'Av',
    checkYourInbox: 'Kontrollera din inkorg',
    faq: 'Ordlista',
    globalSearch: 'Global sökning',
    gamesLost: 'Förlorade matcher',
    outOf: 'av',
    avgSeason: 'Säsongssnitt',
    leftDays: 'återstående dagar',
    notifyError: 'Rapportera fel',
    notify: 'Notifiera',
    comments: 'Kommentarer',
    searches: 'Sökningar',
    now: 'Nu',
    twoHoursAgo: 'För två timmar sedan',
    incomings: 'Ankomster',
    departures: 'Avgångar',
    transferLoans: 'Lån',
    transfers: 'Övergångar',
    movements: 'Rörelser',
    incomes: 'Intäkter',
    expenditures: 'Utgifter',
    action: 'Åtgärd',
    target: 'Mål',
    uses: 'Användning',
    users: 'Användare',
    since: 'sedan',
    mediaMode: 'Medieläge',
    white: 'Vit',
    enabled: 'Aktiverad',
    disabled: 'Inaktiverad',
    left: 'Vänster',
    right: 'Höger',
    both: 'Båda',
    'left-both': 'Vänster båda',
    'right-both': 'Höger båda',
    'left foot': 'Vänster',
    'right foot': 'Höger',
    files: 'Filer',
    confirm: 'Bekräfta',
    currentStep: 'Aktuellt steg',
    phases: 'Faser',
    entries: 'Poster',
    none: 'Ingen',
    times: 'gånger',
    darkMode: 'Mörkt läge',
    client: 'Kund',
    visits: 'Besök',
    lastVisit: 'Senaste besök',
    strong: 'Stark',
    medium: 'Medel',
    weak: 'Svag',
    goal: 'Mål',
    list: 'Lista',
    map: 'Karta',
    copiedToClipboard: 'Kopierat till urklipp',
    division: 'Division',
    many: 'Många',
    few: 'Få',
    median: 'Median',
    topRight: 'Övre höger',
    topLeft: 'Övre vänster',
    bottomRight: 'Nedre höger',
    bottomLeft: 'Nedre vänster',
    library: 'Bibliotek',
    mediaLibrary: 'Mediebibliotek',
    for: 'För',
    stat: 'Statistik',
    position: 'Position',
    order: 'Ordning',
    add: 'Lägg till',
    visualization: 'Visualisering',
    basic: 'Grundläggande',
    selectAll: 'Välj alla',
    unselectAll: 'Avmarkera alla',
    distribution: 'Fördelning',
    end: 'Slut',
    accuracy: 'Noggrannhet',
    opponent: 'Motståndare',
    ownTeam: 'Eget lag',
    center: 'Centralt',
    line: 'Linje',
    live: 'Live',
    unavailable: 'otillgänglig',
    calendar: 'Kalender',
    activeLeague: 'Pågående liga',
    similarity: 'Likhet',
    emptyForSelectAll: 'Tomt = välj alla',
    size: 'Storlek',
    selectPlayersRestriction: 'Välj mellan 1 och {x} spelare',
    group: 'Grupp',
    alerts: 'Aviseringar',
    shortcuts: 'Genvägar',
    share: 'Dela',
    dataAvailable: 'Data kommer snart att finnas tillgänglig',
    someStatsAvailableSoon: 'Viss statistik blir snart tillgänglig',
    monthGamesWarning: 'Matcher för vald månad blir snart tillgängliga',
    metrics: 'Metriker',
    competition: 'Tävling',
    code: 'Kod',
    alias: 'Alias',
    never: 'Aldrig',
    unlimited: 'Obegränsad',
    user: 'Användare',
    warning: 'Varning',
    requests: 'Förfrågningar',
    contactSales: 'Kontakta sälj',
    comingSoon: 'Kommer snart!',
    firstPost: '1:a stolpe',
    secondPost: '2:a stolpe',
    dZone: 'D-zon',
    penaltySpot: 'Straffpunkt',
    secondPlay: '2:a spel',
    otherZone: 'Annan zon',
    baseline: 'Kortlinje',
    youth: 'Ungdom',
    male: 'Herr',
    direct: 'Direkt',
    indirect: 'Indirekt',
    processing: 'Bearbetar',
    addNew: 'Lägg till ny',
    createdBy: 'Skapad av',
    downloading: 'Hämtar',
    displayType: 'Visningstyp',
    alreadyExists: 'finns redan',
    aggregation: 'Aggregering',
    unavailableLeagues: 'Du har inte tillgång till någon av ligorna där spelaren har spelat',
    meters: 'Meter',
    quantity: 'Kvantitet',
    allTime: 'Alla tider',
    games: 'Matcher',
    unit: 'Enhet',
    categories: 'Kategorier',
    maintenanceWarning: 'Underhåll pågår',
    maintenanceMessage: 'Vi gör några uppdateringar. Ändringar du gör nu sparas inte. Tack för ditt tålamod!',
    seeAll: 'Se allt',
    from: 'Från',
    to: 'till',
    showFilters: 'Visa filter',
    hideFilters: 'Dölj filter',
    horizontal: 'Horisontell',
    vertical: 'Vertikal',
    drop: 'Släppa',
    orientation: 'Orientering',
    goalProbability: 'Målsannolikhet',
    assistProbability: 'Assist sannolikhet',
    attackingDirection: 'Anfallsriktning',
    currentTeam: 'Nuvarande lag',
    expectations: 'Förväntningar',
    sideBySide: 'Sida vid sida',
    teamValue: 'Lagets värde',
    fieldLayout: 'Fältlayout',
    searchPlaceholder: 'Type {x} letters at least to search',
    crests: 'Vapen',
    pcts: 'PCT'
  },
  playerScout: {
    dlabDatabase: 'Driblab‑databas',
    league: 'Liga',
    top5: 'Top 5',
    topCountries: 'Länder',
    tier: 'Nivå',
    division1: 'Första divisionen',
    division2: 'Andra divisionen',
    division3: 'Tredje divisionen',
    division4: 'Fjärde divisionen',
    division5: 'Femte divisionen',
    division6: 'Sjätte divisionen',
    summary: 'Sammanfattning',
    offensive: 'Off',
    defensive: 'Def',
    gk: 'MV',
    all: 'Alla',
    physical: 'Fys',
    arrigo: 'Arrigo',
    yearTooltip: 'Endast ett år tillåtet',
    expectedThreat: 'xThreat',
    expectedThreatTooltip: 'Hot tillagt till alla bollinnehav',
    expectedThreatOP: 'xThreat OP',
    expectedThreatOPTooltip: 'Hot tillagt till bollinnehav i öppet spel',
    expectedThreatInTeam: 'xThreat i lag %',
    expectedThreatInTeamTooltip: 'Andel av hot som spelaren tillför laget',
    ballProgression: 'Bollprogression',
    ballProgressionTooltip: 'Progressioner på +10 meter',
    deepProgression: 'Djupa progressioner',
    deepProgressionTooltip: 'Bollprogressioner till sista femtedelen',
    ballRetention: '% Bollbehållning',
    ballRetentionTooltip: 'Andel aktioner där bollen behölls framgångsrikt',
    ballRetentionOppHalf: '% Bollbehållning OH',
    ballRetentionOppHalfExplicit: 'Andel av tiden med boll som inte slutar i bolltapp på offensiv planhalva',
    finishing: 'Avslut',
    finishingTooltip: 'Andel skott som slutar med mål',
    scoringContribution: 'Målbidrag',
    scoringContributionTooltip: 'Assist + mål',
    xgPerShot: 'xG per skott',
    xgPerGoal: 'xG per mål',
    headerPerCross: 'Nick per inlägg',
    completedCrosses: 'Lyckade inlägg',
    crossingPct: '% Inlägg',
    crossingEfficiency: 'Inläggseffektivitet',
    crossingEfficiencyTooltip: 'Inläggseffektivitet (mäter kvalitet och kvantitet)',
    longBalls: 'Långa bollar',
    longPassing: '% Lång boll',
    dribblingPct: '% Dribbling',
    throughBalls: 'Djupledsbollar',
    oppBoxTouches: 'Toucher i motståndarens straffområde',
    oppBoxTouchesTooltip: 'Toucher i motståndarens straffområde',
    openPlayKeyPasses: 'OP nyckelpassningar',
    openPlayKeyPassesTooltip: 'Passningar i öppet spel som slutar i skott',
    xGBuildup: 'xG Buildup',
    xGBuildupTooltip: 'xG för sekvenser som slutar i skott där spelaren var involverad (exkl. xG för skott och nyckelpass)',
    Assists: 'Assist',
    passPercentage: '% Passningar',
    passPerLongBall: 'Pass per LB',
    passPerLongBallExplicit: 'Pass per lång boll',
    nonPenaltyGoals: 'Icke-straffmål',
    xG: 'xG',
    xGExplicit: 'Förväntade mål',
    shots: 'Skott',
    xGShot: 'xG per skott',
    xGChain: 'xG‑kedja',
    xGChainTooltip: 'xG för sekvenser som slutar i skott där spelaren var involverad',
    chancesCreated: 'Passningar som följs av skott',
    chances: 'Chanser',
    dribbles: 'Dribblingar',
    dribblesSuccessfull: 'Lyckade dribblingar',
    touches: 'Toucher i motståndarens straffområde',
    xA: 'xA',
    xAExplicit: 'Förväntade assist',
    xAOpenPlay: 'xA OP',
    xAOpenPlayExplicit: 'Förväntade assist öppet spel',
    passesOpponentBox: 'Passningar i motståndarens straffområde',
    passesOB: 'Passningar i OB',
    passesFinalThirdTooltip: 'Passningar sista tredjedelen',
    passesSuccessful: 'Lyckade passningar',
    passesSuccessfulTooltip: 'Lyckade passningar',
    ballProgressionPassing: 'BP via passningar',
    ballProgressionPassingTooltip: 'Bollprogression via passningar',
    ballProgressionDribbling: 'BP via drivningar',
    ballProgressionDribblingTooltip: 'Bollprogression via drivningar',
    passesTotal: 'Passningar',
    passesTotalTooltip: 'Totalt antal försökta passningar',
    shortPassesSuccessful: 'Lyckade KP',
    shortPassesSuccessfulTooltip: 'Antal kortpassningar som gick fram',
    shortPassesTotal: 'Totala KP',
    shortPassesTotalTooltip: 'Antal försökta kortpassningar',
    tackles: 'Tacklingar *',
    adjustedTackles: 'Tacklingar justerade för bollinnehav',
    interceptions: 'Interceptioner *',
    adjustedInterceptions: 'Interceptioner justerade för bollinnehav',
    aerials: 'Luftdueller',
    aerialsPercent: '% Luftdueller',
    aerialEfficiency: 'Luftduell‑eff.',
    aerialEfficiencyTooltip: 'Luftduell‑effektivitet (mäter kvalitet och kvantitet)',
    twd: 'TwD',
    tacklesWasDribbled: 'Tacklingar blev dribblad',
    fouls: 'Fouls',
    indPressure: 'Individuell press',
    pressure: 'Press',
    dispossessed: 'Av med bollen',
    recoveries: 'Återerövringar',
    primary: 'Primär',
    secondary: 'Sekundär',
    position: 'Position',
    nationality: 'Nationalitet',
    height: 'Längd (cm)',
    minHeight: 'Min. längd',
    maxHeight: 'Max. längd',
    age: 'Ålder',
    minAge: 'Min. ålder',
    maxAge: 'Max. ålder',
    games: 'Matcher',
    minGames: 'Min. matcher',
    maxGames: 'Max. matcher',
    minutes: 'Minuter',
    minMinutes: 'Min. minuter',
    maxMinutes: 'Max. minuter',
    minPercentMinutes: 'Min. procent minuter',
    dates: 'Datum',
    marketValue: '(€) Marknadsvärde',
    teams: 'Lag',
    contractEnd: 'Kontraktsslut',
    minValue: 'Min. värde',
    maxValue: 'Max. värde',
    excludeTeams: 'Exkludera lag',
    recentSearches: 'Senaste sökningar',
    saveSearch: 'Spara sökning',
    loadSearch: 'Ladda sökning',
    loadCollection: 'Ladda samling',
    collection: 'Samling',
    search: 'Sök',
    searchesList: 'Söklistor',
    mySearches: 'Mina sökningar',
    mySearchesDescription: 'De du sparade tidigare',
    recentSearchesDescription: 'Senaste 10 sökningarna du gjort',
    searchToLoad: 'Sökning att ladda',
    recentSearch: 'Senaste sökning',
    saveSearchSuccess: 'Sökningen sparades',
    removeSearch: 'Ta bort sökning',
    removeSearchMessage: 'Är du säker på att du vill ta bort sökningen?',
    updateSearch: 'Uppdatera sökning',
    updateSearchMessage: 'Är du säker på att du vill uppdatera sökningen?',
    deleteSearchSuccess: 'Sökningen har tagits bort',
    playersFound: 'spelare hittade',
    addToCollection: 'Lägg till i samling',
    npg: 'NPG',
    goals: 'Mål',
    value: 'Värde',
    nationalTeams: 'Landslag',
    gbeScore: 'GBE',
    dlIndex: 'Poäng',
    minGbe: 'Min. GBE',
    goalsConceded: 'Insläppta mål',
    npgConceded: 'NPG insläppta',
    npgConcededTooltip: 'Icke‑straffmål insläppta',
    xGOTConceded: 'xG On Target insläppta',
    xGOTConcededTooltip: 'xG för skott på mål som mottagits',
    goalsPrevented: 'Förhindrade mål',
    xGFacedPerShotOnTarget: 'xGOT per skott',
    xGFacedPerShotOnTargetTooltip: 'xG on Target per insläppt skott',
    xGSavedPerxGFacedOnTarget: 'xG räddning',
    xGSavedPerxGFacedOnTargetTooltip: 'Räddningsprocent med hänsyn till xG',
    savesPct: '% Räddningar',
    savesOutOfBoxPct: '% Räddningar utanför box',
    savesInBoxPct: '% Räddningar i box',
    xGFacedPerGoal: 'xG per insläppt mål',
    xGFacedPerGoalTooltip: 'xG som krävs för att göra mål',
    catchingPct: '% Fångade',
    catchingTooltip: 'Andel räddningar som fångades',
    passingOwnHalfPct: '% Passningar egen planhalva',
    passingOwnHalfPctTooltip: 'Andel lyckade passningar på egen planhalva',
    passingOppHalfPct: '% Passningar offens. planhalva',
    passingOppHalfPctTooltip: 'Andel lyckade passningar på offensiv planhalva',
    passingContribution: '% Passningsbidrag',
    passingContributionTooltip: 'Hotbidrag genom passningar – över genomsnitt',
    shotsPerGoal: 'Skott per mål',
    passesFinalThird: 'Passningar sista â…“',
    passingFinalThird: '% Passningar sista â…“',
    claimAccuracy: 'Greppsäkerhet',
    claimAccuracyTooltip: 'Fångade bollar över genomsnitt',
    highTurnovers: 'Höga bollvinster',
    highTurnoversTooltip: 'Bollvinster närmare än 40 meter från mål',
    shotEndingHighTurnovers: 'Skott efter HB',
    shotEndingHighTurnoversTooltip: 'Skott efter höga bollvinster',
    goalEndingHighTurnovers: 'Mål efter HB',
    goalEndingHighTurnoversTooltip: 'Mål efter höga bollvinster',
    avgCarriesProgress: 'Genomsnittlig progression',
    avgCarriesProgressTooltip: 'Genomsnittlig vertikal förflyttning med boll (meter)',
    carriesChance: 'Chans avslut',
    carriesChanceTooltip: 'Drivningar följda av nyckelpassning',
    carriesAssist: 'Assist avslut',
    carriesAssistTooltip: 'Drivningar följda av assist',
    carriesShot: 'Skott avslut',
    carriesShotTooltip: 'Drivningar följda av skott',
    carriesGoal: 'Mål avslut',
    carriesGoalTooltip: 'Drivningar följda av mål',
    shotEndingSequence: 'Skott avslut',
    shotEndingSequenceTooltip: 'Antal sekvenser som slutar i skott där spelaren var involverad',
    goalEndingSequence: 'Mål avslut',
    goalEndingSequenceTooltip: 'Antal sekvenser som slutar i mål där spelaren var involverad',
    gbeScoreTooltip: 'FA:s Governing Body Endorsement',
    goalsPreventedTooltip: 'Icke‑straffmål räddade av målvakten (xG emot - NPG insläppta)',
    freePlayers: 'Kontraktslösa spelare',
    index: 'Index',
    playerName: 'Namn',
    teamName: 'Lag',
    secondPos: 'Andra pos.',
    side: 'Sida',
    onlyOnLoan: 'Endast på lån',
    dob: 'Född',
    countryName: 'Land',
    secondCountryName: 'Andra land',
    seasonYear: 'Säsong',
    assists: 'Assist',
    placeholder: 'Du kan börja lägga till ligafilter',
    placeholder2: 'Klicka på sökknappen för att visa resultat',
    passesPct: '% Passningar',
    passingPct: '% Passningar',
    oppBoxPasses: 'Passningar i motst. straffområde',
    adjustedClearances: 'Rensningar justerade',
    aerialsPct: '% Luftdueller',
    leagueCountryCode: 'Ligans landskod',
    shooting: '% Skott på mål',
    xtPassing: 'xT Passningar',
    xtPassingTooltip: 'Hot tillagt via passningar',
    xtDribbling: 'xT Drivningar',
    xtDribblingTooltip: 'Hot tillagt via drivningar',
    foot: 'Stark fot',
    aggressiveActions: 'Aggressiva aktioner',
    aggressiveActionsTooltip: 'Antal tacklingar inom två sekunder efter bolltapp',
    tacklesAttempted: 'Totalt antal försökta tacklingar',
    highDefensiveActionPct: '% HD‑aktioner',
    highDefensiveActionPctTooltip: 'Andel defensiva aktioner inom 40 meter från motståndarens mål',
    individualPressureOppHalf: 'Press offens. planhalva',
    individualPressureOppHalfTooltip: 'Mäter antalet lyckade försök (återerövringar) vid press på offensiv planhalva',
    xGBuildUp5Pass: 'xG Buildup 5p',
    xGBuildUp5PassTooltip: 'Mängd xG spelaren deltagit i, endast senaste 5 passningar (exkl. skott och passningar som leder till skott)',
    chancesCreatedOpenPlay: 'Skapade chanser OP',
    chancesCreatedOpenPlayTooltip: 'Antal passningar som leder till skott i öppet spel',
    fmf: {
      Defender: 'Försvarare',
      aerial: 'Luftspel',
      goodDefender: 'Bra försvarare',
      goodPresence: 'Bra närvaro',
      playmaking: 'Spelfördelning',
      Fullback: 'Ytterback',
      defensiveness: 'Defensiv',
      offensiveness: 'Offensiv',
      fast: 'Snabb',
      Forward: 'Anfallare',
      goalChances: 'Målchanser',
      goodDecissions: 'Bra beslut',
      individualTechnique: 'Individuell teknik',
      Goalkeeper: 'Målvakt',
      footWork: 'Spel med fötterna',
      leadership: 'Ledarskap',
      Midfielder: 'Defensiv mittfältare',
      balance: 'Balans',
      ballRetention: '% Bollbehållning',
      offensivePasses: 'Offensiva passningar',
      recoveries: 'Återerövringar',
      shotToGoal: 'Skott mot mål',
      'Attacking-Midfielder': 'Offensiv mittfältare',
      defensiveGame: 'Defensivt spel',
      offensiveGame: 'Offensivt spel',
      Winger: 'Ytter',
      crossing: 'Inlägg',
      deepProgressions: 'Djupa progressioner',
      defendingEffort: 'Defensiv arbetsinsats',
      facing: 'Vänd mot mål'
    },
    yellowCards: 'Gula kort',
    redCards: 'Röda kort',
    alert: 'Avisering',
    yearOfBirth: 'Födelseår',
    minYearOfBirth: 'Min. födelseår',
    maxYearOfBirth: 'Max. födelseår',
    women: 'Dam',
    continental: 'Kontinental',
    countryCup: 'Nationell cup',
    statsName: 'Statsnamn',
    abbreviation: 'Förkortning',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: 'Visar bara förra grundserien spelad',
    gamesWith60PlusMinsTooltip: 'Minsta antal spel spelade med mer än 60 minuter',
    starts: 'Startar',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: 'Jämför upp till 5 spelare',
    requestReport: 'Begär rapport',
    searchBarPlaceholder: 'Sök spelare eller lag',
    allStats: 'All statistik',
    placeholder: 'Du kan börja lägga till spelare'
  },
  reports: {
    detailedInsights: 'Få fördjupade insikter',
    features: 'Rapportens funktioner',
    performance: 'Prestation',
    evolution: 'Utveckling',
    compareWithMyTeam: 'Jämför med mitt lag',
    similarPlayers: 'Liknande spelare',
    potentialTeams: 'Potentiella lag',
    requestSuccess: 'Förfrågan skickad',
    requestAt: 'Begärd',
    reportConversation: 'Rapportkonversation',
    writeYourMessage: 'Skriv ditt meddelande...',
    you: 'Du'
  },
  state: {
    requested: 'Begärd',
    inProgress: 'Pågår',
    delivered: 'Levererad'
  },
  langs: {
    es: 'Spanska',
    en: 'Engelska',
    fr: 'Franska',
    de: 'Tyska',
    it: 'Italienska',
    pt: 'Portugisiska',
    tr: 'Turkiska',
    jp: 'Japanska',
    cn: 'Kinesiska',
    sa: 'Arabiska',
    nl: 'Nederländska',
    pl: 'Polska',
    sv: 'Svenska',
    cs: 'Tjeckiska',
    ko: 'Koreanska',
    hu: 'Ungerska',
    ru: 'Russiska'
  },
  langsArea: {
    europe: 'Europa',
    asia: 'Asien',
    arabic: 'Arabiska'
  },
  inbox: {
    subtitle: 'Håll dig uppdaterad',
    new_injury_alert: 'Ny skadeavisering',
    new_contract_alert: 'Ny kontraktavisering',
    new_team_alert: 'Ny värvningsavisering',
    new_marketValue_alert: 'Ny marknadsvärdesavisering',
    new_game_alert: 'Ny match spelad‑avisering',
    receive_mail: 'Ta emot e‑post',
    receive_mail_subtitle: 'Få daglig e‑post med spelare som matchar filter',
    receive_notifications: 'Aviseringar',
    receive_notifications_subtitle: 'Få aviseringar i appen med spelare som matchar filter',
    changedTo: 'Ändrad till',
    alerts: 'Aviseringar',
    includedIn: 'Inkluderad i',
    noContract: 'Inget kontrakt',
    newMessages: 'Nya meddelanden',
    reply: {
      reply: 'Svara',
      replyTitle: 'Ge feedback till kunden:',
      replyPlaceholder: 'Användaren får svaret tillsammans med statusuppdateringen'
    }
  },
  gameAnalysis: {
    subtitle: 'Få insikter från de senaste matcherna',
    subtitle2: 'Visar matcher de kommande sju dagarna',
    subtitle3: 'Få insikter från senaste matcherna och utforska kommande',
    seeDetail: 'Visa detaljer'
  },
  statsNaming: {
    Possession: 'Bollinnehav',
    TimePossession: 'Bollinnehavstid',
    PassesPerShots: 'Passningar per skott',
    PPDA: 'PPDA',
    ExpectedPoints: 'Förväntade poäng',
    Points: 'Poäng',
    Directness: 'Direkthet',
    PassesPerLongBall: 'Passningar per lång boll',
    CrossingPerXG: 'Inlägg per xG',
    PenaltySavedPenaltyFaced: 'Räddade straffar/Mottagna straffar',
    Goals: 'Mål',
    PenaltyShots: 'Straffskott',
    PenaltyGoals: 'Straffmål',
    NonPenaltyGoals: 'Icke-straffmål',
    NPGOpenPlay: 'NPG öppet spel',
    NPGSetPiece: 'NPG fast situation',
    Shooting: 'Skott',
    Finishing: 'Avslut',
    xGEfficiency: 'xG‑effektivitet',
    HeaderPerShot: 'Nick per skott',
    HeaderPerCross: 'Nick per inlägg',
    HeadedGoals: 'Ledade mål',
    GoalsConceded: 'Insläppta mål',
    SavesInBox: 'Sparar i box',
    SavesOutBox: 'Sparar ur kartongen',
    Assists: 'Assist',
    ThroughBalls: 'Djupledsbollar',
    CrossEfficiency: 'Inläggseffektivitet',
    ScoringContribution: 'Målbidrag',
    xAssistsOpenPlay: 'xAssist öppet spel',
    xAssistsSetPiece: 'xAssist fast situation',
    xAssistsOpenPlayInTeam: 'xAssist öppet spel i lag',
    xAssistsSetPieceInTeam: 'xAssist fast situation i lag',
    xGBuildupFinalThird: 'xG Build Up Final â…“',
    xGChainFinalThird: 'xG Chain Final â…“',
    BallProgressionPassing: 'Bollprog. via passning',
    BallProgressionDribbling: 'Bollprog. via drivning',
    TacklesWasDribbled: 'Vunna defensiva 1-mot-1-dueller',
    TacklesSuccessful: 'Lyckade tacklingar',
    Interceptions: 'Interceptioner',
    Clearances: 'Rensningar',
    Fouls: 'Fouls',
    Recoveries: 'Återerövringar',
    Shots: 'Skott',
    ShotsPerGoal: 'Skott per mål',
    ShortPassesSuccessful: 'Lyckade kortpassningar',
    PassingSuccessForwardPct: '% Lyckade framåtpassningar',
    PassingSuccessBackwardPct: '% Lyckade bakåtpassningar',
    PassingForwardBackwardPct: '% Framåt per bakåt',
    LongBallPerPassesPct: '% Lång boll per passningar',
    LongBallReceived: 'Mottagna långbollar',
    LongBallReceivedOppHalf: 'Mottagna långbollar offens. halv',
    OffensiveActions: 'Offensiva aktioner',
    DribblesAttempted: 'Försökta dribblingar',
    SuccessfulDribblesPct: '% Lyckade dribblingar',
    OffensiveTouchesOutBoxPct: '% Offensiva toucher utanför box',
    BallRetention: '% Bollbehållning',
    PassingPct: '% Passningar',
    PassingOwnHalfPct: '% Passningar egen halv',
    PassingOppHalfPct: '% Passningar offens. halv',
    PassingFinalThird: 'Passningar in i sista â…“',
    PassesFinalThirdTotal: 'Totalt antal godkända finaler ⅓',
    PassingFinalThirdPct: '% Passningar in i sista â…“',
    LongBallSuccessful: 'Lyckade långbollar',
    LongBallPct: '% Långbollar',
    LongBallTotal: 'Totalt långa bollar',
    SavesPct: '% Räddningar',
    SavesInBoxPct: '% Räddningar i box',
    SavesOutOfBoxPct: '% Räddningar utanför box',
    xGSavedPerXGFacedOnTarget: 'xG räddad/xG emot på mål',
    xGFacedOnTargetPerGoalReceived: 'xG emot per mål',
    xGFacedOnTargetEfficiency: 'Förhindrade mål',
    xGFacedOnTarget: 'xG emot på mål',
    IndividualPressure: 'Individuell press',
    AerialEfficiency: 'Luftduell‑effektivitet',
    AerialWins: 'Vunna luftdueller',
    AerialWinsPct: '% Vunna luftdueller',
    xG: 'Förväntade mål',
    xGDiff: 'xG‑skillnad',
    xGOpenPlay: 'xG öppet spel',
    xGSetPiece: 'xG fast situation',
    xGPerShot: 'xG per skott',
    ChancesCreated: 'Skapade chanser',
    CompletedCrosses: 'Lyckade inlägg',
    Crossing: '% Inlägg',
    OpenPlayKeyPasses: 'Nyckelpass öppet spel',
    OpenPlayKeyPassesInTeam: '% Nyckelpass öppet spel i lag',
    OpenPlayPassesIntoOpponentBox: 'Tot. OP‑passningar in i box',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'OP‑passningar in i box',
    xAssists: 'Förväntade assist',
    xGChain: 'xG‑kedja',
    xGBuildup: 'xG‑uppbyggnad',
    xGBuildupInTeam: 'xG‑uppbyggnad i lag',
    BallProgression: 'Bollprogression',
    SuccessfulDribbles: 'Lyckade dribblingar',
    Dispossessed: 'Av med bollen',
    TouchesInOpponentBox: 'Toucher i motst. straffområde',
    xGSavedPerShot: 'xG räddad per skott',
    BallRetentionOppHalf: '% Bollbehållning offens. halv',
    DeepProgression: 'Djup progression',
    DeepProgressionFinalThird: 'Djup progression in i sista â…“',
    FoulsTaken: 'Utdelade frisparkar',
    PenaltiesTaken: 'Fälld till straff',
    BlockedCrosses: 'Blockerade inlägg',
    BlockedShots: 'Blockerade skott',
    Blocks: 'Blockar',
    NonPenaltyGoalsAgainst: 'Icke‑straffmål insläppta',
    Headers: 'Nickar',
    AveragePassDistance: 'Genomsnittlig passningslängd',
    ProgressiveRuns: 'Progressiva drivningar',
    xT: 'Förväntat hot (xT)',
    xTOpenPlay: 'xT öppet spel',
    xTSetPiece: 'xT fast situation',
    xGOT: 'Förväntade mål på mål',
    BadActions: 'Dåliga aktioner',
    BadActionsOwnHalf: 'Dåliga aktioner egen halv',
    AerialsWonOwnBox: 'Vunna luftdueller egen box',
    AerialsWonOppBox: 'Vunna luftdueller motst. box',
    AerialsTotalOppBox: 'Luftdueller totalt motst. box',
    AerialsTotalOwnBox: 'Luftdueller totalt egen box',
    FoulsOwnHalfPct: '% Fouls egen halv',
    RecoveriesOppHalf: 'Återerövringar offens. halv',
    DuelsPct: '% Lyckade dueller',
    TacklesUnsuccessful: 'Misslyckade tacklingar',
    TacklesWasDribbledFirstThird: 'Vunna defensiva 1-mot-1-dueller â…“',
    TacklesWasDribbledSecondThird: 'Vunna defensiva 1-mot-1-duellerâ…”',
    TacklesWasDribbledFinalThird: 'Vunna defensiva 1-mot-1-dueller sista â…“',
    BallProgressionFinalThird: 'Bollprogression sista â…“',
    DuelsTotal: 'Dueller',
    QuickRecoveries: 'Snabba återerövringar',
    ShotsPerNPG: 'Skott per NPG',
    ShotsOutBox: 'Skott utanför box',
    GoalsOutBox: 'Mål utanför box',
    ShootingOutBox: '% Skott på mål utanför box',
    HandPassing: '% Passningsnoggrannhet med händer',
    Catching: '% Fångade',
    Caught: 'Fångade räddningar',
    ClaimAccuracy: 'Greppsäkerhet',
    HighTurnovers: 'Höga bollvinster',
    ShotEndingHighTurnovers: 'Skott efter höga bollvinster',
    GoalEndingHighTurnovers: 'Mål efter höga bollvinster',
    AverageCarriesProgress: 'Genomsnittlig drivningsprogression',
    ChanceEndingCarries: 'Drivningar som slutar i chans',
    AssistEndingCarries: 'Drivningar som slutar i assist',
    ShotEndingCarries: 'Drivningar som slutar i skott',
    GoalEndingCarries: 'Drivningar som slutar i mål',
    ShotEndingSequence: 'Sekvens som slutar i skott',
    GoalEndingSequence: 'Sekvens som slutar i mål',
    xGPerNPG: 'xG per NPG',
    AerialWonOffensive: 'Vunna luftdueller offensiv',
    AerialWonDefensive: 'Vunna luftdueller defensiv',
    xGAgainst: 'xG emot',
    xGDiffAgainst: 'xG‑diff emot',
    xGPerNPGAgainst: 'xG per NPG emot',
    xGSetPieceAgainst: 'xG fast situation emot',
    xGOpenPlayAgainst: 'xG öppet spel emot',
    xGPerShotAgainst: 'xG per skott emot',
    ShotsAgainst: 'Skott emot',
    ShotsOnTargetAgainst: 'Skott på mål emot',
    ShotsOnTargetInBoxAgainst: 'Avgivna skott på mål i boxen',
    ShotsOnTargetOutBoxAgainst: 'Skott på mål utanför boxen medgivna',
    RivalPossession: 'Motståndarens bollinnehav',
    AerialDefensivePct: '% Luftdueller defensiv',
    HighRecoveries: 'Höga återerövringar',
    HighDefensiveActions: 'Höga defensiva aktioner',
    HighDefensiveActionPct: '% Höga defensiva aktioner',
    HighDefensiveDistance: 'Hög defensiv distans',
    PassesPerPossession: 'Passningar per bollinnehav',
    LengthPerPossession: 'Distans per bollinnehav',
    xTNet: 'Netto xT',
    AvgCarriesDistance: 'Gen. drivningsdistans',
    PassesForwardPct: '% Passningar framåt',
    PassesForwardSuccessful: 'Framgångsrika framåtpassningar',
    PassesForwardTotal: 'Totalt antal framåtpassningar',
    TacklesAttempted: 'Försökta tacklingar',
    DuelsLost: 'Förlorade dueller',
    Carries: 'Drivningar',
    CarriesPct: '% Drivningar',
    Aerials: 'Luftdueller',
    ProgressivePassesReceivedIntoBox: 'Progressiva passningar mottagna in i box',
    PassesOppHalf: 'Passningar offens. halv',
    ShotsOnTarget: 'Skott på mål',
    AggressiveActions: 'Aggressiva aktioner',
    Crosses: 'Inlägg',
    xGBuildup5pass: 'xG‑uppbyggnad 5 passningar',
    SpeedSequence: 'Sekvenshastighet',
    Touches: 'Toucher',
    AerialsTotalOppHalf: 'Luftdueller totalt offens. halv',
    AerialsWonOppHalf: 'Aerials vann Opp. Halv',
    AerialsWonOppHalfPct: '% Vunna luftdueller offens. halv',
    AerialsPctOppBox: '% Vunna luftdueller motst. box',
    AerialsPctOwnBox: '% Vunna luftdueller egen box',
    AerialDefensive: 'Luftdueller defensiv',
    AerialOffensive: 'Luftdueller offensiv',
    AerialOffensivePct: '% Luftdueller offensiv',
    IndividualPressureOppHalf: 'Individuell press offens. halv',
    ChancesCreatedOP: 'Skapade chanser öppet spel',
    TouchesPerShot: 'Toucher per skott',
    PassesFinalThirdTotalPct: '% Passningar sista â…“',
    xACrosses: 'xA från inlägg',
    Passes: 'Passningar',
    PassesSuccessful: 'Lyckade passningar',
    TacklesWasDribbledFouls: '% Markdueller',
    OffsidesCaught: 'Offsider',
    ProgressivePassesReceivedFinalThird: 'Prog. passn. mottagna sista â…“',
    ProgressivePassesReceived: 'Prog. passn. mottagna',
    Breadth: 'Bredd',
    DuelsDefTotal: 'Defensiva dueller',
    DefensiveActions: 'Defensiva aktioner',
    ProgressivePassesReceivedOppHalf: 'Prog. passn. mottagna offens. halv',
    CompletedCrossesOP: 'Lyckade inlägg öppet spel',
    CrossingOP: '% Inlägg öppet spel',
    CrossesOP: 'Totala korsningar Öppet spel',
    PassingContribution: '% Passningsbidrag',
    BallProgressionOppHalfInTeam: '% Bollprogression offens. halv i lag',
    PassesOPIntoBoxInTeam: '% OP‑passningar in i box i lag',
    TouchesOppBoxInTeam: '% Toucher motst. box i lag',
    xGOPInTeam: '% xG öppet spel i lag',
    DeepPasses: 'Djupa passningar',
    DeepPassesTotal: 'Djupa pass',
    DefensiveDuelsPct: '% Defensiva dueller',
    DefensiveDistance: 'Defensiv distans',
    QuickRecoveriesPct: '% Snabba återerövringar',
    DiffDefensiveDistanceTeam: 'Diff. defensiv distans lag',
    xTPassing: 'xT passningar',
    xTPassing100Passes: 'xT passningar per 100 passningar',
    ProgressivePassesAccurate: 'Progressiva passningar',
    PassAbility: 'Passningsförmåga',
    OPPassesIntoOppBoxPct: '% OP‑passningar in i motst. box',
    EntriesOppBox: 'Inbrytningar motst. box',
    Crosses6yardBox: 'Inlägg målområde',
    Cutbacks: 'Cutbacks',
    xTDribbling: 'xT dribbling',
    AvgShotDistance: 'Genomsnittlig skottdistans',
    xGOnTarget: 'xG på mål',
    FinishingxGOT: 'Avslut xGOT',
    DribblesWonOwnHalf: 'Lyckade dribblingar egen halv',
    DribblesOwnHalf: 'Dribblingar egen halv',
    DribblesOwnHalfPct: '% Dribblingar egen halv',
    DribblesWonOppHalf: 'Lyckade dribblingar offens. halv',
    DribblesOppHalf: 'Dribblingar offens. halv',
    DribblesOppHalfPct: '% Dribblingar offens. halv',
    DribblesWonFinalThird: 'Lyckade dribblingar sista â…“',
    DribblesFinalThird: 'Dribblingar sista â…“',
    DribblesFinalThirdPct: '% Dribblingar sista â…“',
    ShotEndingHighRecoveries: 'Skott efter höga återerövringar',
    PassingFinalThirdAgainst: 'Passningar in i sista â…“ emot',
    OpenPlayPassesIntoOpponentBoxAgainst: 'OP‑passningar in i box emot',
    EntriesOppBoxAgainst: 'Inbrytningar motst. box emot',
    DeepProgressionAgainst: 'Djup progression emot',
    TouchesInOpponentBoxAgainst: 'Toucher i motst. box emot',
    Score: 'Poäng',
    PDScore: 'Fysisk poäng',
    OrlegiScore: 'Poäng Orlegi',
    SirScore: 'Sirius‑poäng',
    ExcScore: 'Excelsior Score',
    xTOPInTeam: 'xT OP i lag',
    YellowCards: 'Gula kort',
    RedCards: 'Röda kort',
    xTOpenPlayAgainst: 'xT öppet spel emot',
    xTSetPieceAgainst: 'xT fast situation emot',
    NPGOpenPlayAgainst: 'NPG öppet spel emot',
    NPGSetPieceAgainst: 'NPG fast situation emot',
    PassesOppHalfPerPossession: 'Passningar offens. halv per innehav',
    AverageTimeRecovery: 'Gen. återhämtningstid',
    ExpectedPassing: '% Förväntade passningar',
    NumPossession10Passes: 'Innehav med 10 passningar',
    PassesReceived: 'Mottagna passningar',
    PassesReceivedFinalThird: 'Mottagna passningar sista â…“',
    ProgressivePassesTotalPct: '% Progressiva passningar',
    ShortPassesPct: '% Kortpassningar',
    TouchesOppBoxOppTeam: 'Motst. aktioner i egen box',
    ShotsOnTargetOppTeam: 'Skott på mål för motst.',
    NPGOppTeam: 'NPG motst.',
    ShotsOpenPlay: 'Skott öppet spel',
    xGSetPiecePerxG: 'xG fast situation per xG',
    ShotsOpenPlayAgainst: 'Skott öppet spel emot',
    ShotsFromDribble: 'Skott efter Dribbling',
    GoalsFromDribble: 'Mål efter Dribbling',
    PassesIntoFinalThird: 'Passningar till Sista Tredjedelen',
    PassesIntoFinalThirdTotal: 'Totalt går över till sista tredje',
    PassesInsideFinalThird: 'Passningar inom Sista Tredjedelen',
    PassesInsideFinalThirdTotal: 'Totalt antal pass i final ⅓',
    PassesFinalThirdNoArea: 'Klarar sista tredje (W/O Box)',
    PassesIntoOppBox: 'Passningar till Motståndarens Straffområde',
    CarriesFinalThird: 'Dribblingar till Sista Tredjedelen',
    CarriesInsideFinalThird: 'Dribblingar inom Sista Tredjedelen',
    CarriesFinalThirdNoBox: 'Har sista tredjedelen (utan box)',
    CarriesIntoOppBox: 'Dribblingar till Motståndarens Straffområde',
    TimePossessionAgainst: 'Motståndarens Bollinnehav',
    TimePossessionTotal: 'Totalt Bollinnehav',
    PassesInBox: 'Passningar i Eget Straffområde',
    LongThrowInSuccessful: 'Lyckade Långa Inkast',
    LongThrowInTotal: 'Totalt Antal Långa Inkast',
    LongThrowInPct: '% Lyckade Långa Inkast',
    Games: 'Spelade spel',
    PointsPerGame: 'Poäng per spel',
    ExpectedPointsDiff: 'Förväntad poängskillnad',
    PassesTotalOwnHalf: 'Totalt godkända egna hälft',
    PassesOwnHalf: 'Passerar egen halva',
    PassesTotalOppHalf: 'Passer totalt mot halva',
    ProgressivePassesTotal: 'Totalt progressiva pass',
    DuelsWon: 'Dueller vann',
    NonPenaltySaves: 'Räddningar utan straff',
    BadActionsOppHalf: 'Dåliga handlingar Upp halva',
    CarriesSuccessful: 'Bär framgångsrik',
    ShotsOnTargetOutBox: 'Skott på mål out of box',
    TotalDistance: 'Total distans',
    DistanceIP: 'Distans TIP',
    DistanceOOP: 'Distans OTIP',
    SprintsNumber: 'Antal sprintar',
    SprintsDistance: 'Sprintdistans',
    WalkingDistance: 'Gångdistans',
    JoggingDistance: 'Joggdistans',
    RunningDistance: 'Springdistans',
    ExtremeAccelerations: 'Extrema accelerationer',
    NumberOfRuns: 'Antal löpningar',
    HsrNumber: 'Antal HSR',
    HsrDistance: 'HSR‑distans',
    SprintNumberDeclinePct: '% Minskning antal sprintar',
    SprintDistanceDeclinePct: '% Minskning sprintdistans',
    SprintNumberDecline: 'Minskning antal sprintar',
    SprintDistanceDecline: 'Minskning sprintdistans',
    HsrDistancePct: '% HSR‑distans',
    SprintDistancePct: '% Sprintdistans',
    Accelerations: 'Accelerationer',
    ExplosiveDistance: 'Explosiv distans',
    MaxSpeed: 'Max. hastighet',
    AvgMaxSpeed: 'Gen. max. hastighet',
    MaxAccelerations: 'Max. accelerationer',
    BypassedPlayersByPasses: 'Spelare passerade via passningar',
    BypassedDefendersByPasses: 'Försvarare passerade via passningar',
    PassesBypassingPlayers: 'Passningar som passerar spelare',
    PassesBypassingDefenders: 'Passningar som passerar försvarare',
    BypassedPlayersPerPass: 'Spelare passerade per passning',
    BypassedDefendersPerPass: 'Försvarare passerade per passning',
    LineBreakingPasses: 'Linjebrytande passningar',
    LineBreakingPassesMD: 'Linjebrytande passningar MD',
    LineBreakingPassesM: 'Linjebrytande passningar M',
    LineBreakingThroughBalls: 'Linjebrytande djupledsbollar',
    LineBreakingPassesPerPass: '% Linjebrytande passningar per passning',
    TotalPassesUnderStrongPressure: 'Totalt passningar under hård press',
    TotalPassesUnderLightPressure: 'Totalt passningar under press',
    SuccessfulPassesUnderStrongPressure: 'Lyckade passningar under hård press',
    SuccessfulPassesUnderLightPressure: 'Lyckade passningar under press',
    PassingUnderStrongPressure: '% Passningar under hård press',
    PassingUnderLightPressure: '% Passningar under press',
    PassReceiptsInSpaceCompleted: 'Mottagna passningar i yta',
    PassReceiptsInSpace: 'Mottagna passningar i yta',
    PassReceiptsInSpaceCompletedFirstThird: 'Mottagningar i Yta Slutförda Första Tredjedelen',
    PassReceiptsInSpaceCompletedSecondThird: 'Mottagningar i Yta Slutförda Andra Tredjedelen',
    PassReceiptsInSpaceCompletedFinalThird: 'Mottagningar i Yta Slutförda Sista Tredjedelen',
    PassReceiptsInSpaceCompletedOppHalfRight: 'Mottagningar i Yta Motståndarens Högerhalva',
    PassReceiptsInSpaceCompletedOppHalfCenter: 'Mottagningar i Yta Motståndarens Center',
    PassReceiptsInSpaceCompletedOppHalfLeft: 'Mottagningar i Yta Motståndarens Vänsterhalva',
    PassReceiptsInSpaceFirstThird: 'Mottagningar i Yta Första Tredjedelen',
    PassReceiptsInSpaceSecondThird: 'Mottagningar i Yta Andra Tredjedelen',
    PassReceiptsInSpaceFinalThird: 'Mottagningar i Yta Sista Tredjedelen',
    PassReceiptsInSpaceOppHalfRight: 'Mottagningar i Yta Motståndarens Högerhalva',
    PassReceiptsInSpaceOppHalfCenter: 'Mottagningar i Yta Motståndarens Center',
    PassReceiptsInSpaceOppHalfLeft: 'Mottagningar i Yta Motståndarens Vänsterhalva',
    TotalStrongOnBallPressures: 'Totalt hård press på boll',
    TotalLightOnBallPressures: 'Totalt press på boll',
    SuccessfulStrongOnBallPressures: 'Lyckad hård press på boll',
    SuccessfulLightOnBallPressures: 'Lyckad press på boll',
    StrongOnBallPressuresPct: '% Hård press på boll',
    LightOnBallPressuresPct: '% Press på boll',
    TimesBypassedByPasses: 'Gånger passerad via passningar',
    TimesBypassedByCarries: 'Gånger passerad via drivningar',
    TimesBypassedByActions: 'Gånger passerad via aktioner',
    BypassedPlayersByCarries: 'Spelare passerade via drivningar',
    BypassedDefendersByCarries: 'Försvarare passerade via drivningar',
    BypassedPlayersByActions: 'Spelare passerade via aktioner',
    BypassedDefendersByActions: 'Försvarare passerade via aktioner',
    CarriesBypassingPlayers: 'Drivningar som passerar spelare',
    CarriesBypassingDefenders: 'Drivningar som passerar försvarare',
    BypassedPlayersPerCarry: 'Spelare passerade per drivning',
    BypassedDefendersPerCarry: 'Försvarare passerade per drivning',
    LineBreakingCarries: 'Linjebrytande drivningar',
    LineBreakingCarriesMD: 'Linjebrytande drivningar MD',
    LineBreakingCarriesM: 'Linjebrytande drivningar M',
    LineBreakingCarriesD: 'Linjebrytande drivningar D',
    LineBreakingCarriesPerCarry: '% Linjebrytande drivningar per drivning',
    LineBreakingActions: 'Linjebrytande aktioner',
    LineBreakingActionsMD: 'Linjebrytande aktioner MD',
    LineBreakingActionsM: 'Linjebrytande aktioner M',
    LineBreakingActionsD: 'Linjebrytande aktioner D',
    PassesPerLineBreakingPass: 'Passningar per linjebrytande passning',
    CarriesPerLineBreakingCarry: 'Drivningar per linjebrytande drivning',
    LinesBrokenByPasses: 'Linjer brutna via passningar',
    LinesBrokenByCarries: 'Linjer brutna via drivningar',
    LinesBrokenByActions: 'Linjer brutna via aktioner',
    LinesBrokenPerPass: 'Linjer brutna per passning',
    LinesBrokenPerCarry: 'Linjer brutna per drivning',
    AvgLastDefenderDistanceIP: 'Sista försvararens distans IP',
    AvgLastDefenderDistanceOOP: 'Sista försvararens distans OOP',
    AvgDefensiveLineDistanceIP: 'Defensiv linjes distans IP',
    AvgDefensiveLineDistanceOOP: 'Defensiv linjes distans OOP',
    AvgRBDistanceIP: 'Högerbackens distans IP',
    AvgRBDistanceOOP: 'Högerbackens distans OOP',
    AvgLBDistanceIP: 'Vänsterbackens distans IP',
    AvgLBDistanceOOP: 'Vänsterbackens distans OOP',
    AvgBlockDistanceIP: 'Blockdistans IP',
    AvgBlockDistanceOOP: 'Blockdistans OOP',
    AvgBlockAreaIP: 'Blockyta IP',
    AvgBlockAreaOOP: 'Blockyta OOP',
    AvgDefensiveLineWidthOOP: 'Def. linjes bredd OOP',
    AvgOffensiveLineLastThirdWidthIP: 'Off. linje sista tredjedel bredd IP',
    AvgLByIP: 'Vänsterbackens position IP',
    AvgRByIP: 'Högerbackens position IP',
    AvgOffensiveLineDistanceIP: 'Offensiv linjes distans IP',
    AvgOffensiveLineLastThirdDistanceIP: 'Off. linje sista tredjedel distans IP',
    AvgOffensiveLineWidthIP: 'Offensiv linjes bredd IP',
    OffBallRuns: 'Totalt löpningar utan boll',
    OffBallRunsOverlap: 'Löpningar utan boll overlap',
    OffBallRunsUnderlap: 'Löpningar utan boll underlap',
    OffBallRunsRunAhead: 'Löpningar utan boll framåt',
    OffBallRunsRunBehind: 'Löpningar utan boll bakåt',
    OffBallRunsCrossReceiver: 'Löpningar utan boll inläggsmottagare',
    OffBallRunsSupport: 'Löpningar utan boll stöd',
    OffBallRunsComingShort: 'Löpningar utan boll droppar kort',
    description: {
      Possession: 'Andel bollinnehav för laget',
      TimePossession: 'Bollinnehavstid för laget',
      PassesPerShots: 'Genomsnittligt antal passningar per skott',
      PPDA: 'Tillåtna passningar per defensiv aktion. PPDA mäter trycket laget lägger på motståndarna när de har bollen. Värdet motsvarar genomsnittligt antal passningar i rad motståndaren kunde slå innan avbrott. Ju högre värde, desto fler passningar tilläts',
      Directness: 'Mäter hur direkt ett lag är. Högt värde på direkthet kopplas till fler framåtpassningar jämfört med sidledspassningar',
      ExpectedPoints: 'Antal förväntade poäng för ett lag, beräknat baserat på genererad och insläppt xG. Måttet gör det möjligt att bättre bedöma lagets prestation i en match (eller flera matcher) jämfört med faktiskt uppnådda poäng',
      PassesPerLongBall: 'Andel lyckade långpassningar av totalt antal slagna passningar',
      CrossingPerXG: 'Andel förväntade mål från inlägg',
      PenaltySavedPenaltyFaced: 'Andel räddade straffskott av totalt mottagna straffskott',
      Goals: 'Antal mål',
      PenaltyShots: 'Totalt antal skott från straffar',
      PenaltyGoals: 'Totalt antal mål från straffar',
      NonPenaltyGoals: 'Antal mål exklusive straffmål',
      NPGOpenPlay: 'Antal mål från öppet spel exklusive straffmål',
      NPGSetPiece: 'Antal mål från fasta situationer exklusive straffmål',
      Shooting: 'Andel skott på mål',
      Finishing: 'Andel skott som slutar i mål',
      xGEfficiency: 'Mängd förväntade mål som behövs för att en spelare ska göra mål',
      HeaderPerShot: 'Antal nickar',
      HeaderPerCross: 'Andel inlägg som spelaren nickar av totalt antal inlägg laget slagit',
      Assists: 'Antal assist',
      ThroughBalls: 'Antal djupledsbollar för spelare i anfallslöpning som skapar målchans',
      CrossEfficiency: 'Mått som kombinerar andel lyckade inlägg med volymen lyckade inlägg',
      ScoringContribution: 'Antal assist och mål',
      xAssistsOpenPlay: 'Antal förväntade assist genererade i öppet spel',
      xAssistsSetPiece: 'Antal förväntade assist genererade på fasta situationer',
      xAssistsOpenPlayInTeam: 'Antal förväntade assist genererade i öppet spel i lag',
      xAssistsSetPieceInTeam: 'Antal förväntade assist genererade på fasta situationer i lag',
      xGChainFinalThird: 'Mängd xG spelaren deltagit i i sista tredjedelen',
      xGBuildupFinalThird: 'Mängd xG spelaren deltagit i i sista tredjedelen (exklusive skott och passningar som leder till skott)',
      BallProgressionPassing: 'Antal gånger spelaren förflyttar bollen 10 meter eller mer via passning',
      BallProgressionDribbling: 'Antal gånger spelaren förflyttar bollen 10 meter eller mer via drivning',
      TacklesWasDribbled: 'Mått som tar hänsyn till andelen gånger spelaren vinner bollen via tackling jämfört med när den passades/drevs. Ju högre värde, desto bättre',
      TacklesSuccessful: 'Antal lyckade tacklingar',
      Interceptions: 'Antal gånger spelaren interceptar en passning för att förhindra att bollen når målet',
      Clearances: 'Antal gånger spelaren rensar bollen från försvarszonen',
      Fouls: 'Antal fouls',
      Recoveries: 'Antal bollar återvunna',
      Shots: 'Totalt antal skott',
      ShotsPerGoal: 'Skott på mål som behövs för att göra ett icke-straffmål mot målvakten',
      ShortPassesSuccessful: 'Kortpassningar (under 12 meter) slagna',
      PassingSuccessForwardPct: 'Andel lyckade passningar framåt',
      PassingSuccessBackwardPct: 'Andel lyckade passningar bakåt',
      PassingForwardBackwardPct: 'Förhållande mellan framåtpassningar och bakåtpassningar',
      LongBallPerPassesPct: 'Andel lyckade långpassningar (>32 meter) av alla passningar spelaren slagit',
      LongBallReceived: 'Långpassningar (>32 meter) mottagna',
      LongBallReceivedOppHalf: 'Långpassningar (>32 meter) mottagna på offensiv planhalva',
      OffensiveActions: 'Offensiva aktioner',
      DribblesAttempted: 'Försökta dribblingar',
      SuccessfulDribblesPct: 'Lyckade dribblingar/totalt antal dribblingsförsök',
      OffensiveTouchesOutBoxPct: '% Offensiva toucher utanför box',
      BallRetention: 'Andel av tiden med boll som inte slutar i bolltapp',
      PassingPct: 'Andel lyckade passningar av alla passningar spelaren slagit',
      PassingOwnHalfPct: 'Andel lyckade passningar av alla passningar spelaren slagit (endast passningar på egen planhalva)',
      PassingOppHalfPct: 'Andel lyckade passningar av alla passningar spelaren slagit (endast passningar på offensiv planhalva)',
      PassingFinalThird: 'Lyckade passningar till sista tredjedelen',
      PassesFinalThirdTotal: 'Totalt antal försök, exklusive kryss, fasta mål, hörnor och inkast, som slutar i den sista tredjedelen',
      PassingFinalThirdPct: 'Andel lyckade passningar av alla passningar spelaren slagit (endast passningar till sista tredjedelen)',
      LongBallSuccessful: 'Slagna passningar över 32 meter',
      LongBallPct: 'Slagna passningar över 32 meter/Totalt antal försökta passningar över 32 meter',
      LongBallTotal: 'Totalt antal pass över 32 meter',
      SavesPct: 'Andel räddningar av totalt antal insläppta skott',
      SavesInBoxPct: 'Andel räddade skott som kommer inifrån boxen',
      SavesOutOfBoxPct: 'Andel räddade skott som kommer utifrån boxen',
      xGSavedPerXGFacedOnTarget: 'Koefficient som visar andelen förväntad xG som räddas av målvakten. Ett värde på 1 betyder att målvakten räddar all förväntad xG från insläppta skott, medan 0 betyder att all förväntad xG från motståndaren blir mål',
      xGFacedOnTargetPerGoalReceived: 'Mått som visar hur många förväntade mål som behövs för att göra mål mot en målvakt. Högt värde betyder att det krävs mycket xG för att göra mål',
      xGFacedOnTargetEfficiency: 'Antal icke-straffmål förhindrade av målvakten. Detta är antal förväntade mål på mål som målvakten mottar minus antal (icke-straff) mål insläppta. Visar antal mål som inte gjordes tack vare målvakten',
      xGFacedOnTarget: 'Total xG (räddade och mål) som målvakten möter',
      IndividualPressure: 'Mått som mäter antal lyckade försök (återerövringar) när spelaren pressar motståndaren',
      AerialEfficiency: 'Mått som kombinerar andel vunna luftdueller med volymen vunna luftdueller',
      AerialWins: 'Antal luftdueller spelaren vinner',
      AerialWinsPct: 'Antal luftdueller spelaren vinner av totalt antal luftdueller där spelaren var involverad',
      xG: 'Förväntade mål genererade. Måttet mäter sannolikheten att ett skott blir mål baserat på olika variabler (distans, vinkel, speltyp, kroppsdel, ...) för aktionen',
      xGDiff: 'Skillnad mellan xG och mål',
      xGOpenPlay: 'Förväntade mål genererade i öppet spel',
      xGSetPiece: 'Förväntade mål genererade på fasta situationer',
      xGPerShot: 'Genomsnittlig xG för spelarens skott. Måttet mäter genomsnittlig farlighet hos skotten. Ju högre, desto större sannolikhet att skotten blir mål. Hög xG per skott betyder att spelaren väljer sina skott väl',
      ChancesCreated: 'Antal passningar som leder till skott',
      CompletedCrosses: 'Antal lyckade inlägg',
      Crossing: 'Andel inlägg som slagit av alla försökta inlägg',
      OpenPlayKeyPasses: 'Antal passningar slagna i öppet spel',
      OpenPlayKeyPassesInTeam: 'Andel passningar slagna i öppet spel i lag',
      OpenPlayPassesIntoOpponentBox: 'Totalt antal försökta passningar in i motståndarens box i öppet spel',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Antal passningar slagna in i motståndarens box i öppet spel',
      xAssists: 'Mått som analyserar kvaliteten på skapade chanser i en match. Varje skottassist har ett värde baserat på sannolikheten att skottet blir mål. Värdet tilldelas enligt passningens plats, typ (inlägg djupledsboll fast situation...), spelsituation etc. Till skillnad från xG är xA ett mått där en spelare idealiskt har högre värde än sina assist, eftersom en skapare bara kan kontrollera sina kvalitetspassningar (xA), medan antal assist beror på avslutaren',
      xGChain: 'Mängd xG spelaren deltagit i',
      xGBuildup: 'Liknande xG Chain men utan att räkna de sista 2 spelarna i sekvensen (exklusive skott och passningar som leder till skott)',
      xGBuildupInTeam: 'Liknande xG Chain men utan att räkna de sista 2 spelarna i sekvensen (exklusive skott och passningar som leder till skott) i lag',
      BallProgression: 'Antal gånger spelaren avancerar 10 meter eller mer via passning, drivning eller kombination',
      SuccessfulDribbles: 'Lyckade dribblingar',
      Dispossessed: 'Antal gånger en spelare blir tacklad och tappar bollen',
      TouchesInOpponentBox: 'Antal gånger bollinnehavet är i motståndarens box',
      xGSavedPerShot: 'Genomsnittlig sannolikhet för mål på insläppta skott på mål',
      BallRetentionOppHalf: 'Andel av tiden med boll som inte slutar i bolltapp på offensiv planhalva',
      DeepProgression: 'Antal gånger sista femtedelen nås via drivning, plus antal gånger bollinnehavet är i sista femtedelen',
      DeepProgressionFinalThird: 'Antal gånger sista tredjedelen nås via drivning, plus antal gånger bollinnehavet är i sista tredjedelen',
      FoulsTaken: 'Antal gånger spelaren får frispark mot sig',
      PenaltiesTaken: 'Antal gånger spelaren fälls till straff i motståndarens box',
      BlockedCrosses: 'Blockerade inlägg',
      BlockedShots: 'Blockerade skott',
      NonPenaltyGoalsAgainst: 'Antal icke-straffmål insläppta',
      GoalsConceded: 'Antal insläppta mål',
      Headers: 'Antal skott med huvudet',
      HeadedGoals: 'Antal gjorda mål med huvudet',
      Points: 'Antal poäng som laget uppnått',
      SavesInBox: 'Antal räddningar från skott inuti boxen',
      SavesOutBox: 'Antal räddningar från skott utanför boxen',
      ShotsOnTargetInBoxAgainst: 'Antal insläppta skott på mål inifrån boxen',
      ShotsOnTargetOutBoxAgainst: 'Antal insläppta skott på mål utanför straffområdet',
      AveragePassDistance: 'Genomsnittlig distans för passningar i meter',
      ProgressiveRuns: 'Lyckade drivningar som förflyttar bollinnehavet 20% närmare motståndarens mål',
      xT: 'Förväntat hot (xT) är ett mått som mäter hotet en spelare skapar mot motståndaren genom att driva eller passa bollen till ytor där sannolikheten att bollinnehavet slutar i mål är högre',
      xTOpenPlay: 'Förväntat hot genererat i öppet spel',
      xTSetPiece: 'Förväntat hot genererat på fasta situationer',
      xGOT: 'Förväntade mål på mål. Antal förväntade mål som målvakten möter. Måttet tar endast hänsyn till skott på mål (missade skott och skott i stolpe/ribba exkluderas)',
      BadActions: 'Summa av alla dåliga aktioner (misslyckad passning, misslyckad dribbling, av med bollen, offside-passning, misslyckad bolltouch)',
      BadActionsOwnHalf: 'Summa av alla dåliga aktioner (misslyckad passning, misslyckad dribbling, av med bollen, offside-passning, misslyckad bolltouch) på egen planhalva',
      AerialsWonOwnBox: 'Vunna luftdueller egen box',
      AerialsWonOppBox: 'Vunna luftdueller motst. box',
      AerialsTotalOppBox: 'Totalt luftdueller motst. box',
      AerialsTotalOwnBox: 'Totalt luftdueller egen box',
      FoulsOwnHalfPct: 'Andel fouls på egen planhalva',
      RecoveriesOppHalf: 'Antal bollar återvunna på offensiv planhalva',
      DuelsPct: 'Andel lyckade dueller',
      TacklesUnsuccessful: 'Antal gånger en spelare misslyckas vinna bollen när motståndaren dribblar förbi',
      TacklesWasDribbledFirstThird: 'Andel gånger spelaren vinner bollen när den möts i sista tredjedelen',
      TacklesWasDribbledSecondThird: 'Vunna defensiva 1-mot-1-dueller⅔',
      TacklesWasDribbledFinalThird: 'Vunna defensiva 1-mot-1-dueller sista ⅓',
      BallProgressionFinalThird: 'Bollprogression sista tredjedelen',
      DuelsTotal: 'Totalt antal tacklingar, luftdueller, bolltoucher, dribblingar och fouls',
      QuickRecoveries: 'Återerövringar 40 meter eller mer från eget mål gjorda 8 sekunder efter bolltapp',
      ShotsPerNPG: 'Genomsnittligt antal skott för att göra ett icke-straffmål',
      ShotsOutBox: 'Antal skott utanför boxen',
      GoalsOutBox: 'Antal mål utanför boxen',
      ShootingOutBox: 'Andel skott på mål från utanför boxen',
      HandPassing: 'Passningsnoggrannhet med händer',
      Catching: 'Andel räddningar där målvakten fångar bollen',
      Caught: 'Räddar där målvakten fångar och håller bollen, vilket förhindrar andra spel',
      ClaimAccuracy: 'Mäter hur bra en målvakt är på att fånga/blockera luftbollar. Ett värde över 1 betyder att målvakten fångar fler luftbollar än förväntat',
      HighTurnovers: 'Bollvinster närmare än 40 meter från eget mål',
      ShotEndingHighTurnovers: 'Höga bollvinster (närmare än 40 meter från eget mål) som slutar i skott från motståndarlaget',
      GoalEndingHighTurnovers: 'Höga bollvinster (närmare än 40 meter från eget mål) som slutar i mål från motståndarlaget',
      AverageCarriesProgress: 'Genomsnittlig distans spelaren förflyttar bollen vertikalt per drivning (meter)',
      ChanceEndingCarries: 'Drivningar på minst 7 meter som slutar i passning följd av skott',
      AssistEndingCarries: 'Drivningar på minst 7 meter som slutar i passning följd av mål',
      ShotEndingCarries: 'Drivningar på minst 7 meter som slutar i skott',
      GoalEndingCarries: 'Drivningar på minst 7 meter som slutar i mål',
      ShotEndingSequence: 'Antal sekvenser som slutar i skott där spelaren var involverad',
      GoalEndingSequence: 'Antal sekvenser som slutar i mål där spelaren var involverad',
      xGPerNPG: 'Förväntade mål som behövs för att göra ett icke-straffmål',
      AerialWonOffensive: 'Vunna luftdueller offensiv',
      AerialWonDefensive: 'Vunna luftdueller defensiv',
      xGAgainst: 'Förväntade mål insläppta',
      xGDiffAgainst: 'Skillnad mellan förväntade mål insläppta och mål insläppta',
      xGPerNPGAgainst: 'Förväntade mål mottagna per icke-straffmål insläppt',
      xGSetPieceAgainst: 'Förväntade mål genererade på fasta situationer insläppta',
      xGOpenPlayAgainst: 'Förväntade mål genererade i öppet spel insläppta',
      xGPerShotAgainst: 'Förväntade mål mottagna per insläppt skott',
      ShotsAgainst: 'Antal skott insläppta',
      ShotsOnTargetAgainst: 'Antal skott på mål insläppta',
      RivalPossession: 'Motståndarens bollinnehav',
      AerialDefensivePct: 'Andel vunna luftdueller utan bollinnehav',
      HighRecoveries: 'Återerövringar gjorda 40 meter eller närmare motståndarens mål',
      HighDefensiveActions: 'Defensiva aktioner (Tacklingar, Interceptioner, Blockar, Fouls och 1vs1) gjorda 40 meter över egen kortlinje',
      HighDefensiveActionPct: 'Andel defensiva aktioner (Tacklingar, Interceptioner, Blockar, Fouls och 1vs1) gjorda 40 meter över egen kortlinje',
      HighDefensiveDistance: 'Genomsnittlig distans från eget mål för alla defensiva aktioner',
      PassesPerPossession: 'Antal passningar per bollinnehav',
      LengthPerPossession: 'Distans per bollinnehav',
      xTNet: 'Netto xT',
      AvgCarriesDistance: 'Genomsnittlig drivningsdistans',
      PassesForwardPct: '% Passningar framåt',
      PassesForwardSuccessful: 'Framgångsrika framåtpassningar',
      PassesForwardTotal: 'Totalt antal framåtpassningar',
      TacklesAttempted: 'Försökta tacklingar',
      DuelsLost: 'Förlorade dueller',
      Carries: 'Drivningar',
      CarriesPct: '% Drivningar',
      Aerials: 'Totalt antal luftdueller',
      ProgressivePassesReceivedIntoBox: 'Progressiva passningar mottagna in i box',
      PassesOppHalf: 'Lyckade passningar som slutar på offensiv planhalva',
      ShotsOnTarget: 'Skott på mål',
      AggressiveActions: 'Antal tacklingar försökta inom två sekunder efter bolltapp',
      Crosses: 'Totalt antal inlägg',
      xGBuildup5pass: 'Mängd xG spelaren deltagit i, endast senaste 5 passningar (exklusive skott och passningar som leder till skott)',
      DefensiveDistance: 'Genomsnittlig distans till eget mål för utförda defensiva dueller',
      SpeedSequence: 'Genomsnittlig hastighet (meter täckta per tid) för alla bollinnehav i ett lag',
      Touches: 'Antal gånger en spelare har bollen',
      AerialsTotalOppHalf: 'Totalt luftdueller på offensiv planhalva',
      AerialsWonOppHalf: 'Flygdueller framgångsrika in på motståndarhalvan',
      AerialsWonOppHalfPct: 'Andel vunna luftdueller på offensiv planhalva',
      AerialsPctOppBox: 'Andel vunna luftdueller i motståndarens box',
      AerialsPctOwnBox: 'Andel vunna luftdueller i egen box',
      AerialDefensive: 'Totalt antal luftdueller när motståndarlaget har bollen',
      AerialOffensive: 'Totalt antal luftdueller när eget lag har bollen',
      AerialOffensivePct: 'Andel vunna luftdueller när eget lag har bollen',
      IndividualPressureOppHalf: 'Mått som mäter antal lyckade försök (återerövringar) när spelaren pressar motståndaren på offensiv planhalva',
      ChancesCreatedOP: 'Antal passningar som leder till skott i öppet spel',
      TouchesPerShot: 'Antal gånger spelare rör bollen per skott',
      PassesFinalThirdTotalPct: 'Andel passningar (lyckade och misslyckade) till sista tredjedelen',
      xACrosses: 'Förväntade assist genererade från inlägg',
      Passes: 'Totalt antal passningar',
      PassesSuccessful: 'Antal slagna passningar',
      TacklesWasDribbledFouls: 'Andel vunna tacklingar i förhållande till totalt antal tacklingar och fouls',
      OffsidesCaught: 'Offsider',
      ProgressivePassesReceivedFinalThird: 'Progressiva passningar mottagna sista ⅓',
      ProgressivePassesReceived: 'Progressiva passningar mottagna',
      Breadth: 'Summa av tacklingar, utmaningar, interceptioner och fouls på sidorna av planen',
      DuelsDefTotal: 'Summa av totalt antal tacklingar, defensiva luftdueller och fouls',
      DefensiveActions: 'Defensiva aktioner när motståndaren försöker dribbla (Tacklingar, Utmaningar och Fouls)',
      ProgressivePassesReceivedOppHalf: 'Progressiva passningar mottagna offens. halv',
      CompletedCrossesOP: 'Lyckade inlägg öppet spel',
      CrossingOP: 'Andel inlägg slagna av alla försökta inlägg i öppet spel',
      CrossesOP: 'Totalt antal kryss under öppet spel',
      PassingContribution: 'Andel som mäter hot från passningar med hänsyn till mottagarens position',
      BallProgressionOppHalfInTeam: '% Bollprogression offens. halv i lag',
      PassesOPIntoBoxInTeam: '% OP‑passningar in i box i lag',
      TouchesOppBoxInTeam: '% Toucher motst. box i lag',
      xGOPInTeam: '% xG öppet spel i lag',
      DeepPasses: 'Passningar från utanför 20‑metersradien från motståndarens mål som slutar inuti området',
      DeepPassesTotal: 'Totalt antal passningar som försökts utanför en 20-meters radie från motståndarmålet som slutar inom det området',
      DefensiveDuelsPct: 'Andel vunna defensiva dueller av totalt antal defensiva dueller',
      QuickRecoveriesPct: 'Andel snabba återerövringar av interceptioner och försökta tacklingar',
      DiffDefensiveDistanceTeam: 'Skillnad mellan spelarens defensiva distans och lagets defensiva distans',
      xTPassing: 'Förväntat hot genererat endast från passningar',
      xTPassing100Passes: 'Förväntat hot genererat endast från passningar och per 100 passningar',
      ProgressivePassesAccurate: 'Slagna passningar på 10 meter eller mer i X‑axeln',
      PassAbility: 'Förhållande mellan slagna passningar och förväntade passningar (xP)',
      OPPassesIntoOppBoxPct: 'Andel slagna OP‑passningar in i motståndarens box och försökta OP‑passningar in i motståndarens box',
      EntriesOppBox: 'Antal passningar och drivningar in i motståndarens box',
      Crosses6yardBox: 'Totalt antal inlägg som slutar i målområdet',
      Cutbacks: 'Passning från kortlinje bakåt och in i motståndarens box',
      xTDribbling: 'Förväntat hot genererat endast från dribblingar',
      AvgShotDistance: 'Genomsnittlig distans för totalt antal skott',
      xGOnTarget: 'Förväntade mål från skott på mål. Mäter sannolikheten att ett skott blir mål med slutmålets position',
      FinishingxGOT: 'Andel skott på mål som slutar i mål över genomsnittet. Måttet mäter hur mycket värde anfallaren tillför med kvaliteten på sina skott',
      DribblesWonOwnHalf: 'Lyckade dribblingar på egen planhalva',
      DribblesOwnHalf: 'Antal försökta dribblingar på egen planhalva',
      DribblesOwnHalfPct: 'Andel lyckade dribblingar och försökta dribblingar på egen planhalva',
      DribblesWonOppHalf: 'Lyckade dribblingar på offensiv planhalva',
      DribblesOppHalf: 'Antal försökta dribblingar på offensiv planhalva',
      DribblesOppHalfPct: 'Andel lyckade dribblingar och försökta dribblingar på offensiv planhalva',
      DribblesWonFinalThird: 'Lyckade dribblingar i sista tredjedelen',
      DribblesFinalThird: 'Antal försökta dribblingar i sista tredjedelen',
      DribblesFinalThirdPct: 'Andel lyckade dribblingar och försökta dribblingar i sista tredjedelen',
      ShotEndingHighRecoveries: 'Höga återerövringar (40 meter eller närmare motståndarens mål) som slutar i skott',
      PassingFinalThirdAgainst: 'Lyckade passningar från motståndaren till sista tredjedelen',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Totalt antal försökta passningar från motståndaren in i egen box i öppet spel',
      EntriesOppBoxAgainst: 'Antal passningar och drivningar från motståndaren in i egen box',
      DeepProgressionAgainst: 'Antal gånger motståndaren når sista femtedelen via drivning, plus antal gånger bollinnehavet är i första femtedelen',
      TouchesInOpponentBoxAgainst: 'Antal gånger motståndaren har bollen i vår box',
      Score: 'Spelarens prestation baserat på olika metriker',
      PDScore: 'Spelarens fysiska prestation baserat på olika fysiska metriker',
      OrlegiScore: 'Spelarens prestation baserat på olika metriker',
      SirScore: 'Spelarens prestation baserat på olika metriker',
      ExcScore: 'Spelarens prestation baserat på olika metriker',
      xTOPInTeam: 'Förväntat hot genererat i öppet spel i lag',
      YellowCards: 'Gula kort mottagna',
      RedCards: 'Röda kort mottagna',
      xTOpenPlayAgainst: 'Förväntat hot insläppt i öppet spel',
      xTSetPieceAgainst: 'Förväntat hot insläppt på fasta situationer',
      NPGOpenPlayAgainst: 'Antal mål insläppta i öppet spel exklusive straffmål',
      NPGSetPieceAgainst: 'Antal mål insläppta på fasta situationer exklusive straffmål',
      PassesOppHalfPerPossession: 'Passningar offens. halv per bollinnehav',
      AverageTimeRecovery: 'Gen. återhämtningstid',
      ExpectedPassing: 'Andel passningar som borde ha slagit',
      NumPossession10Passes: 'Bollinnehav genererade av 10 eller fler passningar',
      PassesReceived: 'Mottagna passningar',
      PassesReceivedFinalThird: 'Mottagna passningar sista ⅓',
      ProgressivePassesTotalPct: 'Andel progressiva passningar',
      ShortPassesPct: 'Andel kortpassningar',
      TouchesOppBoxOppTeam: 'Antal motståndaraktioner insläppta inuti egen box medan spelaren är på planen',
      ShotsOnTargetOppTeam: 'Skott på mål insläppta medan spelaren är på planen',
      NPGOppTeam: 'Icke-straffmål insläppta medan spelaren är på planen',
      xGSetPiecePerxG: 'Förväntade mål genererade på fasta situationer som behövs för att generera ett förväntat mål',
      ShotsOpenPlay: 'Antal skott genererade i öppet spel',
      ShotsOpenPlayAgainst: 'Antal skott mottagna i öppet spel',
      ShotsFromDribble: 'Skott tagna efter att ha dribblat en motståndare',
      GoalsFromDribble: 'Mål gjorda efter att ha dribblat en motståndare',
      PassesIntoFinalThird: 'Lyckade passningar från sista tredjedelen',
      PassesIntoFinalThirdTotal: 'Totalt antal passningar som startar utanför och slutar inne i den sista tredjedelen',
      PassesInsideFinalThird: 'Lyckade passningar inom sista tredjedelen (början och slut inom samma zon)',
      PassesInsideFinalThirdTotal: 'Totalt antal passningar som försökts inom den sista tredjedelen (start och slut i sista tredjedelen)',
      PassesFinalThirdNoArea: 'Klarar sista tredje (W/O Box)',
      PassesIntoOppBox: 'Lyckade passningar som slutar i motståndarens straffområde',
      CarriesFinalThird: 'Dribblingar på minst 7 meter som slutar i sista tredjedelen',
      CarriesInsideFinalThird: 'Dribblingar på minst 7 meter inom sista tredjedelen (början och slut i samma zon)',
      CarriesFinalThirdNoBox: 'Har sista tredjedelen (utan box)',
      CarriesIntoOppBox: 'Dribblingar på minst 7 meter som slutar i motståndarens straffområde',
      TimePossessionAgainst: 'Motståndarlagets bollinnehavstid',
      TimePossessionTotal: 'Total bollinnehavstid för båda lagen',
      PassesInBox: 'Lyckade passningar inom det egna straffområdet',
      LongThrowInSuccessful: 'Lyckat långt inkast från sidlinjen, över 20 meter',
      LongThrowInTotal: 'Totalt antal långa inkast från sidlinjen, över 20 meter',
      LongThrowInPct: 'Andel långa inkast (20+ meter) som är lyckade',
      Games: 'Spelade spel',
      PointsPerGame: 'Poäng per spel',
      ExpectedPointsDiff: 'Förväntad poängskillnad',
      PassesTotalOwnHalf: 'Totalt antal pass gjorda från egen planhalva',
      PassesOwnHalf: 'Antal lyckade passningar från egen planhalva',
      PassesTotalOppHalf: 'Totalt antal passningar från motståndarhalvan',
      ProgressivePassesTotal: 'Totalt antal pass på 10 meter eller mer i X-axeln',
      DuelsWon: 'Framgångsrika dueller (tacklingar, antenner, bollberöring, dribblingar och begångna fouls)',
      NonPenaltySaves: 'Räddningar exklusive straffslag',
      BadActionsOppHalf: 'Summan av alla dåliga handlingar som begåtts (passning misslyckad, ta på misslyckad, besatt, offsidepassning, bollberöring misslyckad) i motståndarhalvan',
      CarriesSuccessful: 'Antal bär på minst 7 meter som slutar med ett lyckat evenemang',
      ShotsOnTargetOutBox: 'Skott gjorda på mål från utsidan av boxen',
      TotalDistance: 'Total distans som spelaren har tillryggalagt under en match',
      WalkingDistance: 'Total distans som spelaren har tillryggalagt under en match i en hastighet lägre än 2 m/s (7,2 km/h)',
      JoggingDistance: 'Total distans som spelaren har tillryggalagt under en match i en hastighet mellan 2 m/s (7,2 km/h) och 4 m/s (14,4 km/h)',
      RunningDistance: 'Total distans som spelaren har tillryggalagt under en match i en hastighet mellan 4 m/s (14,4 km/h) och 5,5 m/s (19,8 km/h)',
      ExtremeAccelerations: 'Antal gånger spelaren accelererar mer än 3 m/s<sup>2</sup>',
      NumberOfRuns: 'Antal löpningar slutförda i en hastighet mellan 4 m/s (14,4 km/h) och 5,5 m/s (19,8 km/h)',
      DistanceIP: 'Distans (Team In Possession) som spelaren har tillryggalagt under en match med bollinnehav',
      DistanceOOP: 'Distans OTIP (Opponent Team In Possession) som spelaren har tillryggalagt under en match utan bollinnehav',
      HsrNumber: 'Antal gånger spelaren rör sig i en hastighet som är större än eller lika med 5,5 m/s (19,8 km/h) men mindre än 7 m/s (25,2 km/h) under minst 1 sekund',
      HsrDistance: 'Total distans som spelaren har tillryggalagt under en match i en hastighet som är större än eller lika med 5,5 m/s (19,8 km/h) men mindre än 7 m/s (25,2 km/h)',
      HsrDistancePct: 'Andel HSR (High Speed Run) distans i förhållande till total tillryggalagd distans',
      SprintsNumber: 'Antal gånger spelaren rör sig i en hastighet som är större än eller lika med 7 m/s (25,2 km/h) under minst 1 sekund',
      SprintsDistance: 'Total distans som spelaren har tillryggalagt under en match i en hastighet som är större än eller lika med 7 m/s (25,2 km/h)',
      SprintNumberDeclinePct: 'Procentuell minskning av antal sprintar jämfört med andra halvleken',
      SprintDistanceDeclinePct: 'Procentuell minskning av sprintdistans jämfört med andra halvleken',
      SprintNumberDecline: 'Minskning av antal sprintar jämfört med andra halvleken',
      SprintDistanceDecline: 'Minskning av sprintdistans jämfört med andra halvleken',
      SprintDistancePct: 'Andel sprintdistans i förhållande till total tillryggalagd distans',
      Accelerations: 'Antal gånger spelaren accelererar mellan 1,5 m/s<sup>2</sup> och 3 m/s<sup>2</sup>',
      ExplosiveDistance: 'Explosiv distans',
      MaxSpeed: 'Maximal hastighet uppnådd av spelaren',
      AvgMaxSpeed: 'Genomsnittlig maximal hastighet uppnådd av spelaren',
      MaxAccelerations: 'Maximal meter/sekund<sup>2</sup> uppnådd av spelaren',
      BypassedPlayersByPasses: 'Totalt antal motståndare (försvarare och mittfältare) passerade via passningar',
      BypassedDefendersByPasses: 'Totalt antal motståndare (försvarare) passerade via passningar',
      PassesBypassingPlayers: 'Antal passningar som passerar spelare',
      PassesBypassingDefenders: 'Antal passningar som passerar försvarare',
      BypassedPlayersPerPass: 'Totalt antal spelare passerade per passningar',
      BypassedDefendersPerPass: 'Totalt antal försvarare passerade per passningar',
      LineBreakingPasses: 'Antal slagna passningar som lyckas penetrera en eller flera defensiva linjer',
      LineBreakingPassesMD: 'Antal slagna passningar som lyckas penetrera mittfälts- och försvarslinjer',
      LineBreakingPassesM: 'Antal slagna passningar som lyckas penetrera mittfältslinjen',
      LineBreakingThroughBalls: 'Antal slagna passningar som lyckas penetrera försvarslinjen',
      LineBreakingPassesPerPass: 'Andel linjebrytande passningar per passning',
      TotalPassesUnderStrongPressure: 'Totalt antal passningar slagna under hård press (inom 0-2 meter från närmaste motståndare)',
      TotalPassesUnderLightPressure: 'Totalt antal passningar slagna under press (inom 2-4 meter från närmaste motståndare)',
      SuccessfulPassesUnderStrongPressure: 'Antal lyckade passningar slagna under hård press (inom 0-2 meter från närmaste motståndare)',
      SuccessfulPassesUnderLightPressure: 'Antal lyckade passningar slagna under press (inom 2-4 meter från närmaste motståndare)',
      PassingUnderStrongPressure: 'Andel lyckade passningar och totalt antal passningar båda under hård press (inom 0-2 meter från närmaste motståndare)',
      PassingUnderLightPressure: 'Andel lyckade passningar och totalt antal passningar båda under press (inom 2-4 meter från närmaste motståndare)',
      PassReceiptsInSpaceCompleted: 'Passningar slagna där mottagaren är på offensiv planhalva och inte har någon försvarare inom 5 meters radie mot målets riktning',
      PassReceiptsInSpace: 'Passningar mottagna på offensiv planhalva där det inte finns någon försvarare inom 5 meters radie mot målets riktning',
      PassReceiptsInSpaceCompletedFirstThird: 'Passningar där mottagaren är i första tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceCompletedSecondThird: 'Passningar där mottagaren är i andra tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceCompletedFinalThird: 'Passningar där mottagaren är i sista tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Passningar där mottagaren är i motståndarens högra halva utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Passningar där mottagaren är i motståndarens centrala zon utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Passningar där mottagaren är i motståndarens vänstra halva utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceFirstThird: 'Passningar mottagna i första tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceSecondThird: 'Passningar mottagna i andra tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceFinalThird: 'Passningar mottagna i sista tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceOppHalfRight: 'Passningar mottagna i motståndarens högra halva utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceOppHalfCenter: 'Passningar mottagna i motståndarens centrala zon utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceOppHalfLeft: 'Passningar mottagna i motståndarens vänstra halva utan försvarare inom 5 meter mot mål',
      TotalStrongOnBallPressures: 'Antal hård press på boll (inom 0-2 meter från bollbäraren)',
      TotalLightOnBallPressures: 'Antal press på boll (inom 2-4 meter från bollbäraren)',
      SuccessfulStrongOnBallPressures: 'Antal lyckad hård press på boll (inom 0-2 meter)',
      SuccessfulLightOnBallPressures: 'Antal lyckad press på boll (inom 2-4 meter)',
      StrongOnBallPressuresPct: 'Andel lyckad och totalt hård press på boll (inom 0-2 meter från närmaste motståndare)',
      LightOnBallPressuresPct: 'Andel lyckad och totalt press på boll (inom 2-4 meter från närmaste motståndare)',
      TimesBypassedByPasses: 'Totalt antal gånger passerad via passning',
      TimesBypassedByCarries: 'Totalt antal gånger passerad via drivning',
      TimesBypassedByActions: 'Totalt antal gånger passerad via passning och drivning kombinerat',
      BypassedPlayersByCarries: 'Totalt antal motståndare (försvarare och mittfältare) passerade via drivningar',
      BypassedDefendersByCarries: 'Totalt antal motståndare (försvarare) passerade via drivningar',
      BypassedPlayersByActions: 'Totalt antal motståndare (försvarare och mittfältare) passerade via passningar och drivningar kombinerat',
      BypassedDefendersByActions: 'Totalt antal motståndare (försvarare) passerade via passningar och drivningar kombinerat',
      CarriesBypassingPlayers: 'Antal drivningar som passerar spelare',
      CarriesBypassingDefenders: 'Antal drivningar som passerar försvarare',
      BypassedPlayersPerCarry: 'Genomsnittligt antal motståndare passerade per drivning',
      BypassedDefendersPerCarry: 'Genomsnittligt antal försvarare passerade per drivning',
      LineBreakingCarries: 'Antal drivningar som lyckas penetrera en eller flera defensiva linjer',
      LineBreakingCarriesMD: 'Antal drivningar som lyckas penetrera mittfälts- och försvarslinjer',
      LineBreakingCarriesM: 'Antal drivningar som lyckas penetrera mittfältslinjen',
      LineBreakingCarriesD: 'Antal drivningar som lyckas penetrera försvarslinjen',
      LineBreakingCarriesPerCarry: 'Andel linjebrytande drivningar per drivning',
      LineBreakingActions: 'Antal passningar och drivningar kombinerat som lyckas penetrera en eller flera defensiva linjer',
      LineBreakingActionsMD: 'Antal passningar och drivningar kombinerat som lyckas penetrera mittfälts- och försvarslinjer',
      LineBreakingActionsM: 'Antal passningar och drivningar kombinerat som lyckas penetrera mittfältslinjen',
      LineBreakingActionsD: 'Antal passningar och drivningar kombinerat som lyckas penetrera försvarslinjen',
      PassesPerLineBreakingPass: 'Förhållande mellan totalt antal passningar per linjebrytande passning',
      CarriesPerLineBreakingCarry: 'Förhållande mellan totalt antal drivningar per linjebrytande drivning',
      LinesBrokenByPasses: 'Totalt antal linjer brutna via passningar',
      LinesBrokenByCarries: 'Totalt antal linjer brutna via drivningar',
      LinesBrokenByActions: 'Totalt antal linjer brutna via passningar och drivningar kombinerat',
      LinesBrokenPerPass: 'Förhållande mellan totalt antal linjer brutna per passning',
      LinesBrokenPerCarry: 'Förhållande mellan totalt antal linjer brutna per drivning',
      AvgLastDefenderDistanceIP: 'Distans mellan sista försvararen (närmast eget mål) och mållinjen med bollinnehav',
      AvgLastDefenderDistanceOOP: 'Distans mellan sista försvararen (närmast eget mål) och mållinjen utan bollinnehav',
      AvgDefensiveLineDistanceIP: 'Distans mellan positionen för den djupaste defensiva linjen och målet med bollinnehav',
      AvgDefensiveLineDistanceOOP: 'Distans mellan positionen för den djupaste defensiva linjen och målet utan bollinnehav',
      AvgRBDistanceIP: 'Distans från högerback till eget mål med bollinnehav',
      AvgRBDistanceOOP: 'Distans från högerback till eget mål utan bollinnehav',
      AvgLBDistanceIP: 'Distans från vänsterback till eget mål med bollinnehav',
      AvgLBDistanceOOP: 'Distans från vänsterback till eget mål med bollinnehav',
      AvgBlockDistanceIP: 'Distans mellan den djupaste och mest avancerade utespelaren med bollinnehav',
      AvgBlockDistanceOOP: 'Distans mellan den djupaste och mest avancerade utespelaren utan bollinnehav',
      AvgBlockAreaIP: 'Ytan av bounding box som omger alla utespelare (ett mått på hur mycket utrymme laget ockuperar) med bollinnehav',
      AvgBlockAreaOOP: 'Ytan av bounding box som omger alla utespelare (ett mått på hur mycket utrymme laget ockuperar) utan bollinnehav',
      AvgDefensiveLineWidthOOP: 'Bredden på den bakre linjen av spelare (längst från eget mål) utan bollinnehav',
      AvgOffensiveLineLastThirdWidthIP: 'Den horisontella bredden på den offensiva linjen i sista tredjedelen med bollinnehav',
      AvgLByIP: 'Position för vänsterback med bollinnehav',
      AvgRByIP: 'Position för högerback med bollinnehav',
      AvgOffensiveLineDistanceIP: 'Distans mellan eget mål och den offensiva linjen med bollinnehav',
      AvgOffensiveLineLastThirdDistanceIP: 'Distans mellan eget mål och den offensiva linjen i sista tredjedelen med bollinnehav',
      AvgOffensiveLineWidthIP: 'Den horisontella bredden på den offensiva linjen med bollinnehav',
      OffBallRuns: 'Avsiktliga rörelser utan boll (löpningar) för att stödja anfallsfasen',
      OffBallRunsOverlap: 'Löpningar där spelaren rör sig runt utsidan av en lagkamrat (närmare sidlinjen) medan lagkamraten har bollen',
      OffBallRunsUnderlap: 'Löpningar där spelaren rör sig inuti en lagkamrat, tar en inre rutt (närmare planens centrum)',
      OffBallRunsRunAhead: 'Framåtlöpning som går förbi bollbäraren men stannar framför sista försvararen',
      OffBallRunsRunBehind: 'Framåtlöpning som bryter in i den sista defensiva linjen, kommer mellan försvarare och målvakt',
      OffBallRunsCrossReceiver: 'En spelare springer in i boxen och positionerar sig för att ta emot ett inlägg från en lagkamrat',
      OffBallRunsSupport: 'Spelaren springer för att anpassa sig till bollbäraren, erbjuder en närliggande passningsmöjlighet i anfall',
      OffBallRunsComingShort: 'Spelaren rör sig mot bollbäraren för att erbjuda nära stöd eller en passningsmöjlighet bort från målet',
      AerialsOppHalf: 'Lyckade luftdueller på offensiv planhalva',
      CarriesIntoFinalThird: 'Rörledningar på minst 7 meter från utsidan till insidan av den sista tredjedelen',
      SpeedScore: 'Spelarens fysiska prestanda baserat på olika hastighetsmått',
      EnduranceScore: 'Spelarens fysiska prestationsförmåga baserat på olika mätvärden',
      SwitchPlaySuccessful: 'Antal genomförda passningar över 32 meter där bollens sidoförskjutning är större än dess förskjutning mot motståndarmålet',
      SwitchPlayTotal: 'Totalt antal försök över 32 meter där bollens förskjutning i sidled är större än dess förskjutning mot motståndarmålet',
      PassesInsideOppHalf: 'Totalt antal passningar som både börjar och slutar på motståndarhalvan',
      PassesInsideOppHalfSuccessful: 'Antal genomförda passningar som både börjar och slutar på motståndarhalvan',
      TacklesAttemptedFirstThird: 'Totalt antal tacklingar som försökts på den första tredjedelen av planen',
      TacklesAttemptedSecondThird: 'Totalt antal tacklingar försökte i den andra tredjedelen av planen',
      TacklesFirstThird: 'Antalet framgångsrika tacklingar gjorda på den första tredjedelen av planen',
      TacklesSecondThird: 'Antalet framgångsrika tacklingar på planens andra tredjedel',
      FoulsOwnHalf: 'Antal regelbrott som begåtts på spelarens egen planhalva',
      TouchesOppHalf: 'Antal bollberöringar på motståndarhalvan',
      TacklesAttemptedNotAdjusted: 'Totalt antal tacklingar försökte, utan besittningsjustering',
      TacklesSuccessfulNotAdjusted: 'Totalt antal framgångsrika tacklingar, utan innehavsjustering',
      AvgTop5MaxSpeed: 'Genomsnitt av spelarens fem högsta maxhastigheter',
      LBPReceived: 'Antal mottagna radbrytande passningar. Dessa är avslutade passningar som flyttar bollen minst 10 % närmare motståndarmålet och skär ett par försvarare i närheten eller färdas bortom försvarslinjen',
      LBPMReceived: 'Antal mottagna passningar som bryter igenom motståndarens mittfältslinje',
      LBPMDReceived: 'Antal mottagna passningar som bryter igenom både motståndarens mittfält och försvarslinjer',
      ThroughBallReceived: 'Antal mottagna passningar som bryter igenom motståndets sista försvarslinje',
      HsrDistanceIP: 'Sprintsträcka >21 km/h i besittning',
      HsrDistanceOOP: 'Sprintsträcka >21 km/h utom besittning',
      JoggingDistanceIP: 'Joggingdistans i besittning',
      JoggingDistanceOOP: 'Jogging distans ur besittning',
      RunningDistanceIP: 'Löpsträcka i besittning',
      RunningDistanceOOP: 'Löpsträcka ur besittning',
      SprintsDistanceIP: 'Sprintsträcka >24 km/h i besittning',
      SprintsDistanceOOP: 'Sprintsträcka >24 km/h utom besittning',
      WalkingDistanceIP: 'Gångavstånd i besittning',
      WalkingDistanceOOP: 'Gångavstånd ur besittning',
      RunningNumberIP: 'Antal gånger som spelaren rör sig med en hastighet mellan 4 m/s (14,4 km/h) och 5,5 m/s (19,8 km/h) under en tidsperiod på minst 1 sekund med besittning',
      RunningNumberOOP: 'Antal gånger som spelaren rör sig med en hastighet mellan 4 m/s (14,4 km/h) och 5,5 m/s (19,8 km/h) under en tidsperiod på minst 1 sekund utan besittning',
      RunningDistancePctIP: 'Procent av löpsträcka i förhållande till total tillryggalagd sträcka med innehav',
      RunningDistancePctOOP: 'Procent av löpsträcka i förhållande till total tillryggalagd sträcka utan innehav',
      RunningDistancePct: 'Procent av löpsträcka i förhållande till totalt tillryggalagd sträcka',
      HsrNumberIP: 'Antal gånger som spelaren rör sig med en hastighet som är större än eller lika med 5,5 m/s (19,8 km/h) men mindre än 7 m/s (25,2 km/h) under en tidsperiod på minst 1 sekund med besittning',
      HsrNumberOOP: 'Antal gånger som spelaren rör sig med en hastighet som är större än eller lika med 5,5 m/s (19,8 km/h) men mindre än 7 m/s (25,2 km/h) under en tidsperiod på minst 1 sekund utan innehav',
      SprintsNumberIP: 'Antal gånger som spelaren rör sig med en hastighet som är större än eller lika med 7 m/s (25,2 km/h) under en tidsperiod på minst 1 sekund med besittning',
      SprintsNumberOOP: 'Antal gånger som spelaren rör sig med en hastighet som är större än eller lika med 7 m/s (25,2 km/h) under en tidsperiod på minst 1 sekund utan besittning',
      SprintsDistancePctIP: 'Procent av sprintdistans i förhållande till total tillryggalagd sträcka med innehav',
      SprintsDistancePctOOP: 'Procent av sprintdistans i förhållande till totalt tillryggalagd sträcka utan innehav',
      SprintsDistancePct: 'Procent av sprintdistans i förhållande till total tillryggalagd sträcka',
      PossessionRegain: 'Antal gånger du tvingar motståndaren att förlora besittning',
      HandPassesSuccessful: 'Framgångsrika passningar gjorda med händer (målvakter eller inkastning av målspel)',
      HandPassesTotal: 'Totalt antal passningar gjorda med händer (målvakter eller inkastning av målspel)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player'
    },
    subtitles: {
      Possession: 'Andel bollinnehav för laget',
      TimePossession: 'Bollinnehavstid för laget',
      PassesPerShots: 'Genomsnittligt antal passningar per skott',
      PPDA: 'Tryck laget lägger på motståndarna när de har bollen',
      Directness: 'Fler framåtpassningar jämfört med sidledspassningar',
      ExpectedPoints: 'Antal förväntade poäng för ett lag, beräknat baserat på förväntade mål',
      PassesPerLongBall: 'Andel lyckade långpassningar av totalt antal slagna passningar',
      CrossingPerXG: 'Andel förväntade mål från inlägg',
      PenaltySavedPenaltyFaced: 'Andel räddade straffskott av totalt mottagna straffskott',
      Goals: 'Antal mål',
      PenaltyShots: 'Totalt antal skott från straffar',
      PenaltyGoals: 'Totalt antal mål från straffar',
      NonPenaltyGoals: 'Mål (exklusive straffar)',
      AerialWins: 'Vunna luftdueller',
      AerialEfficiency: 'Mått som kombinerar vunna luftdueller med totalt antal luftdueller',
      AerialWinsPct: 'Andel vunna luftdueller',
      Assists: 'Assist',
      Catching: 'Andel räddningar där målvakten fångar bollen',
      Caught: 'Räddar där målvakten fångar och håller bollen, vilket förhindrar andra spel',
      ChancesCreated: 'Antal passningar som leder till skott',
      ClaimAccuracy: 'Bollar fångade över genomsnittet',
      CompletedCrosses: 'Lyckade inlägg',
      Crossing: 'Andel lyckade inlägg',
      Dispossessed: 'Bolltapp',
      Finishing: 'Andel skott som slutar i mål',
      xGEfficiency: 'Mängd förväntade mål som behövs för att en spelare ska göra mål',
      Fouls: 'Fouls',
      DeepProgression: 'Antal gånger sista femtedelen nås via drivning, plus antal gånger bollinnehavet är i sista femtedelen',
      DeepProgressionFinalThird: 'Gånger spelaren har bollinnehavet i sista tredjedelen',
      FoulsTaken: 'Fouls mottagna',
      IndividualPressure: 'Lyckade försök (återerövringar)',
      Interceptions: 'Bollinterceptioner',
      LongBallPct: 'Andel slagna passningar på minst 32 meter',
      LongBallTotal: 'Totalt antal pass över 32 meter',
      LongBallSuccessful: 'Slagna passningar på minst 32 meter',
      NPGOpenPlay: 'Mål (exklusive straffar) i öppet spel',
      NPGSetPiece: 'Mål (exklusive straffar) på fasta situationer',
      OpenPlayKeyPasses: 'Passningar som slutar i skott (exklusive assist) i öppet spel',
      OpenPlayKeyPassesInTeam: 'Andel passningar som slutar i skott (exklusive assist) i öppet spel i lag',
      PassingFinalThird: 'Lyckade passningar till sista tredjedelen',
      PassesFinalThirdTotal: 'Totalt antal försök, exklusive kryss, fasta mål, hörnor och inkast, som slutar i den sista tredjedelen',
      PassingFinalThirdPct: 'Andel lyckade passningar i sista tredjedelen',
      PassingOppHalfPct: 'Andel lyckade passningar till offensiv planhalva',
      PassingOwnHalfPct: 'Andel lyckade passningar till egen planhalva',
      PassingPct: 'Andel lyckade passningar',
      Recoveries: 'Bollåtererövringar (via tacklingar eller interceptioner)',
      SavesInBoxPct: 'Andel räddningar från skott i boxen',
      SavesOutOfBoxPct: 'Andel räddningar från skott utanför boxen',
      SavesPct: 'Andel räddningar',
      ScoringContribution: 'Antal assist och mål',
      xAssistsOpenPlay: 'Antal förväntade assist genererade i öppet spel',
      xAssistsSetPiece: 'Antal förväntade assist genererade på fasta situationer',
      xAssistsOpenPlayInTeam: 'Antal förväntade assist genererade i öppet spel i lag',
      xAssistsSetPieceInTeam: 'Antal förväntade assist genererade på fasta situationer i lag',
      xGChainFinalThird: 'Mängd xG spelaren deltagit i i sista tredjedelen',
      xGBuildupFinalThird: 'Mängd xG spelaren deltagit i i sista tredjedelen (exklusive skott och passningar som leder till skott)',
      BallProgressionPassing: 'Antal gånger spelaren förflyttar bollen 10 meter eller mer via passning',
      BallProgressionDribbling: 'Antal gånger spelaren förflyttar bollen 10 meter eller mer via drivning',
      Shooting: 'Andel skott (exklusive straffar) på mål',
      Shots: 'Antal skott',
      ShotsPerGoal: 'Genomsnittligt antal skott för att göra mål',
      SuccessfulDribbles: 'Lyckade dribblingar',
      TacklesSuccessful: 'Totalt antal tacklingar',
      TacklesWasDribbled: 'Andel dueller vunna via tackling',
      ThroughBalls: 'Antal passningar som bryter försvarslinjen',
      TouchesInOpponentBox: 'Antal kontroller av bollen i motståndarens box',
      xAssists: 'Förväntade assist genererade',
      xG: 'Förväntade mål genererade',
      xGDiff: 'Skillnad mellan xG och mål',
      xGOpenPlay: 'Förväntade mål genererade i öppet spel',
      xGSetPiece: 'Förväntade mål genererade på fasta situationer',
      xGBuildup: 'Involvering i xG byggt',
      xGBuildupInTeam: 'Involvering i xG byggt i lag',
      BallProgression: 'Progressioner via passning eller drivning minst 10 meter',
      xGChain: 'Involvering i xG kedja',
      xGPerNPG: 'Förväntade mål som behövs för att göra ett icke-straffmål',
      xGPerShot: 'Genomsnittlig xG per skott',
      xGSavedPerShot: 'Genomsnittlig xG räddad per skott mött',
      xGSavedPerXGFacedOnTarget: 'Genomsnittlig xG räddad per xG mött på mål',
      xGFacedOnTargetPerGoalReceived: 'Förväntade mål behövs för att göra mål mot en målvakt',
      xGFacedOnTargetEfficiency: 'Antal icke-straffmål förhindrade av målvakten',
      xGFacedOnTarget: 'Total xG (räddade och mål) som målvakten möter',
      HighTurnovers: 'Bolltapp närmare än 40 meter från eget mål',
      OpenPlayPassesIntoOpponentBox: 'Totalt öppet spel passningar in i motståndarens box',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Öppet spel slagna passningar in i motståndarens box',
      ChancesCreatedOP: 'Antal passningar som leder till skott i öppet spel',
      PenaltiesTaken: 'Antal gånger spelaren fälls till straff i motståndarens box',
      BlockedCrosses: 'Blockerade inlägg',
      BlockedShots: 'Blockerade skott',
      NonPenaltyGoalsAgainst: 'Antal icke-straffmål insläppta',
      Headers: 'Antal skott med huvudet',
      AveragePassDistance: 'Genomsnittlig distans för passningar i meter',
      ProgressiveRuns: 'Lyckade drivningar som förflyttar bollinnehavet 20% närmare motståndarens mål',
      xT: 'Hot genererat genom att flytta bollen till farliga ytor',
      xTOpenPlay: 'Förväntat hot genererat i öppet spel',
      xTSetPiece: 'Förväntat hot genererat på fasta situationer',
      xGOT: 'Antal förväntade mål som målvakten möter',
      BadActions: 'Summa av alla dåliga aktioner',
      BadActionsOwnHalf: 'Summa av alla dåliga aktioner på egen planhalva',
      AerialsWonOwnBox: 'Vunna luftdueller egen box',
      AerialsWonOppBox: 'Vunna luftdueller motst. box',
      AerialsTotalOppBox: 'Totalt luftdueller motst. box',
      AerialsTotalOwnBox: 'Totalt luftdueller egen box',
      FoulsOwnHalfPct: 'Andel fouls på egen planhalva',
      RecoveriesOppHalf: 'Antal bollar återvunna på offensiv planhalva',
      DuelsPct: 'Andel lyckade dueller',
      TacklesUnsuccessful: 'Antal gånger en spelare misslyckas vinna bollen när motståndaren dribblar förbi',
      TacklesWasDribbledFirstThird: 'Andel gånger spelaren vinner bollen när den möts i sista tredjedelen',
      TacklesWasDribbledSecondThird: 'Vunna defensiva 1-mot-1-dueller ⅔',
      TacklesWasDribbledFinalThird: 'Vunna defensiva 1-mot-1-dueller sista ⅓',
      BallProgressionFinalThird: 'Antal gånger en spelare avancerar 10 meter eller mer i sista tredjedelen',
      DuelsTotal: 'Totalt antal tacklingar, luftdueller, bolltoucher, dribblingar och fouls',
      QuickRecoveries: 'Återerövringar 40 meter eller mer från eget mål gjorda 8 sekunder efter bolltapp',
      ShotsPerNPG: 'Genomsnittligt antal skott för att göra ett icke-straffmål',
      ShotsOutBox: 'Antal skott utanför boxen',
      GoalsOutBox: 'Antal mål utanför boxen',
      ShootingOutBox: 'Andel skott på mål från utanför boxen',
      HandPassing: 'Passningsnoggrannhet med händer',
      ShotEndingHighTurnovers: 'Höga bolltapp (närmare än 40 meter från eget mål) som slutar i skott från motståndarlaget',
      GoalEndingHighTurnovers: 'Höga bolltapp (närmare än 40 meter från eget mål) som slutar i mål från motståndarlaget',
      AverageCarriesProgress: 'Genomsnittlig distans spelaren förflyttar bollen vertikalt per drivning (meter)',
      ChanceEndingCarries: 'Drivningar på minst 7 meter som slutar i passning följd av skott',
      AssistEndingCarries: 'Drivningar på minst 7 meter som slutar i passning följd av mål',
      ShotEndingCarries: 'Drivningar på minst 7 meter som slutar i skott',
      GoalEndingCarries: 'Drivningar på minst 7 meter som slutar i mål',
      ShotEndingSequence: 'Antal sekvenser som slutar i skott där spelaren var involverad',
      GoalEndingSequence: 'Antal sekvenser som slutar i mål där spelaren var involverad',
      AerialWonOffensive: 'Vunna luftdueller offensiv',
      AerialWonDefensive: 'Vunna luftdueller defensiv',
      xGAgainst: 'Förväntade mål insläppta',
      xGDiffAgainst: 'Skillnad mellan förväntade mål insläppta och mål insläppta',
      xGPerNPGAgainst: 'Förväntade mål mottagna per icke-straffmål insläppt',
      xGOpenPlayAgainst: 'Förväntade mål genererade i öppet spel insläppta',
      xGSetPieceAgainst: 'Förväntade mål genererade på fasta situationer insläppta',
      xGPerShotAgainst: 'Förväntade mål mottagna per insläppt skott',
      ShotsAgainst: 'Skott insläppta',
      ShotsOnTargetAgainst: 'Skott på mål insläppta',
      RivalPossession: 'Motståndarens bollinnehav',
      AerialDefensivePct: 'Andel vunna luftdueller utan bollinnehav',
      HighRecoveries: 'Återerövringar gjorda 40 meter nära motståndarens mål',
      HighDefensiveActions: 'Defensiva aktioner (Tacklingar, Interceptioner, Blockar, Fouls och 1vs1) gjorda 40 meter över egen kortlinje',
      HighDefensiveActionPct: 'Andel defensiva aktioner (Tacklingar, Interceptioner, Blockar, Fouls och 1vs1) gjorda 40 meter över egen kortlinje',
      HighDefensiveDistance: 'Genomsnittlig distans från eget mål för alla defensiva aktioner',
      PassesPerPossession: 'Antal passningar per bollinnehav',
      LengthPerPossession: 'Distans per bollinnehav',
      xTNet: 'Netto xT',
      AvgCarriesDistance: 'Genomsnittlig drivningsdistans',
      PassesForwardPct: '% Passningar framåt',
      PassesForwardSuccessful: 'Framgångsrika framåtpassningar',
      PassesForwardTotal: 'Totalt antal framåtpassningar',
      TacklesAttempted: 'Försökta tacklingar',
      DuelsLost: 'Förlorade dueller',
      Carries: 'Drivningar',
      CarriesPct: '% Drivningar',
      Aerials: 'Totalt antal luftdueller',
      ProgressivePassesReceivedIntoBox: 'Progressiva passningar mottagna in i box',
      PassesOppHalf: 'Lyckade passningar som slutar på offensiv planhalva',
      LongBallReceived: 'Antal långpassningar (>32 meter) mottagna',
      ShotsOnTarget: 'Skott på mål',
      AggressiveActions: 'Antal tacklingar försökta inom två sekunder efter bolltapp',
      Crosses: 'Totalt antal inlägg',
      xGBuildup5pass: 'Mängd xG spelaren deltagit i, endast senaste 5 passningar (exklusive skott och passningar som leder till skott)',
      DefensiveDistance: 'Genomsnittlig distans till eget mål för utförda defensiva dueller',
      SpeedSequence: 'Genomsnittlig hastighet (meter täckta per tid) för alla bollinnehav i ett lag',
      Touches: 'Antal gånger en spelare har bollen',
      AerialsTotalOppHalf: 'Totalt luftdueller på offensiv planhalva',
      AerialsWonOppHalf: 'Flygdueller framgångsrika in på motståndarhalvan',
      AerialsWonOppHalfPct: 'Andel vunna luftdueller på offensiv planhalva',
      AerialsPctOppBox: 'Andel vunna luftdueller i motståndarens box',
      AerialsPctOwnBox: 'Andel vunna luftdueller i egen box',
      AerialDefensive: 'Totalt antal luftdueller när motståndarlaget har bollen',
      AerialOffensive: 'Totalt antal luftdueller när eget lag har bollen',
      AerialOffensivePct: 'Andel vunna luftdueller när eget lag har bollen',
      IndividualPressureOppHalf: 'Återerövringar av en spelare när den pressar motståndaren på offensiv planhalva',
      TouchesPerShot: 'Antal gånger spelare rör bollen per skott',
      PassesFinalThirdTotalPct: 'Andel passningar (lyckade och misslyckade) till sista tredjedelen',
      xACrosses: 'Förväntade assist genererade från inlägg',
      Passes: 'Totalt antal passningar',
      PassesSuccessful: 'Antal slagna passningar',
      TacklesWasDribbledFouls: 'Andel vunna tacklingar i förhållande till totalt antal tacklingar och fouls',
      OffsidesCaught: 'Offsider',
      ProgressivePassesReceivedFinalThird: 'Progressiva passningar mottagna sista ⅓',
      ProgressivePassesReceived: 'Progressiva passningar mottagna',
      Breadth: 'Summa av tacklingar, utmaningar, interceptioner och fouls på sidorna av planen',
      DuelsDefTotal: 'Summa av totalt antal tacklingar, defensiva luftdueller och fouls',
      DefensiveActions: 'Defensiva aktioner när motståndaren försöker dribbla (Tacklingar, Utmaningar och Fouls)',
      ProgressivePassesReceivedOppHalf: 'Progressiva passningar mottagna offens. halv',
      CompletedCrossesOP: 'Lyckade inlägg öppet spel',
      CrossingOP: 'Andel inlägg slagna av alla försökta inlägg i öppet spel',
      CrossesOP: 'Totalt antal kryss under öppet spel',
      PassingContribution: 'Andel som mäter hot från passningar med hänsyn till mottagarens position',
      BallProgressionOppHalfInTeam: '% Bollprogression på offensiv planhalva i lag',
      PassesOPIntoBoxInTeam: '% Passningar öppet spel in i box i lag',
      TouchesOppBoxInTeam: '% Toucher motståndarens box i lag',
      xGOPInTeam: '% xG öppet spel i lag',
      DeepPasses: 'Passningar från utanför 20‑metersradien från motståndarens mål som slutar inuti området',
      DeepPassesTotal: 'Totalt antal passningar som försökts utanför en 20-meters radie från motståndarmålet som slutar inom det området',
      DefensiveDuelsPct: 'Andel vunna defensiva dueller av totalt antal defensiva dueller',
      QuickRecoveriesPct: 'Andel snabba återerövringar av interceptioner och försökta tacklingar',
      DiffDefensiveDistanceTeam: 'Skillnad mellan spelarens defensiva distans och lagets defensiva distans',
      xTPassing: 'Förväntat hot genererat endast från passningar',
      xTPassing100Passes: 'Förväntat hot genererat endast från passningar och per 100 passningar',
      ProgressivePassesAccurate: 'Slagna passningar på 10 meter eller mer i X‑axeln',
      PassAbility: 'Förhållande mellan slagna passningar och förväntade passningar (xP)',
      OPPassesIntoOppBoxPct: 'Andel slagna öppet spel passningar in i motståndarens box och försökta öppet spel passningar in i motståndarens box',
      EntriesOppBox: 'Antal passningar och drivningar in i motståndarens box',
      Crosses6yardBox: 'Totalt antal inlägg som slutar i målområdet',
      Cutbacks: 'Passning från kortlinje bakåt och in i motståndarens box',
      xTDribbling: 'Förväntat hot genererat endast från dribblingar',
      AvgShotDistance: 'Genomsnittlig distans för totalt antal skott',
      xGOnTarget: 'Förväntade mål från skott på mål',
      FinishingxGOT: 'Andel skott på mål som slutar i mål över genomsnittet',
      DribblesWonOwnHalf: 'Lyckade dribblingar på egen planhalva',
      DribblesOwnHalf: 'Antal försökta dribblingar på egen planhalva',
      DribblesOwnHalfPct: 'Andel lyckade dribblingar och försökta dribblingar på egen planhalva',
      DribblesWonOppHalf: 'Lyckade dribblingar på offensiv planhalva',
      DribblesOppHalf: 'Antal försökta dribblingar på offensiv planhalva',
      DribblesOppHalfPct: 'Andel lyckade dribblingar och försökta dribblingar på offensiv planhalva',
      DribblesWonFinalThird: 'Lyckade dribblingar i sista tredjedelen',
      DribblesFinalThird: 'Antal försökta dribblingar i sista tredjedelen',
      DribblesFinalThirdPct: 'Andel lyckade dribblingar och försökta dribblingar i sista tredjedelen',
      ShotEndingHighRecoveries: 'Höga återerövringar (40 meter eller närmare motståndarens mål) som slutar i skott',
      PassingFinalThirdAgainst: 'Lyckade passningar från motståndaren till sista tredjedelen',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Totalt antal försökta passningar från motståndaren in i egen box i öppet spel',
      EntriesOppBoxAgainst: 'Antal passningar och drivningar från motståndaren in i egen box',
      DeepProgressionAgainst: 'Antal gånger motståndaren når sista femtedelen via drivning, plus antal gånger bollinnehavet är i första femtedelen',
      TouchesInOpponentBoxAgainst: 'Antal gånger motståndaren har bollen i vår box',
      Score: 'Spelarens prestation baserat på olika metriker',
      PDScore: 'Spelarens fysiska prestation baserat på olika fysiska metriker',
      OrlegiScore: 'Spelarens prestation baserat på olika metriker',
      SirScore: 'Spelarens prestation baserat på olika metriker',
      ExcScore: 'Spelarens prestation baserat på olika metriker',
      xTOPInTeam: 'Förväntat hot genererat i öppet spel i lag',
      YellowCards: 'Gula kort mottagna',
      RedCards: 'Röda kort mottagna',
      xTOpenPlayAgainst: 'Förväntat hot insläppt i öppet spel',
      xTSetPieceAgainst: 'Förväntat hot insläppt på fasta situationer',
      NPGOpenPlayAgainst: 'Antal icke-straffmål insläppta i öppet spel',
      NPGSetPieceAgainst: 'Antal icke-straffmål insläppta på fasta situationer',
      PassesOppHalfPerPossession: 'Passningar offens. halv per bollinnehav',
      AverageTimeRecovery: 'Gen. återhämtningstid',
      ExpectedPassing: 'Andel passningar som borde ha slagit',
      NumPossession10Passes: 'Bollinnehav genererade av 10 eller fler passningar',
      PassesReceived: 'Mottagna passningar',
      PassesReceivedFinalThird: 'Mottagna passningar sista ⅓',
      ProgressivePassesTotalPct: 'Andel progressiva passningar',
      ShortPassesPct: 'Andel kortpassningar',
      TouchesOppBoxOppTeam: 'Antal motståndaraktioner insläppta inuti egen box medan spelaren är på planen',
      ShotsOnTargetOppTeam: 'Skott på mål insläppta medan spelaren är på planen',
      NPGOppTeam: 'Icke-straffmål insläppta medan spelaren är på planen',
      xGSetPiecePerxG: 'Förväntade mål genererade på fasta situationer som behövs för att generera ett förväntat mål',
      ShotsOpenPlay: 'Antal skott genererade i öppet spel',
      ShotsOpenPlayAgainst: 'Antal skott mottagna i öppet spel',
      ShotsFromDribble: 'Skott tagna efter att ha dribblat en motståndare',
      GoalsFromDribble: 'Mål gjorda efter att ha dribblat en motståndare',
      PassesIntoFinalThird: 'Lyckade passningar från sista tredjedelen',
      PassesIntoFinalThirdTotal: 'Totalt antal passningar som startar utanför och slutar inne i den sista tredjedelen',
      PassesInsideFinalThird: 'Lyckade passningar inom sista tredjedelen (början och slut inom samma zon)',
      PassesInsideFinalThirdTotal: 'Totalt antal passningar som försökts inom den sista tredjedelen (start och slut i sista tredjedelen)',
      PassesFinalThirdNoArea: 'Klarar sista tredje (W/O Box)',
      PassesIntoOppBox: 'Lyckade passningar som slutar i motståndarens straffområde',
      CarriesFinalThird: 'Dribblingar på minst 7 meter som slutar i sista tredjedelen',
      CarriesInsideFinalThird: 'Dribblingar på minst 7 meter inom sista tredjedelen (början och slut i samma zon)',
      CarriesFinalThirdNoBox: 'Har sista tredjedelen (utan box)',
      CarriesIntoOppBox: 'Dribblingar på minst 7 meter som slutar i motståndarens straffområde',
      TimePossessionAgainst: 'Motståndarlagets bollinnehavstid',
      TimePossessionTotal: 'Total bollinnehavstid för båda lagen',
      PassesInBox: 'Lyckade passningar inom det egna straffområdet',
      LongThrowInSuccessful: 'Lyckat långt inkast från sidlinjen, över 20 meter',
      LongThrowInTotal: 'Totalt antal långa inkast från sidlinjen, över 20 meter',
      LongThrowInPct: 'Andel långa inkast (20+ meter) som är lyckade',
      Games: 'Spelade spel',
      PointsPerGame: 'Poäng per spel',
      ExpectedPointsDiff: 'Förväntad poängskillnad',
      PassesTotalOwnHalf: 'Totalt antal pass gjorda från egen planhalva',
      PassesOwnHalf: 'Antal lyckade passningar från egen planhalva',
      PassesTotalOppHalf: 'Totalt antal passningar från motståndarhalvan',
      ProgressivePassesTotal: 'Totalt antal pass på 10 meter eller mer i X-axeln',
      DuelsWon: 'Framgångsrika dueller (tacklingar, antenner, bollberöring, dribblingar och begångna fouls)',
      NonPenaltySaves: 'Räddningar exklusive straffslag',
      BadActionsOppHalf: 'Summan av alla dåliga handlingar som begåtts i motståndarhalvan',
      CarriesSuccessful: 'Antal bär på minst 7 meter som slutar med ett lyckat evenemang',
      ShotsOnTargetOutBox: 'Skott gjorda på mål från utsidan av boxen',
      TotalDistance: 'Total distans',
      WalkingDistance: 'Total distans som spelaren har tillryggalagt under en match i en hastighet lägre än 2 m/s (7,2 km/h)',
      JoggingDistance: 'Total distans som spelaren har tillryggalagt under en match i en hastighet mellan 2 m/s (7,2 km/h) och 4 m/s (14,4 km/h)',
      RunningDistance: 'Total distans som spelaren har tillryggalagt under en match i en hastighet mellan 4 m/s (14,4 km/h) och 5,5 m/s (19,8 km/h)',
      ExtremeAccelerations: 'Antal gånger spelaren accelererar mer än 3 m/s<sup>2</sup>',
      NumberOfRuns: 'Antal löpningar slutförda i en hastighet mellan 14,4 km/h och 19,8 km/h',
      HsrDistance: 'Höghastighetslöpning distans > 19,8 km/h',
      HsrNumber: 'Höghastighetslöpning antal > 19,8 km/h',
      HsrDistancePct: '% HSR distans',
      SprintsNumber: 'Antal sprintar > 25,2 km/h',
      SprintsDistance: 'Sprintdistans > 25,2 km/h',
      SprintNumberDeclinePct: '% Minskning antal sprintar',
      SprintDistanceDeclinePct: '% Minskning sprintdistans',
      SprintNumberDecline: 'Minskning antal sprintar jämfört med andra halvleken',
      SprintDistanceDecline: 'Minskning sprintdistans jämfört med andra halvleken',
      SprintDistancePct: '% Sprintdistans',
      Accelerations: 'Antal accelerationer',
      MaxSpeed: 'Max. hastighet',
      AvgMaxSpeed: 'Genomsnittlig maximal hastighet uppnådd av spelaren',
      MaxAccelerations: 'Maximal meter/sekund<sup>2</sup> uppnådd av spelaren',
      BypassedPlayersByPasses: 'Totalt antal motståndare (försvarare och mittfältare) passerade via passningar',
      BypassedDefendersByPasses: 'Totalt antal motståndare (försvarare) passerade via passningar',
      PassesBypassingPlayers: 'Antal passningar som passerar spelare',
      PassesBypassingDefenders: 'Antal passningar som passerar försvarare',
      BypassedPlayersPerPass: 'Totalt antal spelare passerade per passningar',
      BypassedDefendersPerPass: 'Totalt antal försvarare passerade per passningar',
      LineBreakingPasses: 'Antal passningar som lyckas penetrera en eller flera defensiva linjer',
      LineBreakingPassesMD: 'Antal passningar som lyckas penetrera mittfälts- och försvarslinjer',
      LineBreakingPassesM: 'Antal passningar som lyckas penetrera mittfältslinjen',
      LineBreakingThroughBalls: 'Antal passningar som lyckas penetrera försvarslinjen',
      LineBreakingPassesPerPass: 'Andel linjebrytande passningar per passning',
      TotalPassesUnderStrongPressure: 'Totalt antal passningar slagna under hård press (inom 0-2 meter från närmaste motståndare)',
      TotalPassesUnderLightPressure: 'Totalt antal passningar slagna under press (inom 2-4 meter från närmaste motståndare)',
      SuccessfulPassesUnderStrongPressure: 'Antal lyckade passningar slagna under hård press (inom 0-2 meter från närmaste motståndare)',
      SuccessfulPassesUnderLightPressure: 'Antal lyckade passningar slagna under press (inom 2-4 meter från närmaste motståndare)',
      PassingUnderStrongPressure: 'Andel lyckade passningar och totalt antal passningar båda under hård press (inom 0-2 meter från närmaste motståndare)',
      PassingUnderLightPressure: 'Andel lyckade passningar och totalt antal passningar båda under press (inom 2-4 meter från närmaste motståndare)',
      PassReceiptsInSpaceCompleted: 'Passningar slagna där mottagaren är på offensiv planhalva och inte har någon försvarare inom 5 meters radie mot målets riktning',
      PassReceiptsInSpace: 'Passningar mottagna på offensiv planhalva där det inte finns någon försvarare inom 5 meters radie mot målets riktning',
      PassReceiptsInSpaceCompletedFirstThird: 'Passningar där mottagaren är i första tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceCompletedSecondThird: 'Passningar där mottagaren är i andra tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceCompletedFinalThird: 'Passningar där mottagaren är i sista tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Passningar där mottagaren är i motståndarens högra halva utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Passningar där mottagaren är i motståndarens centrala zon utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Passningar där mottagaren är i motståndarens vänstra halva utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceFirstThird: 'Passningar mottagna i första tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceSecondThird: 'Passningar mottagna i andra tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceFinalThird: 'Passningar mottagna i sista tredjedelen utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceOppHalfRight: 'Passningar mottagna i motståndarens högra halva utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceOppHalfCenter: 'Passningar mottagna i motståndarens centrala zon utan försvarare inom 5 meter mot mål',
      PassReceiptsInSpaceOppHalfLeft: 'Passningar mottagna i motståndarens vänstra halva utan försvarare inom 5 meter mot mål',
      TotalStrongOnBallPressures: 'Antal hård press på boll (inom 0-2 meter från bollbäraren)',
      TotalLightOnBallPressures: 'Antal press på boll (inom 2-4 meter från bollbäraren)',
      SuccessfulStrongOnBallPressures: 'Antal lyckad hård press på boll (inom 0-2 meter)',
      SuccessfulLightOnBallPressures: 'Antal lyckad press på boll (inom 2-4 meter)',
      StrongOnBallPressuresPct: 'Andel lyckad och totalt hård press på boll (inom 0-2 meter från närmaste motståndare)',
      LightOnBallPressuresPct: 'Andel lyckad och totalt press på boll (inom 2-4 meter från närmaste motståndare)',
      TimesBypassedByPasses: 'Totalt antal gånger passerad via passning',
      TimesBypassedByCarries: 'Totalt antal gånger passerad via drivning',
      TimesBypassedByActions: 'Totalt antal gånger passerad via passning och drivning kombinerat',
      BypassedPlayersByCarries: 'Totalt antal motståndare (försvarare och mittfältare) passerade via drivningar',
      BypassedDefendersByCarries: 'Totalt antal motståndare (försvarare) passerade via drivningar',
      BypassedPlayersByActions: 'Totalt antal motståndare (försvarare och mittfältare) passerade via passningar och drivningar kombinerat',
      BypassedDefendersByActions: 'Totalt antal motståndare (försvarare) passerade via passningar och drivningar kombinerat',
      CarriesBypassingPlayers: 'Antal drivningar som passerar spelare',
      CarriesBypassingDefenders: 'Antal drivningar som passerar försvarare',
      BypassedPlayersPerCarry: 'Genomsnittligt antal motståndare passerade per drivning (minst 7 meter)',
      BypassedDefendersPerCarry: 'Genomsnittligt antal försvarare passerade per drivning (minst 7 meter)',
      LineBreakingCarries: 'Antal drivningar som lyckas penetrera en eller flera defensiva linjer',
      LineBreakingCarriesMD: 'Antal drivningar som lyckas penetrera mittfälts- och försvarslinjer',
      LineBreakingCarriesM: 'Antal drivningar som lyckas penetrera mittfältslinjen',
      LineBreakingCarriesD: 'Antal drivningar som lyckas penetrera försvarslinjen',
      LineBreakingCarriesPerCarry: 'Andel linjebrytande drivningar per drivning',
      LineBreakingActions: 'Antal passningar och drivningar kombinerat som lyckas penetrera en eller flera defensiva linjer',
      LineBreakingActionsMD: 'Antal passningar och drivningar kombinerat som lyckas penetrera mittfälts- och försvarslinjer',
      LineBreakingActionsM: 'Antal passningar och drivningar kombinerat som lyckas penetrera mittfältslinjen',
      LineBreakingActionsD: 'Antal passningar och drivningar kombinerat som lyckas penetrera försvarslinjen',
      PassesPerLineBreakingPass: 'Förhållande mellan totalt antal passningar per linjebrytande passning',
      CarriesPerLineBreakingCarry: 'Förhållande mellan totalt antal drivningar per linjebrytande drivning',
      LinesBrokenByPasses: 'Totalt antal linjer brutna via passningar',
      LinesBrokenByCarries: 'Totalt antal linjer brutna via drivningar',
      LinesBrokenByActions: 'Totalt antal linjer brutna via passningar och drivningar kombinerat',
      LinesBrokenPerPass: 'Förhållande mellan totalt antal linjer brutna per passning',
      LinesBrokenPerCarry: 'Förhållande mellan totalt antal linjer brutna per drivning',
      AvgLastDefenderDistanceIP: 'Distans mellan sista försvararen (närmast eget mål) och mållinjen med bollinnehav',
      AvgLastDefenderDistanceOOP: 'Distans mellan sista försvararen (närmast eget mål) och mållinjen utan bollinnehav',
      AvgDefensiveLineDistanceIP: 'Distans mellan positionen för den djupaste defensiva linjen och målet med bollinnehav',
      AvgDefensiveLineDistanceOOP: 'Distans mellan positionen för den djupaste defensiva linjen och målet utan bollinnehav',
      AvgRBDistanceIP: 'Distans från högerback till eget mål med bollinnehav',
      AvgRBDistanceOOP: 'Distans från högerback till eget mål utan bollinnehav',
      AvgLBDistanceIP: 'Distans från vänsterback till eget mål med bollinnehav',
      AvgLBDistanceOOP: 'Distans från vänsterback till eget mål med bollinnehav',
      AvgBlockDistanceIP: 'Distans mellan den djupaste och mest avancerade utespelaren med bollinnehav',
      AvgBlockDistanceOOP: 'Distans mellan den djupaste och mest avancerade utespelaren utan bollinnehav',
      AvgBlockAreaIP: 'Ytan av bounding box som omger alla utespelare (ett mått på hur mycket utrymme laget ockuperar) med bollinnehav',
      AvgBlockAreaOOP: 'Ytan av bounding box som omger alla utespelare (ett mått på hur mycket utrymme laget ockuperar) utan bollinnehav',
      AvgDefensiveLineWidthOOP: 'Bredden på den bakre linjen av spelare (längst från eget mål) utan bollinnehav',
      AvgOffensiveLineLastThirdWidthIP: 'Den horisontella bredden på den offensiva linjen i sista tredjedelen med bollinnehav',
      AvgLByIP: 'Position för vänsterback med bollinnehav',
      AvgRByIP: 'Position för högerback med bollinnehav',
      AvgOffensiveLineDistanceIP: 'Distans mellan eget mål och den offensiva linjen med bollinnehav',
      AvgOffensiveLineLastThirdDistanceIP: 'Distans mellan eget mål och den offensiva linjen i sista tredjedelen med bollinnehav',
      AvgOffensiveLineWidthIP: 'Den horisontella bredden på den offensiva linjen med bollinnehav',
      OffBallRuns: 'Avsiktliga rörelser utan boll (löpningar) för att stödja anfallsfasen',
      OffBallRunsOverlap: 'Löpningar där spelaren rör sig runt utsidan av en lagkamrat (närmare sidlinjen) medan lagkamraten har bollen',
      OffBallRunsUnderlap: 'Löpningar där spelaren rör sig inuti en lagkamrat, tar en inre rutt (närmare planens centrum)',
      OffBallRunsRunAhead: 'Framåtlöpning som går förbi bollbäraren men stannar framför sista försvararen',
      OffBallRunsRunBehind: 'Framåtlöpning som bryter in i den sista defensiva linjen, kommer mellan försvarare och målvakt',
      OffBallRunsCrossReceiver: 'En spelare springer in i boxen och positionerar sig för att ta emot ett inlägg från en lagkamrat',
      OffBallRunsSupport: 'Spelaren springer för att anpassa sig till bollbäraren, erbjuder en närliggande passningsmöjlighet i anfall',
      OffBallRunsComingShort: 'Spelaren rör sig mot bollbäraren för att erbjuda nära stöd eller en passningsmöjlighet bort från målet',
      AerialsOppHalf: 'Lyckade luftdueller på offensiv planhalva',
      CarriesIntoFinalThird: 'Rörledningar på minst 7 meter från utsidan till insidan av den sista tredjedelen',
      DribblesAttempted: 'Antal försök till dribblingar',
      SpeedScore: 'Spelarens fysiska prestanda baserat på olika hastighetsmått',
      EnduranceScore: 'Spelarens fysiska prestationsförmåga baserat på olika mätvärden',
      GoalsConceded: 'Antal insläppta mål',
      HeadedGoals: 'Antal gjorda mål med huvudet',
      SavesInBox: 'Antal räddningar från skott inne i boxen',
      SavesOutBox: 'Antal räddningar från skott utanför boxen',
      ShotsOnTargetInBoxAgainst: 'Antal skott på mål från insidan av straffområdet',
      ShotsOnTargetOutBoxAgainst: 'Antal skott på mål från utanför straffområdet',
      SwitchPlaySuccessful: 'Antal genomförda passningar över 32 meter där bollens sidoförskjutning är större än dess förskjutning mot motståndarmålet',
      SwitchPlayTotal: 'Totalt antal försök över 32 meter där bollens förskjutning i sidled är större än dess förskjutning mot motståndarmålet',
      PassesInsideOppHalf: 'Totalt antal passningar som både börjar och slutar på motståndarhalvan',
      PassesInsideOppHalfSuccessful: 'Antal genomförda passningar som både börjar och slutar på motståndarhalvan',
      TacklesAttemptedFirstThird: 'Totalt antal tacklingar som försökts på den första tredjedelen av planen',
      TacklesAttemptedSecondThird: 'Totalt antal tacklingar försökte i den andra tredjedelen av planen',
      TacklesFirstThird: 'Antalet framgångsrika tacklingar gjorda på den första tredjedelen av planen',
      TacklesSecondThird: 'Antalet framgångsrika tacklingar på planens andra tredjedel',
      FoulsOwnHalf: 'Antal regelbrott som begåtts på spelarens egen planhalva',
      TouchesOppHalf: 'Antal bollberöringar på motståndarhalvan',
      TacklesAttemptedNotAdjusted: 'Totalt antal tacklingar försökte, utan besittningsjustering',
      TacklesSuccessfulNotAdjusted: 'Totalt antal framgångsrika tacklingar, utan innehavsjustering',
      AvgTop5MaxSpeed: 'Genomsnitt av spelarens fem högsta maxhastigheter',
      LBPReceived: 'Antal mottagna radbrytande pass',
      LBPMReceived: 'Antal mottagna passningar som bryter igenom motståndarens mittfältslinje',
      LBPMDReceived: 'Antal mottagna passningar som bryter igenom både motståndarens mittfält och försvarslinjer',
      ThroughBallReceived: 'Antal mottagna passningar som bryter igenom motståndets sista försvarslinje',
      ShortPassesSuccessful: 'Antal genomförda korta pass (mindre än 12 meter).',
      PassingSuccessForwardPct: 'Andel framgångsrika framåtpassningar',
      PassingSuccessBackwardPct: 'Andel lyckade bakåtpassningar',
      PassingForwardBackwardPct: 'Förhållandet mellan framåtpassningar och bakåtpassningar',
      LongBallPerPassesPct: 'Andel långa bollar i förhållande till totala passningar',
      LongBallReceivedOppHalf: 'Antal långa bollar som tagits emot i det rivaliserande fältet',
      OffensiveActions: 'Offensiva handlingar',
      SuccessfulDribblesPct: 'Framgångsrika dribblingar/totalt gjorda dribblingsförsök',
      OffensiveTouchesOutBoxPct: '% av offensiva beröringar utanför boxen',
      HsrDistanceIP: 'Sprintsträcka >21 km/h i besittning',
      HsrDistanceOOP: 'Sprintsträcka >21 km/h utom besittning',
      JoggingDistanceIP: 'Joggingdistans i besittning',
      JoggingDistanceOOP: 'Jogging distans ur besittning',
      RunningDistanceIP: 'Löpsträcka i besittning',
      RunningDistanceOOP: 'Löpsträcka ur besittning',
      SprintsDistanceIP: 'Sprintsträcka >24 km/h i besittning',
      SprintsDistanceOOP: 'Sprintsträcka >24 km/h utom besittning',
      WalkingDistanceIP: 'Gångavstånd i besittning',
      WalkingDistanceOOP: 'Gångavstånd ur besittning',
      PossessionRegain: 'Antal gånger du tvingar motståndaren att förlora besittning',
      HandPassesSuccessful: 'Framgångsrika passningar gjorda med händer (målvakter eller inkastning av målspel)',
      HandPassesTotal: 'Totalt antal passningar gjorda med händer (målvakter eller inkastning av målspel)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      Clearances: 'Number of times the player hits the ball clear of the defensive zone',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player (via Tackles or Interceptions)'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'POH',
      PassesTotalOppHalf: 'PTOPPH',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: 'BAOPPH',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: 'SOTOB',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'SNYFTA',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP%',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRSC',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
      DistanceIP: 'DST IP',
      WalkingDistanceIP: 'WLKD IP',
      JoggingDistanceIP: 'JOGD IP',
      RunningDistanceIP: 'RUND IP',
      HsrDistanceIP: 'HSRD IP',
      SprintsDistanceIP: 'SPRD IP',
      RunningNumberIP: 'RUNQ IP',
      HsrNumberIP: 'HSRQ IP',
      SprintsNumberIP: 'SPRQ IP',
      DistanceOOP: 'DST OOP',
      WalkingDistanceOOP: 'WLKD OOP',
      JoggingDistanceOOP: 'JOGD OOP',
      RunningDistanceOOP: 'RUND OOP',
      HsrDistanceOOP: 'HSRD OOP',
      SprintsDistanceOOP: 'SPRD OOP',
      RunningNumberOOP: 'RUNQ OOP',
      HsrNumberOOP: 'HSRQ OOP',
      SprintsNumberOOP: 'SPRQ OOP',
      PossessionRegain: 'PR',
      HandPassesSuccessful: 'SHP',
      HandPassesTotal: 'THP',
      InterceptionsNotAdjusted: 'INT',
      ClearancesNotAdjusted: 'CLE',
      RecoveriesNotAdjusted: 'REC'
    },
    AerialsOppHalf: 'Lyckade luftdueller offens. halv',
    CarriesIntoFinalThird: 'Kör till den sista ⅓',
    scoreDifference: 'Poängskillnad: Visar om spelets prestation var över eller under säsongens genomsnitt',
    SpeedScore: 'Hastighet Power Score',
    EnduranceScore: 'Uthållighetspoäng',
    HeadedShots: 'Ledade skott',
    HeadedXG: 'Huvudet xG',
    HeadedSetPieceTooltip: 'Visar endast spelare som har headers från fasta spel',
    SwitchPlaySuccessful: 'Switch Play lyckades',
    SwitchPlayTotal: 'Byt spel totalt',
    PassesInsideOppHalf: 'Passerar inne i Opp Half',
    PassesInsideOppHalfSuccessful: 'Passningar inuti Opp Halv Framgångsrik',
    TacklesAttemptedFirstThird: 'Tacklar Försök först ⅓',
    TacklesAttemptedSecondThird: 'Tacklar försökt andra ⅓',
    TacklesFirstThird: 'Tacklar framgångsrik först ⅓',
    TacklesSecondThird: 'Tacklar framgångsrik andra ⅓',
    FoulsOwnHalf: 'Fel på egen halvlek',
    TouchesOppHalf: 'Berör Opp Half',
    TacklesAttemptedNotAdjusted: 'Tacklar försök inte justerade',
    TacklesSuccessfulNotAdjusted: 'Tacklar framgångsrika ej justerade',
    AvgTop5MaxSpeed: 'Avg Top5 MaxSpeed',
    LBPReceived: 'Linjebrytningskort mottagna',
    LBPMReceived: 'Linjebrytningskort (M-linje) mottagna',
    LBPMDReceived: 'Linjebrytningskort (MD-linje) mottagna',
    ThroughBallReceived: 'Mottagna genom bollar',
    recoveriesRate: 'Återställningsförhållande',
    turnoversRate: 'Förlustkvot',
    HsrDistanceIP: 'HSR Avstånd IP',
    HsrDistanceOOP: 'HSR Avstånd OOP',
    JoggingDistanceIP: 'Jogging Distans IP',
    JoggingDistanceOOP: 'Jogging Distans OOP',
    RunningDistanceIP: 'Löpdistans IP',
    RunningDistanceOOP: 'Löpsträcka OOP',
    SprintsDistanceIP: 'Sprints Distans IP',
    SprintsDistanceOOP: 'Sprints Distans OOP',
    WalkingDistanceIP: 'Gångavstånd IP',
    WalkingDistanceOOP: 'Gångavstånd OOP',
    PossessionRegain: 'Återta innehav',
    HandPassesSuccessful: 'Framgångsrika handpassningar',
    HandPassesTotal: 'Hand passerar',
    SprintsNumberIP: 'Sprints Kvantitet IP',
    SprintsNumberOOP: 'Sprints Antal OOP',
    RunningNumberIP: 'Löpande kvantitet IP',
    RunningNumberOOP: 'Löpande kvantitet OOP',
    HsrNumberIP: 'HSR Kvantitet IP',
    HsrNumberOOP: 'HSR Kvantitet OOP',
    InterceptionsNotAdjusted: 'Interceptions',
    ClearancesNotAdjusted: '',
    RecoveriesNotAdjusted: 'Recoveries'
  },
  team: {
    title: 'Lagöversikt',
    subtitle: 'Gå djupare in i lagets egenskaper och statistik',
    averageAge: 'Gen. ålder',
    transferBalance: 'Transferbalans',
    roster: 'Trupp',
    stadium: 'Stadion',
    coach: 'Tränare',
    transfers: 'Övergångar',
    trends: 'Trender',
    loans: 'Lån',
    loanFrom: 'Lån från',
    loanTo: 'Lån till',
    latestGames: 'Senaste matcher',
    latestXGames: 'Senaste {0} matcher',
    playingFor: 'Spelar för',
    overview: 'Översikt',
    visualization: 'Visualisering',
    location: 'Plats',
    outcome: 'Resultat',
    beeswarm: 'Ranking',
    parentTeam: 'A-lag',
    childTeam: 'Ungdomslag',
    preferredFormation: 'Föredragen formation',
    mostFrecuentFormations: 'Mest frekventa formationer',
    viewType: 'Vytyp',
    overviewTab: {
      axisXTotal: 'Totalt',
      axisXper90: 'Per 90\'',
      dataPerGameText: 'Data per match',
      season: 'Säsong',
      last: 'Föregående',
      current: 'Nuvarande',
      TeamStyle: 'Stil',
      TeamDefensive: 'Defensiv',
      TeamOffensive: 'Offensiv',
      TeamCustom1: 'Anpassad 1',
      TeamCustom2: 'Anpassad 2',
      TeamCustom3: 'Anpassad 3',
      TeamCustom4: 'Anpassad 4',
      coach: 'Tränare',
      groups: {
        Goals: {
          name: 'Mål',
          desc: 'Visar straffmål och icke-straffmål (öppet spel och fasta situationer).'
        },
        Assists: {
          name: 'Assist',
          desc: 'Spelare med flest assist (öppet spel och fasta situationer) denna säsong.'
        },
        xG: {
          name: 'Förväntade mål',
          desc: 'Förväntade mål från öppet spel och fasta situationer'
        },
        xA: {
          name: 'Förväntade assist',
          desc: 'Förväntade assist från öppet spel och fasta situationer.'
        },
        Finishing: {
          name: 'Avslutning',
          desc: 'Andel skott som slutar i mål.'
        },
        ScoringContribution: {
          name: 'Målkontribution',
          desc: 'Antal assist och mål för laget.'
        },
        xT: {
          name: 'Förväntat hot',
          desc: 'Förväntat hot genererat från öppet spel, fasta situationer och negativt xT.'
        }
      },
      stats: {
        openPlay: 'Öppet spel',
        setPiece: 'Fasta situationer',
        negative: 'Negativt',
        npg: 'Icke-straffmål',
        goalsPenalty: 'Straffmål',
        npgOpenPlay: 'NPG öppet spel',
        npgSetPiece: 'NPG fasta situationer',
        assists: 'Assist',
        assistsConceded: 'Assist insläppta',
        assistsOpenPlay: 'Assist öppet spel',
        assistsSetPiece: 'Assist fasta situationer',
        xGOpenPlay: 'xG öppet spel',
        xGSetPiece: 'xG fasta situationer',
        xAOpenPlay: 'xA öppet spel',
        xASetPiece: 'xA fasta situationer',
        xAConceded: 'xA insläppta',
        nonPenaltyShots: 'Icke-straffskott',
        penaltyShots: 'Straffskott',
        xT: 'Förväntat hot',
        xTOpenPlay: 'xT öppet spel',
        xTSetPiece: 'xT fasta situationer',
        xTNeg: 'Negativt xT',
        totalFinishing: 'Avslutning',
        nonPenaltyFinishing: 'Icke-straff avslutning',
        goalsPenaltyFinishing: 'Straff avslutning',
        goal: 'Mål',
        notGoal: 'Inte mål',
        chance: 'Chans',
        finished: 'Avslutad',
        notFinished: 'Inte avslutad',
        walkingDistance: 'Gång',
        joggingDistance: 'Jogg ',
        runningDistance: 'Spring ',
        hsrDistance: 'HSR',
        sprintsDistance: 'Sprintar',
        runningNumber: 'Löpningar',
        hsrNumber: 'HSR sprintar',
        sprintsNumber: 'Sprintar',
        maxSpeed: 'Max. hastighet',
        accelerations: 'Accelerationer',
        extremeAccelerations: 'Extrema accelerationer',
        maxAcceleration: 'Maximal acceleration'
      }
    },
    teamAnalysis: 'Lagsanalys',
    agentView: {
      positions: {
        gk: 'MV',
        leftFullback: 'Vänster YB',
        centralDefender: 'Central försvarare',
        rightFullback: 'Höger YB',
        midfielder: 'Mittfältare',
        attackingMidfielder: 'Anfallande mittfältare',
        leftWinger: 'Vänster ytter',
        rightWinger: 'Höger ytter',
        fw: 'Anfallare'
      },
      groups: {
        contractEnd: 'Månader',
        age: 'År gammal',
        availability: 'Tillgänglighet'
      },
      placer: {
        legend: 'Styrka baserat på ålder, kontrakt, tillgänglighet och prestation'
      }
    },
    transfersTab: {
      valueMovements: 'Rörelser värde',
      valueTransfers: 'Övergångar värde',
      valueLoans: 'Lån värde',
      avgAgeMovements: 'Rörelser gen. ålder',
      avgAgeTransfers: 'Övergångar gen. ålder',
      avgAgeLoans: 'Lån gen. ålder',
      operations: {
        buys: {
          buy: 'Köp',
          loan: 'Lån',
          'end of loan': 'Lånet slut',
          'free transfer': 'Kontraktslös',
          free: 'Kontraktslös',
          'loan transfer': 'Lån',
          other: 'Övrigt'
        },
        sells: {
          buy: 'Sälj',
          loan: 'Lån',
          'end of loan': 'Lånet slut',
          'free transfer': 'Kontraktslös',
          free: 'Kontraktslös',
          'loan transfer': 'Lån',
          other: 'Övrigt',
          retired: 'Pensionerad'
        }
      }
    },
    trendsTab: {
      streaks: 'Serier',
      wins: 'Vinster',
      cleanSheets: 'Nollor',
      goalPeriods: 'Målperioder gjorda',
      concededGoalPeriods: 'Målperioder insläppta',
      comebacks: 'Comebacks',
      avgTime: 'Genomsnittlig tid',
      kindOfGoals: 'Typ av mål',
      percentWinning: '% Vinst',
      percentDrawing: '% Oavgjort',
      percentLosing: '% Förlust',
      totalOf: 'Totalt',
      minutes: 'minuter',
      before: 'Före',
      after: 'Efter',
      playedOn: 'Spelad den',
      scored: 'Gjorda',
      conceded: 'Insläppta',
      ownGoals: 'Självmål',
      phasesOfGame: 'Spelfaser',
      intensityLabel: 'Zonintensitet',
      intensityByTeam: 'Efter lag %',
      intensityByLeagueAvg: 'Efter ligasnitt %',
      buildup: 'Uppbyggnad',
      midfieldProgression: 'Mittfältsprogression',
      attackOpposition: 'Anfall motståndare',
      attackingTransition: 'Anfallande övergång',
      highPress: 'Hög press',
      midBlock: 'Mittblock',
      lowBlock: 'Lågt block',
      defensiveTransition: 'Defensiv övergång',
      draws: 'Oavgjort',
      losts: 'Förlorat',
      chokes: 'Choke',
      zoneTooltip: 'Bestämmer kriterierna som används för varje blocks färggradient:',
      teamPctTooltip: 'Baserat på procentandelen av den totala tiden som laget spelat i varje zon.',
      leagueAvgPctTooltip: 'Jämför lagets procentandel mot ligagenomsnittet för varje zon.',
      leagueAvgMinsTooltip: 'Tillämpar samma jämförelsekriterier mot ligan, men utvärderar total tid i minuter istället för i procent.',
      losses: 'Förluster',
      results: 'Resultat',
      kindOfConcededGoals: 'Typer av insläppta mål',
      showMinutes: 'Visa protokoll'
    },
    onOff: 'På/Av',
    dragUpToXPlayers: 'Dra upp till {x} spelare',
    selectUpToXPlayers: 'Välj upp till {x} spelare',
    onOffTab: {
      G90: 'Mål 90',
      GA90: 'Mål emot 90',
      diffG90: 'Målskillnad 90',
      XG90: 'xG 90',
      XGA90: 'xG emot 90',
      diffXG90: 'xG skillnad 90',
      playersOn: 'Kombination PÅ',
      playersOff: 'Kombination AV',
      ground: 'Hemmaplan',
      playersOnThePitch: 'Spelare på planen',
      playersOffThePitch: 'Spelare utanför planen',
      attackTitle: 'Anfall',
      attackSubTitle: 'Offensiva statistik',
      defenseTitle: 'Försvar',
      defenseSubTitle: 'Defensiva statistik',
      associationTitle: 'Association',
      associationSubTitle: 'Associativa statistik',
      comboOn: 'Aktiv kombination',
      comboOff: 'Alla andra',
      diffGoals90: 'M skillnad 90',
      goals90: 'Icke-straffmål 90',
      goalsAgainst90: 'Icke-straffmål emot 90',
      xgAgainstPer90: 'xG emot 90',
      xgDiffPer90: 'xG skillnad 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Skott på mål 90',
      touchesOppBox90: 'Toucher motst. box 90',
      shotsOnTargetAgainst90: 'Skott på mål emot 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Direkthet 90',
      possession: 'Bollinnehav %',
      pctPasses: 'Passningar %',
      pctPassesFinalThird: 'Passningar sista tredjedel %',
      placeholder: 'Börja med att välja ett lag',
      subtitle: 'Optimera lagets metriker genom att lägga till eller ta bort spelare från startelvan'
    },
    terms: {
      short: 'Kort sikt',
      mid: 'Medellång sikt',
      long: 'Lång sikt'
    },
    report: {
      title: 'Lagrapport',
      selectedPeriod: 'Vald period',
      stackedCharts: 'Staplade diagram',
      radars: 'Radar',
      generalData: 'Allmänna data',
      scoringChances: 'Målchanser',
      areasReport: 'Områdesrapport',
      setPieceReport: 'Fasta situationer rapport',
      corners: 'Hörnor',
      cornersAgainst: 'Hörnor emot',
      indirectFreeKicks: 'Indirekta frisparkar',
      indirectFreeKicksAgainst: 'Indirekta frisparkar emot',
      freeKicks: 'Frisparkar',
      freeKicksAgainst: 'Frisparkar emot',
      penaltys: 'Straffar',
      freeKicksContribution: 'Frisparkar kontribution',
      shotsContribution: 'Skott kontribution',
      topXPlayersByStats: 'Topp {x} spelare efter statistik',
      lastShotZone: 'Sista zon skott',
      throwSide: 'Inkast sida',
      kindOfThrow: 'Typ av inkast',
      scored: 'Gjorda',
      against: 'Emot',
      perGame: 'per match',
      total: 'Totalt',
      efficiency: 'Effektivitet',
      organizedAttack: 'Organiserat anfall',
      offTransition: 'Anfallande övergång',
      chances: 'Chanser',
      chancesScored: 'Chanser gjorda',
      chancesAgainst: 'Chanser emot',
      goalsScored: 'Mål gjorda',
      goalsAgainst: 'Mål emot',
      goalsOrganizedAttack: 'Mål organiserat anfall',
      goalsOffTransition: 'Mål anfallande övergång',
      goalsSetPiece: 'Mål fasta situationer',
      goalsOrganizedAttackScored: 'Mål org. anfall gjorda',
      goalsOrganizedAttackAgainst: 'Mål org. anfall emot',
      goalsOffTransitionScored: 'Mål anf. övergång gjorda',
      goalsOffTransitionAgainst: 'Mål anf. övergång emot',
      goalsSetPieceScored: 'Mål fasta situationer gjorda',
      goalsSetPieceAgainst: 'Mål fasta situationer emot',
      crossSide: 'Inlägg sida',
      externalShot: 'Externt skott',
      innerPlay: 'Inre spel',
      throwIn: 'Inkast',
      box: 'Box',
      zone2: 'Zon 2',
      goalsPerPhases: 'Mål per faser'
    },
    minutesAlert: '*Visar endast spelare med 450 eller fler minuter spelade',
    minutesException: 'Det finns inga spelare med 450 eller fler minuter spelade. Visar alla spelare',
    analysis: 'Analys',
    substitutions: 'Inhopp',
    attackZones: 'Anfallszoner',
    formations: 'Formationer',
    shotZones: 'Skottzoner',
    crossings: 'Inlägg',
    byTime: 'Efter tid',
    byPosition: 'Efter position',
    byPlayer: 'Efter spelare',
    W: 'Vinst',
    D: 'Oavgjort',
    L: 'Förlust',
    substitutionsByGame: 'Inhopp per match',
    substitutionsShort: 'Inhopp',
    avgSeasonShort: 'Gen. säsong',
    startingAt: 'Börjar vid',
    endingAt: 'Slutar vid',
    startingAtInfo: 'Visar andel bollinnehav baserat på platsen för första händelsen',
    endingAtInfo: 'Visar andel bollinnehav baserat på platsen för sista händelsen',
    endingWithShot: 'Slutar med skott',
    endingInBox: 'Slutar i box',
    pfX: 'PF {x}',
    bySide: 'Efter sida',
    cornerKicks: 'Hörnor',
    included: 'Inkluderad',
    excluded: 'Exkluderad',
    onlyCorner: 'Endast hörna',
    sizeByMarketValue: 'Storlek efter marknadsvärde',
    timeInTeam: 'Säsonger i lag',
    newSignings: 'Nya värvningar',
    sizeBy: 'Storlek efter',
    connections: 'Kopplingar',
    assistant: 'Passare',
    finisher: 'Avslutare',
    playersMinutesAlert: 'Visar endast spelare med minuter spelade i vald säsong',
    strategyFilterTooltip: 'Visa händelserna som hände under fasta spel eller under ett öppet spel',
    sideFilterTooltip: 'Visa endast de fasta bitarna som börjar på den valda sidan (vänster eller höger)',
    teamMinutesAlert: '*Visar endast lag med 450 eller fler minuter spelade',
    homeCoach: 'Hemmetränare',
    awayCoach: 'Borta tränare'
  },
  leagueTable: {
    subtitle: 'Kolla hur ligorna går'
  },
  leagueMatchdays: {
    byRound: 'Efter omgång',
    byDate: 'Efter datum',
    byTeam: 'Efter lag'
  },
  teamStats: {
    subtitle: 'Jämför hur lag presterar',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Skillnad mellan förväntade mål och mål',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Skillnad mellan förväntade poäng och poäng',
    games: 'MAT',
    gamesExplicit: 'Matcher spelade',
    pointsPerGame: 'PPG',
    pointsPerGameExplicit: 'Poäng per match'
  },
  roles: {
    ROLE_USER: 'Användare',
    ROLE_ADMIN: 'Admin',
    ROLE_REPORTS: 'Driblab Reports',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Driblab Physical Data',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Tracking',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: 'Extrahera spelar-, lag-, match- och ligainformation enkelt i JSON-format.',
    ROLE_EVENTING_DATA_description: 'Djupdyk i statistik med radar-diagram, spelarrankningar, kartor och mer baserat på +100 prestationsmetriker.',
    ROLE_PHYSICAL_DATA_description: 'Få tillgång till konditionsdata och filtrera spelare efter olika prestationsmetriker (distans, hastighet, sprintar, acceleration...).',
    ROLE_VIDEO_description: 'Tillhandahåll videor och startelvor och få matcher taggade med händelser och statistik för djupgående analys.',
    ROLE_DRIBLAB_HUB_description: 'Spåra och hantera scoutningsuppgifter effektivt med kalendrar, anteckningar, varningar och dokumentdelning.',
    ROLE_TRACKING_description: 'Ta emot positionsdata för alla spelare i en match via vår API för omfattande analys.',
    ROLE_ARRIGO_description: 'Kombinera event- och trackingdata till innovativa metriker som går bortom det traditionella och lägger värde till varje aktion.',
    ROLE_REPORTS_description: 'Begär detaljerade scoutingrapporter från vårt team av analytiker för att hitta det perfekta laget eller spelaren.',
    ROLE_RAW_EVENTING: 'Raw Eventing'
  },
  administration: {
    pageSubtitle: 'Hantera applikationens drift',
    newClient: 'Ny klient',
    clientDuplicateName: 'En klient med detta namn finns redan. Välj klienten i listan och använd «Ny användare» för att lägga till användare där.',
    newUser: 'Ny användare',
    editClient: 'Redigera klient',
    editUser: 'Redigera användare',
    clientName: 'Namn',
    permissions: 'Behörigheter',
    releaseUser: 'Släpp användare',
    connectAsUser: 'Anslut som användare',
    releaseModalTitle: 'Bekräfta släpp användare',
    releaseModalMessage: 'Användaren kommer att få ett e-postmeddelande om sitt nya konto. Är du säker på att du vill meddela honom?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Lag',
      Brand: 'Varumärke',
      Federation: 'Förbund',
      Media: 'Media',
      Agency: 'Agentur',
      Individual: 'Individuell'
    },
    userType: {
      Ownership: 'Ägande',
      SportingDirector: 'Sportchef',
      Brand: 'Varumärke',
      Federation: 'Förbund',
      Media: 'Media',
      Agency: 'Agentur',
      Individual: 'Individuell',
      Scout: 'Scout',
      Coach: 'Tränare',
      supervision: {
        title: 'Tillsynshierarki',
        subtitle: 'Övervakningen flyter bara nedåt. Tillsyn på samma nivå är inte tillåten.',
        supervisesLowerLevels: 'Övervakar alla roller nedan',
        ruleNoSameLevel: 'Roller på samma nivå kan inte övervaka varandra.',
        ruleOnlyDownwards: 'Handledning är endast tillåten från högre till lägre roller.',
        ruleLevel3NoSupervision: 'Den lägsta nivån har inga övervakningsbehörigheter.',
        currentUserType: 'Din nuvarande användartyp'
      }
    },
    visibleYears: 'Synliga år',
    areaModalTitle: 'Aktivera/Inaktivera ligor bekräftelse',
    areaModalMessage: 'Är du säker på att aktivera/inaktivera alla ligor från valt område?',
    countStats: 'Räkna statistik',
    userClientModalTitle: 'Användare finns redan i en annan klient',
    eventing: 'Eventhantering',
    hub: 'Hub',
    contract: 'Kontrakt',
    contracts: 'Kontrakt',
    invoiceName: 'Fakturanamn',
    contractFee: 'Kontraktsavgift',
    renewal: 'Förnyelse',
    consultancy: 'Konsulttjänst',
    deleteContract: 'Ta bort klientkontrakt',
    deleteContractMessage: 'Kontraktet kommer att tas bort permanent. Är du säker?',
    activeVsHired: 'Aktivt vs Anställt',
    requestedVsHired: 'Begärt vs Anställt',
    activeVsHiredWithPlaceholder: '{0} Aktiv vs {1} Anställd',
    requestedVsHiredWithPlaceholder: '{0} Begärd vs {1} Anställd',
    salesRepresentative: 'Försäljningsrepresentant',
    periodicities: {
      periodicity: 'Periodicitet',
      annual: 'Årlig',
      biannual: 'Två gånger per år',
      quarterly: 'Kvartalsvis',
      monthly: 'Månadsvis',
      bimonthly: 'Varannan månad',
      onePayment: 'En betalning',
      fourmonthly: 'Var fjärde månad'
    },
    paymentMethods: {
      payment: 'Betalning',
      method: 'Metod',
      transfer: 'Överföring',
      mandate: 'Mandat'
    },
    marketingOptions: {
      marketing: 'Marknadsföring',
      socialMediaAdd: 'Sociala medier-annons',
      videoWithFeedback: 'Video med feedback'
    },
    status: {
      status: 'Status',
      pending: 'Väntande',
      active: 'Aktiv',
      expiringSoon: 'Går snart ut',
      expired: 'Utgången',
      expiringSoonWithDays: 'Kontraktet går snart ut: {0} dagar kvar'
    },
    updates: {
      roleAdded: '<b>{0}</b> lade till rollen <b>{1}</b> till <b>{2}</b>.',
      roleRemoved: '<b>{0}</b> tog bort rollen <b>{1}</b> från <b>{2}</b>.',
      leagueAdded: '<b>{0}</b> lade till <b>{1}</b> i ligan <b>{2}</b>.',
      leagueRemoved: '<b>{0}</b> tog bort <b>{1}</b> från ligan <b>{2}</b>.',
      seasonAdded: '<b>{0}</b> lade till <b>{1}</b> i säsongen <b>{2}</b>.',
      seasonRemoved: '<b>{0}</b> tog bort <b>{1}</b> från säsongen <b>{2}</b>.',
      updateNotesPlaceholder: 'Vänligen inkludera sammanhang för ändringen eller lägg till relevanta anteckningar här...',
      updates: 'Uppdateringar',
      products: 'Produkter'
    },
    clients: 'Kunder',
    trials: 'Rättegångar',
    activeClients: 'Aktiva kunder',
    activeTrials: 'Aktiva försök',
    activeTrialUsers: 'Aktiva testanvändare',
    activeContracts: 'Aktiva kontrakt',
    expiration: 'Utgång',
    clientWarnings: {
      activeContractInactiveClient: 'Kunder med aktiva kontrakt men inga aktiverade användare',
      activeContractTrialUsers: 'Klienter med provanvändare medan ett kontrakt är aktivt',
      activeUsersWithoutContract: 'Klienter med aktiva icke-provanvändare men inget aktivt kontrakt',
      upcomingExpirations: 'Kommande utgångsdatum',
      renewedContracts: 'Kunder under förnyade kontrakt',
      clientsWithWarnings: 'Kunder som kräver uppmärksamhet',
      enabledUsersWithoutContract: '"Aktiverade icke-testanvändare utan ett aktivt kontrakt"',
      trialUsersWithContract: 'Användare i testläge trots ett aktivt kontrakt',
      activeContractInactiveUsers: 'Kunden har ett aktivt kontrakt med alla användare som är inaktiva',
      activeContract: 'Denna kund har ett aktivt kontrakt',
      noEnabledUsers: 'Den här klienten har inga aktiverade användare',
      ongoingTrialInactiveUsers: 'Klienter med en pågående testperiod men inga aktiverade användare',
      neverLoggedIn: 'Klienter som aldrig har loggat in'
    },
    daysLeft: 'Dagar kvar',
    expiringSoon: 'Går snart ut',
    loggedThisWeek: 'Loggade in denna vecka',
    withWarnings: 'Med varningar',
    ofActiveClients: 'av aktiva kunder',
    endingIn30Days: 'slutar om 30 dagar',
    neverLogged: 'aldrig inloggad',
    ofActiveTrials: 'av aktiva försök',
    activeClientsWithoutTrial: 'aktiva kunder (exkl. provperiod)',
    renewals: 'Förnyelser',
    ofActiveContracts: 'av aktiva kontrakt'
  },
  dashboards: {
    lastGame: 'Senaste matchanalys',
    lastGameSimple: 'Senaste match',
    seeAllGameInfo: 'Se all matchinformation',
    nextGame: 'Nästa matchförhandsvisning',
    myTeam: 'Mitt lag',
    lastMatchdayGames: 'Senaste omgången',
    lastAdded: 'Senast tillagda',
    myFavorites: 'Mina favoriter',
    seeAllFavorites: 'Se alla favoriter',
    placeholderFavorites: 'Du kan lägga till favoriter från spelardetaljer',
    placeholderTeamFavorites: 'Du kan lägga till favoriter från lagdetaljer',
    placeholderLeagueFavorites: 'Du kan lägga till favoriter från ligadetaljer',
    myCollections: 'Mina samlingar',
    placeholderCollections: 'Du har inga samlingar ännu',
    lastCreated: 'Senast skapade',
    seeAllCollections: 'Se alla samlingar',
    seeRival: 'Se motståndare',
    seeMyTeam: 'Se mitt lag',
    title: 'Dashboardöversikt',
    subtitle: 'Välkommen tillbaka',
    recentPlayers: 'Senaste spelare',
    lastScouted: 'Senast scoutade',
    scout: 'Scout',
    reportsRequested: 'Rapporter',
    lastRequested: 'Senast begärda',
    goInbox: 'Gå till inkorg',
    placeholderLastScouted: 'Du kan söka efter spelare i vänsterfältet eller i scoutverktyget',
    placeholderReports: 'Du kan begära rapporter från spelardetaljer',
    nationalPlayers: 'Mest värdefulla nationella spelare i andra länder',
    lastGames: 'Senaste matcher',
    nationalPlayersShort: 'Nationella spelare i andra länder',
    nextMatchdayGames: 'Nästa omgång',
    injuredPlayers: 'Skadade spelare',
    atPresent: 'För närvarande',
    seeAllPlayers: 'Se alla spelare',
    suspendedPlayers: 'Avstängda spelare',
    placeholderInjured: 'Det finns inga skadade spelare',
    teamValueImpacted: 'Lagvärde påverkat',
    placeholderSuspended: 'Det finns inga avstängda spelare',
    placeholderNextGame: 'Det finns ingen tillgänglig match',
    placeholderNoGames: 'Det finns inga matcher tillgängliga ännu',
    placeholderLastMatchDayNotFound: 'Senaste omgången inte tillgänglig',
    placeholderNextMatchDayNotFound: 'Nästa omgång inte tillgänglig',
    usersMostSearch: 'Användare med flest sökningar',
    lastTwoDays: 'Senaste två dagarna',
    searchesHistory: 'Sökhistorik',
    dayByDay: 'Dagligen',
    activeUsersTitle: 'Aktiva användare',
    activeUsersSubtitle: 'Inloggade minst en gång senaste månaden',
    onlineUsersTitle: 'Online användare',
    onlineUsersSubtitle: 'Sökt något senaste timmen',
    searchesPerformed: 'Gjorda sökningar',
    onlyClients: 'Endast klienter',
    activeClientsTitle: 'Aktiva klienter',
    activeClientsSubtitle: 'Har minst en aktiv användare',
    last24Hours: 'Senaste 24 timmarna',
    activityHistory: 'Aktivitetshistorik',
    loginHistory: 'Åtkomsthistorik',
    failLogins: 'Misslyckade åtkomster',
    successLogins: 'Lyckade åtkomster',
    clientStats: 'Klientstatistik',
    playersMostSearch: 'Spelare med flest sökningar',
    toolsMoreUsed: 'Mest använda verktyg',
    hotPlayers: 'Populära spelare',
    last_month: 'Senaste månaden',
    last_week: 'Senaste veckan',
    last_day: 'Senaste dagen',
    nClients: 'Antal klienter',
    userDashboard: 'Användardashboard',
    userDashboardSubtitle: 'Kontoaktivitetsöversikt',
    offlineDaysOfClient: 'Offlinedagar för varje klient',
    hideNoConnected: 'Dölj ej anslutna',
    onlyTrial: 'Endast provklienter',
    daysWithoutLogin: 'Dagar utan inloggning',
    trialDays: 'Provdagar'
  },
  faq: {
    subtitle: 'Lär dig mer om vad Driblab PRO är',
    categories: {
      playerMetrics: 'Spelarmätvärden',
      teamMetrics: 'Lagmätvärden',
      positions: 'Lagpositioner',
      tools: 'Verktyg',
      api: 'API',
      videos: 'Handledningar',
      playerPositions: 'Spelarpositioner',
      userTypes: 'Användartyper'
    },
    positions: {
      GK: 'Målvakt',
      DR: 'Högerback / Höger försvarare (RB)',
      DC: 'Mittback / Central försvarare (CB)',
      DL: 'Vänsterback / Vänster försvarare (LB)',
      DMR: 'Höger vingback (RWB)',
      DMC: 'Defensiv mittfältare (CDM)',
      DML: 'Vänster vingback (LWB)',
      MR: 'Höger mittfältare (RM)',
      MC: 'Central mittfältare (CM)',
      ML: 'Vänster mittfältare (LM)',
      AMR: 'Offensiv mittfältare höger / Höger ytter (RW)',
      AMC: 'Offensiv mittfältare central / Avancerad mittfältare',
      AML: 'Offensiv mittfältare vänster / Vänster ytter (LW)',
      FWR: 'Anfallare höger / Höger anfallare (RS)',
      FW: 'Anfallare / Centerforward (ST)',
      FWL: 'Anfallare vänster / Vänster anfallare (LS)'
    },
    metrics: {
      categories: {
        Association: 'Samarbete',
        Saving: 'Räddningar',
        Shooting: 'Skott',
        Defending: 'Försvar',
        Passing: 'Passningar',
        BallHandling: 'Bollhantering',
        Aerial: 'Luftspel',
        Physical: 'Fysiskt',
        Predictive: 'Prediktivt',
        Arrigo: 'Arrigo',
        Score: 'Poäng',
        Turnovers: 'Bollförluster',
        Carries: 'Bärningar',
        SequenceInvolvement: 'Sekvensinvolvering',
        Crosses: 'Inlägg',
        Distance: 'Distans',
        Sprint: 'Sprint',
        Acceleration: 'Acceleration',
        MaxAcceleration: 'Max acceleration',
        Speed: 'Hastighet',
        OutPlay: 'Överlistning',
        LineBreakingPasses: 'Linjebrytande passningar',
        LineBreakingCarries: 'Linjebrytande bärningar',
        LineBreakingActions: 'Linjebrytande handlingar',
        PassUnderPressure: 'Passning under tryck',
        BallReceived: 'Bollmottagningar',
        PassesUnderPressure: 'Passerar Under Tryck',
        OnBallPressureReceived: 'Tryck på boll mottaget',
        OnBallPressure: 'Tryck på boll',
        BallReceiptsInSpace: 'Bollmottagning i Rymd',
        SpatialCoverage: 'Rumslig täckning',
        OffBallPressure: 'Tryck utan boll',
        OffBallRuns: 'Löpningar utan boll',
        NoCategory: 'Övrigt',
        subcategories: {
          Quality: 'Kvalitet',
          Quantity: 'Kvantitet',
          TeamComparison: 'Lagjämförelse',
          Receptions: 'Mottagningar',
          LongBalls: 'Långa bollar',
          Efficiency: 'Effektivitet',
          Ratio: 'Förhållande',
          Defensive: 'Defensivt',
          Offensive: 'Offensivt',
          Foot: 'Fot',
          Progression: 'Framsteg',
          TopValue: 'Toppvärde',
          Predictive: 'Prediktivt',
          Distance: 'Distans',
          Aerial: 'Luftspel',
          Crosses: 'Inlägg',
          NoCategory: 'Övrigt'
        },
        desc: {
          Association: 'Samarbete',
          Saving: 'Räddningar',
          Shooting: 'Skott',
          Defending: 'Försvar',
          Passing: 'Passningar',
          BallHandling: 'Bollhantering',
          Aerial: 'Luftspel',
          Physical: 'Fysiskt',
          Predictive: 'Prediktivt',
          Arrigo: 'Arrigo',
          Score: 'Poäng',
          Turnovers: 'Bollförluster',
          Carries: 'Bärningar',
          SequenceInvolvement: 'Sekvensinvolvering',
          Crosses: 'Inlägg',
          Distance: 'Distans täckt i olika hastigheter',
          Sprint: 'Sprint i olika hastigheter',
          Acceleration: 'Acceleration',
          Speed: 'Hastighet uppnådd av spelare vid någon tidpunkt under matchen',
          OutPlay: 'Överlistning',
          LineBreakingPasses: 'Linjebrytande passningar',
          LineBreakingCarries: 'Linjebrytande bärningar',
          LineBreakingActions: 'Linjebrytande handlingar',
          PassUnderPressure: 'Passning under tryck',
          BallReceived: 'Bollmottagningar',
          OnBallPressureReceived: 'Tryck på boll mottaget',
          OnBallPressure: 'Tryck på boll',
          BallReceiptsInSpace: 'Bollmottagning i Rymd',
          SpatialCoverage: 'Rumslig täckning',
          OffBallPressure: 'Tryck utan boll',
          OffBallRuns: 'Löpningar utan boll',
          HandPassing: 'Passningar gjorda med handen av målvakter eller kasta in dödspel'
        },
        abbr: {
          Association: 'Samarbete',
          Saving: 'Räddningar',
          Shooting: 'Skott',
          Defending: 'Försvar',
          Passing: 'Passningar',
          BallHandling: 'Bollh.',
          Aerial: 'Luftspel',
          Physical: 'Fysiskt',
          Predictive: 'Prediktivt',
          Arrigo: 'Arrigo',
          Score: 'Poäng',
          Turnovers: 'BF',
          Carries: 'Bärningar',
          SequenceInvolvement: 'Sekv. involv.',
          Crosses: 'Inlägg',
          Distance: 'Distans',
          Sprint: 'Sprint',
          Acceleration: 'Acceleration',
          MaxAcceleration: 'Max. acceleration',
          Speed: 'Hastighet',
          OutPlay: 'Överlistning',
          LineBreakingPasses: 'Linjebrytande passningar',
          LineBreakingCarries: 'Linjebrytande bärningar',
          LineBreakingActions: 'Linjebrytande handlingar',
          PassUnderPressure: 'Passning under tryck',
          BallReceived: 'Bollmottagningar',
          OnBallPressureReceived: 'Tryck på boll mottaget',
          OnBallPressure: 'Tryck på boll',
          BallReceiptsInSpace: 'Bollmottagning i Rymd',
          SpatialCoverage: 'Rumslig täckning',
          OffBallPressure: 'Tryck utan boll',
          OffBallRuns: 'Löpningar utan boll',
          HandPassing: 'Hand som passerar'
        },
        HandPassing: 'Hand som passerar'
      },
      types: {
        1: 'Per 90',
        2: 'Procent',
        3: 'Frekvens',
        4: 'Effektivitet',
        5: 'Genomsnitt',
        6: 'Per match',
        7: 'Skillnad',
        8: 'Max'
      },
      moreInfo: 'Du kan läsa mer här'
    },
    api: {
      subtitle: 'Hämta data från olika förfrågningar',
      resourcesTitle: 'Resurser',
      authentication: 'Autentisering',
      authText: 'För att anropa API:et måste du inkludera i varje förfrågan headern `Authorization` med värdet `Bearer {API_TOKEN}`',
      generate: 'Generera',
      tokenPlaceholder: 'Om du inte har en token eller om den har gått ut, klicka på \'Generera\'',
      pathParameters: 'Sökvägsparametrar',
      queryParameters: 'Förfrågningsparametrar',
      responseModel: 'Svarsmodell',
      tokenWarning: '* Generera en token för att använda API:et',
      pathParamsWarning: '* Det finns ofyllda sökvägsparametrar',
      genericDescription: 'Ett API (Application Programming Interface) gör det möjligt för utvecklare att komma åt och integrera data eller funktionalitet i sina egna applikationer. Vårt fotbollsstatistik-API ger omfattande åtkomst till en mängd datapunkter om länder, tävlingar, lag, spelare, matcher med mera. Genom att använda detta API kan du bygga applikationer som utnyttjar vår rika fotbollsdata för analyser, visualiseringar eller andra innovativa lösningar.',
      methods: {
        getAllCountries: 'Denna metod hämtar en komplett lista över alla länder som finns tillgängliga i API:et, med viktiga detaljer som varje lands unika identifierare och namn. Denna endpoint är idealisk för applikationer som kräver geografisk fotbollsdata, vilket möjliggör funktioner som landval, filtrering och analyser. Den fungerar också som en grundläggande resurs för interaktion med andra endpoints som är beroende av en `countryId`-parameter, vilket säkerställer smidig navigering och integration med API:ets bredare dataset.',
        getCountryDetail: 'Denna metod ger detaljerad information om ett specifikt land som finns tillgängligt i API:et. Genom att använda denna endpoint kan du hämta data som landets namn, kod och all relevant metadata som är kopplad till det. Denna metod är särskilt användbar för applikationer som kräver landspecifika detaljer för att förbättra användarupplevelsen, såsom att visa kontextuell information eller skapa skräddarsydda insikter baserat på geografiska data. Den kompletterar andra endpoints genom att tillåta djupare utforskning av ett valt land.',
        getCountryCompetitions: 'Denna metod hämtar en lista över alla tävlingar som finns tillgängliga inom ett specifikt land. Det är en värdefull resurs för att bygga funktioner som låter användare utforska tävlingar per region, vilket ger ett sömlöst sätt att koppla landdata med dess associerade turneringar. Denna endpoint är väsentlig för applikationer som fokuserar på lokaliserat fotbollsinnehåll eller regionala analyser.',
        getAllCompetitionTypes: 'Denna metod returnerar en lista över alla tävlingstyper som finns tillgängliga i API:et, såsom ligor, cuper och internationella turneringar. Denna endpoint är idealisk för att kategorisera tävlingar och ge användare en organiserad vy över de olika typerna av evenemang som täcks. Den är särskilt användbar för att bygga funktioner som filter eller rullgardinsmenyer som låter användare utforska fotbollsdata baserat på tävlingens karaktär.',
        getAllCompetitions: 'Denna metod hämtar en omfattande lista över alla tävlingar som finns tillgängliga i API:et, oavsett typ eller plats. Denna endpoint är användbar för applikationer som behöver visa eller analysera ett brett spektrum av fotbollstävlingar, vilket låter användare utforska och välja evenemang av intresse.',
        getCompetitionAvailable: 'Denna metod hämtar en lista över tävlingar som för närvarande är markerade som tillgängliga i API:et. Detta säkerställer att returnerad data är uppdaterad och redo att användas i applikationer. Den är särskilt användbar för utvecklare som bygger funktioner som förlitar sig på aktiva eller tillgängliga tävlingar, vilket gör det möjligt för användare att utforska relevanta evenemang utan att stöta på föråldrad eller ofullständig data.',
        getCompetitionDetail: 'Denna metod ger detaljerad information om en specifik tävling som finns tillgänglig i API:et. Den är särskilt användbar för applikationer som kräver djupgående information om en tävling, vilket möjliggör funktioner som detaljerade vyer, kontextuella insikter eller filtreringsalternativ baserat på tävlingens egenskaper.',
        getCompetitionSeasons: 'Denna metod hämtar en lista över alla säsonger som är associerade med en specifik tävling. Denna endpoint är väsentlig för applikationer som syftar till att ge omfattande täckning av en tävlings historia eller nuvarande tillstånd, vilket låter användare utforska data säsong för säsong.',
        getSeasonAvailable: 'Denna metod ger en lista över säsonger som för närvarande är markerade som tillgängliga i API:et. Den är särskilt användbar för applikationer som fokuserar på live eller pågående fotbollsevenemang, vilket låter användare interagera med relevant och aktuell säsongsdata.',
        getSeasonDetail: 'Denna metod hämtar detaljerad information om en specifik säsong, inklusive dess tidslinje, associerad tävling och viktig metadata. Denna endpoint är väsentlig för applikationer som kräver djupgående insikter i en viss säsong, vilket möjliggör funktioner som säsongsöversikter, filtrering per tävling eller visning av detaljerade tidslinjer för användarinteraktion.',
        getSeasonTeams: 'Denna metod ger en lista över alla lag som deltar i en specifik säsong. Den är idealisk för funktioner som trupphantering, lagprestationsanalys eller att skapa säsongsspecifika filter för användare.',
        getSeasonPlayer: 'Denna metod hämtar en lista över alla spelare som är registrerade i en specifik säsong. Den är idealisk för att bygga funktioner som spelartrupper, prestationsspårning eller filtrering av spelare baserat på den valda säsongen.',
        getSeasonPlayerStats: 'Denna metod ger detaljerad statistik för alla spelare i en specifik säsong. Den är särskilt användbar för applikationer som fokuserar på analyser, spelarjämförelser eller att skapa dynamiska visualiseringar av säsongslånga spelarprestationer.',
        getSeasonArrigoMetrics: 'Denna metod ger kombinerad statistik för alla spelare i en specifik säsong. Den är särskilt användbar för applikationer som fokuserar på analyser, spelarjämförelser eller att skapa dynamiska visualiseringar av säsongslånga spelarprestationer.',
        getSeasonTeamStats: 'Denna metod ger omfattande statistik för alla lag som deltar i en specifik säsong. Den är särskilt användbar för applikationer som fokuserar på laganalys, säsongssammanfattningar eller jämförelser av lagprestationer under hela säsongen.',
        getSeasonCoaches: 'Denna metod hämtar en lista över alla tränare som ledde lag under en specifik säsong. Den är särskilt användbar för applikationer som fokuserar på säsongsinsikter, träningsanalys eller spårning av förändringar i lagledning under en säsong.',
        getSeasonGames: 'Denna metod ger en lista över alla matcher som spelades i en specifik säsong. Den är idealisk för applikationer som behöver visa fullständiga säsongsscheman, analysera matchresultat eller ge användare tillgång till omfattande säsongsmatcher.',
        getSeasonGamesMatchday: 'Denna metod hämtar alla matcher för en specifik omgång inom en given säsong. Den är särskilt användbar för applikationer som syftar till att visa omgångsscheman, analysera specifika omgångar eller ge fokuserade insikter i en viss uppsättning matcher under säsongen.',
        getSeasonLeagueTable: 'Denna metod ger ligatabellen för en specifik säsong, inklusive ranking, poäng, vinster, oavgjorda, förluster och annan relevant statistik för varje lag. Denna endpoint är väsentlig för applikationer som fokuserar på att spåra lagplaceringar, analysera ligaframsteg eller presentera användare med uppdaterade rankingar under hela säsongen.',
        getTeamDetail: 'Denna metod ger detaljerad information om ett specifikt lag, inklusive dess namn, grundår, arena och annan metadata. Denna endpoint är idealisk för applikationer som kräver lagspecifika insikter, vilket möjliggör funktioner som detaljerade lagprofiler, historisk kontext eller förbättrade användarupplevelser med rik lagrelaterad data.',
        getTeamLoans: 'Denna metod hämtar information om lånetransaktioner som involverar ett specifikt lag. Denna endpoint är särskilt användbar för applikationer som fokuserar på transferanalys, lagtrupphantering eller spårning av spelarrörelser under en säsong.',
        getTeamRoster: 'Denna metod ger en komplett lista över spelare i ett specifikt lags trupp. Den är idealisk för applikationer som behöver visa laguppställningar, analysera spelarroller eller hantera trupprelaterade funktioner för ett lag.',
        getTeamGames: 'Denna metod hämtar en lista över alla matcher som ett specifikt lag har spelat. Den är särskilt användbar för applikationer som fokuserar på lagprestation, schemaspårning eller ger användare tillgång till ett lags kompletta matchhistorik.',
        getTeamGameStats: 'Denna metod ger detaljerad statistik för ett specifikt lag i en given match. Den är särskilt användbar för applikationer som fokuserar på matchanalys, prestationsutvärderingar eller djupgående uppdelningar av ett lags prestation i individuella matcher.',
        getTeamTransfers: 'Denna metod hämtar information om transfertransaktioner som involverar ett specifikt lag. Den är särskilt användbar för applikationer som fokuserar på transfermarknadsanalys, lagtruppförändringar eller spårning av spelarrörelser över tid.',
        getGameStatus: 'Denna metod ger en lista över alla möjliga matchstatusar som finns tillgängliga i API:et, såsom schemalagd, pågående, slutförd, uppskjuten eller inställd. Denna endpoint är särskilt användbar för applikationer som kräver realtidsmatchspårning, filtrering av matcher per status eller ger användare tydliga uppdateringar om en matchs framsteg eller tillstånd.',
        getPlayerPositions: 'Denna metod returnerar en lista över alla möjliga spelarpositioner, såsom målvakt, försvarare, mittfältare och anfallare. Denna endpoint är särskilt användbar för applikationer som kategoriserar spelare, analyserar positionsdata eller låter användare filtrera spelare baserat på deras roller på planen.',
        getGameDetail: 'Denna metod ger omfattande information om en specifik match, inklusive detaljer som deltagande lag, datum och tid, arena, resultat och annan viktig metadata. Denna endpoint är idealisk för applikationer som kräver djupgående matchinsikter, vilket möjliggör funktioner som detaljerade matchförhandsvisningar, rapporter eller analyser.',
        getGameStats: 'Denna metod ger detaljerad statistik för en specifik match, inklusive mätvärden som mål, skott, bollinnehavsprocent, passningar och defensiva handlingar. Denna endpoint är särskilt användbar för applikationer som fokuserar på matchanalys, eftermatcherrapporter eller visualiseringar av lagprestationer under en match.',
        getGamePlayerStats: 'Denna metod hämtar detaljerad prestationsstatistik för alla spelare som deltog i en specifik match. Den är särskilt användbar för applikationer som analyserar individuella spelarprestationer, genererar matchrapporter eller jämför spelare inom en enda matchkontext.',
        getGamePlayerPhysicalStats: 'Denna metod ger detaljerade fysiska prestationsmätvärden för spelare i en specifik match. Den är särskilt användbar för applikationer som fokuserar på spelarfitnessanalys, fysisk prestationsspårning eller generering av detaljerade matchinsikter för individuella spelare.',
        getGameTeamPhysicalStats: 'Denna metod ger detaljerade fysiska prestationsmätvärden för lag i en specifik match. Detta inkluderar data som totalt täckt avstånd, antal sprinter, höghastighetslöpningar och andra fysiska attribut. Den är särskilt användbar för applikationer som fokuserar på lagfitnessanalys, jämförelse av fysiska ansträngningar mellan lag eller utvärdering av övergripande prestation i en match.',
        getGamePlayerArrigoMetrics: 'Denna metod ger detaljerade arrigo-mätvärden för spelare i en specifik match. Den är särskilt användbar för applikationer som fokuserar på att analysera och generera detaljerade insikter om spelare i en match.',
        getGameTeamArrigoMetrics: 'Denna metod ger detaljerade arrigo-mätvärden för lag i en specifik match. Detta inkluderar data som passerade spelare och andra attribut. Den är särskilt användbar för applikationer som fokuserar på att analysera och utvärdera övergripande prestation i en match.',
        getGameLineup: 'Denna metod hämtar uppställningen för en specifik match, inklusive startspelare, inhoppare och deras respektive positioner. Denna endpoint är särskilt användbar för applikationer som visar förmatchsinformation, analyserar lagformationer eller ger insikter i taktiska beslut som lagen har fattat för en given match.',
        getGameTimeline: 'Denna metod ger en kronologisk lista över händelser som inträffade under en specifik match. Den är särskilt användbar för applikationer som erbjuder live matchuppdateringar, eftermatchersammanfattningar eller detaljerade analyser av matchhändelser.',
        getGameTracking: 'Denna metod ger en länk för att ladda ner spårningsdatafilen för en specifik match. Denna fil innehåller detaljerad rörelse- och positionsdata för spelare och bollen under hela matchen. Den är särskilt användbar för applikationer som fokuserar på avancerad analys, taktisk analys eller att skapa visualiseringar av spelar- och bollrörelser under matchen.',
        getTrackingStatus: 'Denna metod returnerar en komplett lista över alla tillstånd som finns tillgängliga i spårningen, med viktiga detaljer som den unika identifieraren och namnet på varje tillstånd. Denna endpoint är idealisk för applikationer som kräver matchspårning, vilket möjliggör funktioner som tillståndsval, filtrering och analys. Den fungerar också som en kritisk resurs för interaktion med andra endpoints som är beroende av en `statusId`-parameter, vilket säkerställer sömlös navigering och integration med API:ets bredare dataset.',
        getPlayerTransfersTypes: 'Denna metod hämtar en lista över möjliga spelartransfertyper, såsom permanent transfer, lån, fri transfer eller utbyte. Denna endpoint är särskilt användbar för applikationer som analyserar transfermarknadstrender, kategoriserar spelarrörelser eller ger användare detaljerade insikter i typerna av transaktioner som involverar spelare.',
        getPlayerDetail: 'Denna metod ger detaljerad information om en specifik spelare, inklusive personliga detaljer, karriärstatistik och nuvarande lagtillhörighet. Denna endpoint är idealisk för applikationer som erbjuder spelarprofiler, historiska insikter eller analyser av individuella spelarprestationer och karriärbanor.',
        getPlayerGames: 'Denna metod hämtar en lista över alla matcher som en specifik spelare har deltagit i. Den är särskilt användbar för applikationer som fokuserar på spelarprestationsspårning, matchhistorikanalys eller ger användare omfattande matchloggar för individuella spelare.',
        getPlayerInjuries: 'Denna metod ger en detaljerad registrering av skador som en specifik spelare har ådragit sig. Den är särskilt användbar för applikationer som fokuserar på spelarhälsanalys, karriärpåverkanutvärderingar eller spårning av återhämtningstidslinjer.',
        getPlayerNationalTeam: 'Denna metod hämtar detaljerad information om en spelares deltagande i landslagsmatcher. Den är särskilt användbar för applikationer som fokuserar på spelarprestationer på landslagsnivå, spårning av internationella karriärer eller ger insikter i bidrag under turneringar och träningsmatcher.',
        getPlayerSeasons: 'Denna metod ger en lista över alla säsonger där en specifik spelare har deltagit. Den är särskilt användbar för applikationer som spårar en spelares karriärframsteg, analyserar prestationer över säsonger eller ger historisk kontext för deras prestationer.',
        getPlayerTransfers: 'Denna metod hämtar en detaljerad historia av transfertransaktioner som involverar en specifik spelare. Den är särskilt användbar för applikationer som fokuserar på spelarkarriäranalys, transfermarknadsinsikter eller spårning av spelarrörelser mellan lag över tid.',
        getPlayerSeasonTeamStats: 'Denna metod ger detaljerad prestationsstatistik för en specifik spelare under en viss säsong med ett lag. Den är särskilt användbar för applikationer som fokuserar på säsongslång spelaranalys, jämförelser över lag eller säsonger och spårning av individuella bidrag till lagframgång.',
        getPlayerSeasonPhysicalStats: 'Denna metod ger detaljerade fysiska prestationsmätvärden för en specifik spelare under en säsong. Den är särskilt användbar för applikationer som fokuserar på spelarfitnessspårning, fysisk prestationsanalys eller bedömning av en spelares arbetsbelastning under en säsong.',
        getPlayerSeasonGamePhysicalStats: 'Denna metod ger detaljerade fysiska prestationsmätvärden för en specifik spelare på match-för-match-basis inom en säsong. Den är särskilt användbar för applikationer som fokuserar på matchspecifik fitnessanalys, spårning av spelararbetsbelastning eller jämförelse av fysiska prestationer över olika matcher.',
        getPlayerSeasonGameStats: 'Denna metod hämtar detaljerad prestationsstatistik för en specifik spelare på match-för-match-basis inom en säsong. Den är särskilt användbar för applikationer som fokuserar på matchspecifik spelaranalys, prestationstrender eller detaljerade jämförelser över matcher inom en säsong.',
        getCoachDetail: 'Denna metod ger detaljerad information om en specifik tränare, inklusive deras namn, karriärhistoria, lag som de har lett och anmärkningsvärda prestationer. Denna endpoint är särskilt användbar för applikationer som belyser tränarprofiler, spårar ledarkarriärer eller analyserar tränares påverkan på lagprestationer.',
        getCoachHistory: 'Denna metod hämtar en omfattande historia av en specifik tränares karriär, inklusive lag som de har lett, tävlingar de har deltagit i och deras tjänstgöringstider. Denna endpoint är särskilt användbar för applikationer som fokuserar på att analysera tränarkarriärer, spåra ledarförändringar eller ge insikter i en tränares professionella resa och prestationer.',
        getGameEventing: 'Denna metod tillhandahåller alla händelser',
        getLinkStream: 'Den här metoden hämtar länken för att titta på spelvideo',
        getLinkDownload: 'Denna metod hämtar länken för att ladda ner spelvideo',
        getGameTs: 'Denna metod ger den sista tidsstämpeln i en specifik matchning',
        getGameFileTypes: 'Denna metod tillhandahåller filtyperna för matchning',
        deletePlayer: 'This method delete a player',
        getGeneralPositions: 'Denna metod returnerar en lista över möjliga allmänna positioner, såsom målvakt, försvarare, mittfältare och forward.',
        getPercentiles: 'Denna metod ger alla tillgängliga percentiler',
        getPlayerPercentilesEventing: 'Denna metod ger all statistik för en specifik percentil och position'
      },
      responseCodes: 'Svarskoder',
      furtherInformation: 'För ytterligare information, läs vår API-dokumentation',
      clipboard: 'Kopierat till urklipp!',
      limit50: 'Visar bara de första 50 resultaten'
    }
  },
  globalSearch: {
    subtitle: 'Djupfiltrering'
  },
  global: {
    teamElos: {
      title: 'LIGAELO\'S',
      subtitle: 'Få insikter från ligastyrketrender och rankningar världen över.',
      team: 'Liga',
      teams: 'Ligor',
      dates: 'Datum',
      excludeInternational: 'Exkludera internationella tävlingar',
      elo: 'ELO',
      selectButton: 'Välj Top',
      selectTeamFromTable: 'Välj lag från tabellen för att visa ELO-trend.',
      showingTeamAveragesLastSeason: 'Visar endast ligagenomsnitt för deras senaste aktiva säsong',
      showingTeamStatsLastSeason: 'Visar endast lagstatistik för deras senaste aktiva säsong',
      searchToolTip: 'Tips: Tryck på Ctrl + B för att få direkt tillgång till sökfältet',
      selectTopTooltip: 'Visa ytterligare lag i diagrammet för jämförelse',
      loadingPage: 'Förbereder data...'
    },
    leagueElos: {
      title: 'LIGAELO\'S',
      subtitle: 'Globala ligarangeringar och analyser',
      rankings: 'RANKINGAR',
      insights: 'INSIKTER',
      filters: 'FILTER',
      leagues: 'Ligor',
      from: 'Från',
      to: 'Till',
      elo: 'ELO',
      change: 'Förändring',
      league: 'Liga',
      excludeContinental: 'Exkludera internationella tävlingar',
      eloTrend: 'ELO-trend',
      eloRanking: 'ELO-ranking',
      currentELOLabel: '(Nuvarande ELO)',
      allTime: 'Alla tider',
      average: 'Genomsnitt',
      noChartData: 'Ingen diagramdata tillgänglig för de valda filtren.',
      selectLeagueFromTable: 'Välj liga från tabellen för att visa ELO-trend.',
      noInsightsData: 'Ingen insiktsdata tillgänglig för de valda ligorna. Kontrollera att ligorna har tillgängliga säsonger och laginsiktsdata.',
      showingLeagueAveragesLastSeason: 'Visar endast ligagenomsnitt för deras senaste aktiva säsong',
      selectTopTooltip: 'Visa ytterligare ligor i diagrammet för jämförelse',
      confederations: {
        world: 'Världen',
        top5: 'TOPP 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: 'Antal ligor',
      minimumElo: 'Minsta ELO'
    },
    players: {
      title: 'Spelarens GPI',
      subtitle: 'Globala spelarrankningar och insikter',
      gpiRanking: 'GPI-ranking',
      rankTooltip: 'Håll muspekaren för att visa den globala rankningen',
      globalRanking: 'Global Ranking',
      player: 'Spelare',
      players: 'Spelare',
      gpiTrend: 'GPI-trend',
      currentGPILabel: '(Nuvarande GPI)',
      nationality: 'Födelseland',
      position: 'Placera',
      marketValue: 'Marknadsvärde',
      apply: 'Tillämpas',
      marketValueAndAgeTooltip: 'Ange ett intervall och klicka på Använd eller tryck på Retur.',
      searchPlaceholder: 'Sök efter en spelare...',
      selectTopTooltip: 'Visa ytterligare spelare i diagrammet för jämförelse',
      gpi: 'GPI',
      numberOfPlayers: 'Antal spelare',
      showingPlayerStatsLastSeason: 'Visar endast spelarens genomsnittliga statistik för deras senaste aktiva säsong',
      date: 'DATUM',
      showChartLabels: 'Visa etiketter',
      marketValueTooltip: 'Ange ett intervall och klicka på Använd eller tryck på Retur.',
      freeAgents: 'Gratis agenter',
      selectPlayerFromTable: 'Välj en spelare från tabellen för att se GPI-trenden.'
    }
  },
  iso: {
    AF: 'Afghanistan',
    DZ: 'Algeria',
    AO: 'Angola',
    AR: 'Argentina',
    AU: 'Australia',
    AZ: 'Azerbaijan',
    BH: 'Bahrain',
    BB: 'Barbados',
    BE: 'Belgium',
    BJ: 'Benin',
    BO: 'Bolivia',
    BW: 'Botswana',
    BN: 'Brunei',
    BF: 'Burkina Faso',
    KH: 'Cambodia',
    CA: 'Canada',
    CF: 'Central African Rep.',
    CL: 'Chile',
    CO: 'Colombia',
    CD: 'Congo DR',
    CG: 'Congo',
    CI: 'Cote d\'Ivoire',
    CU: 'Cuba',
    CZ: 'Czech Republic',
    DJ: 'Djibouti',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    SV: 'El Salvador',
    ER: 'Eritrea',
    ET: 'Ethiopia',
    FI: 'Finland',
    PF: 'French Polynesia',
    GM: 'Gambia',
    DE: 'Germany',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GP: 'Guadeloupe',
    GN: 'Guinea',
    GY: 'Guyana',
    HN: 'Honduras',
    HU: 'Hungary',
    IN: 'India',
    IR: 'Iran',
    IE: 'Ireland',
    IT: 'Italy',
    JP: 'Japan',
    KZ: 'Kazakhstan',
    KI: 'Kiribati',
    KR: 'Korea, South',
    KG: 'Kyrgyzstan',
    LV: 'Latvia',
    LS: 'Lesotho',
    LY: 'Libyen',
    LT: 'Lithuania',
    MO: 'Macau SAR',
    MG: 'Madagascar',
    MY: 'Malaysia',
    ML: 'Mali',
    MH: 'Marshall Islands',
    MR: 'Mauritania',
    MX: 'Mexico',
    MD: 'Moldova',
    MN: 'Mongolia',
    MA: 'Morocco',
    MM: 'Myanmar',
    NR: 'Nauru',
    NL: 'Netherlands',
    NZ: 'New Zealand',
    NE: 'Niger',
    MP: 'Northern Mariana Islands',
    OM: 'Oman',
    PW: 'Palau',
    PA: 'Panama',
    PY: 'Paraguay',
    PH: 'Philippines',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Romania',
    RW: 'Rwanda',
    LC: 'Saint Lucia',
    SM: 'San Marino',
    SA: 'Saudi Arabia',
    RS: 'Serbia',
    SL: 'Sierra Leone',
    SK: 'Slovakia',
    SB: 'Solomon Islands',
    ZA: 'South Africa',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SZ: 'Swaziland',
    CH: 'Switzerland',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    TG: 'Togo',
    TT: 'Trinidad and Tobago',
    TR: 'Turkey',
    TV: 'Tuvalu',
    UA: 'Ukraine',
    GB: 'United Kingdom',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VG: 'Virgin Islands, British',
    EH: 'Western Sahara',
    ZM: 'Zambia',
    AL: 'Albania',
    AD: 'Andorra',
    AG: 'Antigua and Barbuda',
    AM: 'Armenia',
    AT: 'Austria',
    BS: 'Bahamas',
    BD: 'Bangladesh',
    BY: 'Belarus',
    BZ: 'Belize',
    BT: 'Bhutan',
    BA: 'Bosnia and Herz.',
    BR: 'Brazil',
    BG: 'Bulgaria',
    BI: 'Burundi',
    CM: 'Cameroon',
    CV: 'Cape Verde',
    TD: 'Chad',
    CN: 'China',
    KM: 'Komorerna',
    CR: 'Costa Rica',
    HR: 'Croatia',
    CY: 'Cyprus',
    DK: 'Denmark',
    DM: 'Dominica',
    TL: 'East Timor',
    EG: 'Egypt',
    GQ: 'Equatorial Guinea',
    EE: 'Estonia',
    FJ: 'Fiji',
    FR: 'France',
    GA: 'Gabon',
    GE: 'Georgia',
    GH: 'Ghana',
    GR: 'Greece',
    GD: 'Grenada',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    HT: 'Haiti',
    HK: 'Hong Kong SAR',
    IS: 'Iceland',
    ID: 'Indonesia',
    IQ: 'Iraq',
    IL: 'Israel',
    JM: 'Jamaica',
    JO: 'Jordan',
    KE: 'Kenya',
    KP: 'Korea, North',
    KW: 'Kuwait',
    LA: 'Laos',
    LB: 'Lebanon',
    LR: 'Liberia',
    LI: 'Liechtenstein',
    LU: 'Luxembourg',
    MK: 'Macedonia',
    MW: 'Malawi',
    MV: 'Maldives',
    MT: 'Malta',
    MQ: 'Martinica',
    MU: 'Mauritius',
    FM: 'Micronesia',
    MC: 'Monaco',
    ME: 'Montenegro',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NP: 'Nepal',
    NC: 'New Caledonia',
    NI: 'Nicaragua',
    NG: 'Nigeria',
    NO: 'Norway',
    PK: 'Pakistan',
    PS: 'Palestinian Territories',
    PG: 'Papua New Guinea',
    PE: 'Peru',
    PL: 'Poland',
    PR: 'Puerto Rico',
    RE: 'Reunion',
    RU: 'Russian Federation',
    KN: 'Saint Kitts and Nevis',
    WS: 'Samoa',
    ST: 'Sao Tome and Princ.',
    SN: 'Senegal',
    SC: 'Seychelles',
    SG: 'Singapore',
    SI: 'Slovenia',
    SO: 'Somalia',
    ES: 'Spain',
    VC: 'St Vincent and Gren.',
    SR: 'Suriname',
    SE: 'Sweden',
    SY: 'Syria',
    TJ: 'Tajikistan',
    TH: 'Thailand',
    TO: 'Tonga',
    TN: 'Tunisia',
    TM: 'Turkmenistan',
    UG: 'Uganda',
    AE: 'United Arab Emirates',
    US: 'United States',
    UZ: 'Uzbekistan',
    VA: 'Vatican City',
    VN: 'Vietnam',
    VI: 'Virgin Islands, U.S.',
    YE: 'Yemen',
    ZW: 'Zimbabwe',
    EU: 'Europe',
    INT: 'International',
    CW: 'Curaçao',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'England',
    'GB-WLS': 'Wales',
    'GB-SCT': 'Scotland',
    LATAM: 'South America',
    CAF: 'CAF',
    XK: 'Kosovo',
    AI: 'Anguilla',
    AN: 'Netherlands Antilles',
    AS: 'American Samoa',
    AW: 'Aruba',
    BM: 'Bermuda',
    BQ: 'Bonaire, SE and Saba',
    CK: 'The Cook Islands',
    FO: 'The Faroe Islands',
    GF: 'Guyane',
    GG: 'The Bailiwick of Guernsey',
    GU: 'The Territory of Guam',
    IM: 'The Isle of Man',
    JE: 'The Bailiwick of Jersey',
    KY: 'The Cayman Islands',
    MF: 'The Collectivity of Saint-Martin',
    MS: 'Montserrat',
    NU: 'Niue',
    OC: 'Oceania',
    RI: 'Indonesia',
    SS: 'The Republic of South Sudan',
    TC: 'The Turks and Caicos Islands',
    YT: 'The Department of Mayotte',
    SX: 'Sint Maarten'
  },
  loadingMessages: {
    players: 'Förbereder spelare',
    teams: 'Ordnar lag',
    games: 'Hämtar matcher',
    stats: 'Beräknar mätvärden',
    graphs: 'Ritar grafer',
    gettingReady: 'Värm upp',
    placeholder: 'Gör dig redo'
  },
  requestReport: {
    subtitle: 'Få en djup rapport med allt du behöver',
    categories: {
      scouting: {
        title: 'Scouting',
        subtitle: 'Vilka är de bästa spelarna i en viss liga? Och från flera ligor kombinerade? Begär en skräddarsydd rapport med vilket filter du vill (ålder, längd, kontraktsslut, etc.) och ta reda på vilka spelare som passar bäst'
      },
      coaches: {
        title: 'Tränare',
        subtitle: 'Hur skulle en tränare passa in i ditt lags system? Få detaljerad information eller, givet en viss profil, ta reda på vilka tränare som passar bäst'
      },
      'team analysis': {
        title: 'Lag',
        subtitle: 'Specificera ett lag och få säsongssammanfattningen med värdefulla insikter om stil, defensiv och offensiv prestation, svaga punkter, bästa spelare, etc...'
      },
      'game analysis': {
        title: 'Matchanalys',
        subtitle: 'Givet en match, få en djup för- och eftermatchanalys med detaljerad information'
      },
      'special projects': {
        title: 'Specialprojekt',
        subtitle: 'Hur presterar en spelare i bortamatcher? Hur förändras spelare från liga till liga? Vilka spelare är tillgängliga för lån? Fråga vad som helst du kan tänka dig'
      },
      conversation: {
        title: 'Konversation',
        subtitle: 'Starta en konversation med vårt team'
      }
    },
    notesPlaceholder: 'Låt oss veta vilken liga, profil, statistik, tränare, lag eller match du vill veta mer om',
    chooseType: 'Välj en rapporttyp',
    requestSummary: 'Begäran sammanfattning',
    reportType: 'Rapporttyp',
    reportLanguage: 'Rapportspråk',
    detailTitle: 'Uppföljning av rapport',
    detailSubtitle: 'All information om rapporten du begärde'
  },
  bugReport: {
    modalSubtitle: 'Hjälp oss att förbättra',
    about: 'Om',
    sendSuccess: 'Meddelat framgångsrikt. Kontrollera uppdateringar i inkorgen',
    bugs: 'Bugg'
  },
  gbe: {
    autopass: 'Automatiskt godkännande',
    bandX: 'Band {0}',
    bandXCont: 'Band {0} Kontinental tävling',
    points: 'Poäng',
    titleWinner: 'Titelmästare',
    qualifiedGroupsBandX: 'Kvalificerad för gruppspel i en Band {0} Kontinental tävling',
    qualifiedQualifiersBandX: 'Kvalificerad för kval i en Band {0} Kontinental tävling',
    midTable: 'Mitttabell',
    relegation: 'Nedflyttning',
    promotion: 'Uppflyttning',
    final: 'Final',
    semifinal: 'Semifinal',
    quarterfinal: 'Kvartsfinal',
    round16: 'Åttondelsfinal',
    round32: 'Trettioandradelsfinal',
    groupstage: 'Gruppspel',
    firstRound: '1:a omgången',
    secondRound: '2:a omgången',
    thirdRound: '3:e omgången',
    fourthRound: '4:e omgången',
    preliminaryRound: 'Kvalificeringsomgång',
    other: 'Övrigt',
    score: 'Poäng',
    totalSummary: 'Total sammanfattning',
    currentlyPlayingInUK: 'Spelaren är medborgare i Storbritannien eller Irland, eller spelaren är permanent bosatt i Storbritannien',
    bandsAlert: 'Det finns minuter spelade i mer än ett band, totalt är maxvärdet',
    bandsAlertMax: 'Det finns minuter spelade i mer än ett band, totalt är maxvärdet',
    bandsAlertAvg: 'Det finns minuter spelade i mer än ett band, totalt är medelvärdet',
    generate: 'GBE-ansökningsformulär',
    debutYouthPlayer: 'Debut för ungdomslagsspelare',
    table1: {
      name: 'Spelarens internationella framträdanden',
      title1: 'Sammanställd FIFA-världsranking för spelarens nationella förbund',
      title2: 'Spelarens internationella framträdanden'
    },
    table2: {
      name: 'Spelarens inhemska minuter',
      title1: 'Spelarens inhemska minuter'
    },
    table3: {
      name: 'Spelarens kontinentala minuter',
      title1: 'Spelarens kontinentala minuter'
    },
    table4: {
      name: 'Slutlig ligaplacering för spelarens senaste klubb',
      title1: 'Senaste klubbens slutliga ligaplacering'
    },
    table5: {
      name: 'Kontinental progression för spelarens senaste klubb',
      title1: 'Kontinental progression'
    },
    table6: {
      name: 'Ligakvalitet för spelarens nuvarande klubb',
      title1: 'Band för spelarens nuvarande klubb'
    },
    table7: {
      name: 'Ungdom - Debut',
      title1: 'Band'
    },
    table8: {
      name: 'Ungdom - Slutlig ligaplacering',
      title1: 'Senaste klubbens slutliga ligaplacering'
    },
    table9: {
      name: 'Ungdom - Kontinental progression',
      title1: 'Kontinental progression'
    },
    table10: {
      name: 'Ungdom - Ligakvalitet för spelarens nuvarande',
      title1: 'Band för spelarens nuvarande klubb'
    },
    table11: {
      name: 'Ungdom - Ligakvalitet för spelarens nuvarande',
      title1: 'Band för spelarens nuvarande klubb'
    },
    table12: {
      name: 'Ungdom - Internationella framträdanden',
      title1: 'Spelarens internationella framträdanden'
    }
  },
  mediaMode: {
    borderColor: 'Kantfärg',
    fillColor: 'Fyllfärg',
    bgColor: 'Bakgrundsfärg',
    upperText: 'Övre text',
    lowerText: 'Nedre text',
    socialMedia: 'Sociala medier',
    textColor: 'Textfärg',
    axisColor: 'Axelfärg',
    logo: 'Logotyp',
    comparisonBorderColor: 'Jämförelse kantfärg',
    comparisonFillColor: 'Jämförelse fyllfärg',
    comparisonUpperText: 'Jämförelse övre text',
    comparisonLowerText: 'Jämförelse nedre text',
    homeFillColor: 'Hemma fyllfärg',
    homeBorderColor: 'Hemma kantfärg',
    awayFillColor: 'Borta fyllfärg',
    awayBorderColor: 'Borta kantfärg',
    face: 'Ansikte',
    nationalTeam: 'Landslag',
    comparisonFace: 'Jämförelse ansikte',
    upperTextX: 'Övre text {0}',
    lowerTextX: 'Nedre text {0}',
    borderColorX: 'Kantfärg {0}',
    fillColorX: 'Fyllfärg {0}',
    homeFillColorX: 'Fyllfärg (Hemma) {0}',
    homeBorderColorX: 'Kantfärg (Hemma) {0}',
    awayFillColorX: 'Fyllfärg (Borta) {0}',
    awayBorderColorX: 'Kantfärg (Borta) {0}',
    faceX: 'Ansikte {0}',
    selectField: 'Välj en egenskap',
    orientationX: 'Orientering {0}',
    searchBarPlaceholder: 'Sök spelare och/eller matcher...',
    title: 'Media Dashboard',
    pageSubtitle: 'Utforska och ladda ner kartor och grafik',
    chooseChart: 'Välj diagram...',
    headerTextX: 'Rubriktext {0}',
    avatarLineLength: 'Avatar linjelängd',
    avatarLineWeight: 'Avatar linjevikt',
    avatarSize: 'Avatarstorlek',
    chartX: 'Diagram {0}',
    chartHeaderFontSize: 'Diagram rubrik teckenstorlek',
    chartHeaderFontWeight: 'Diagram rubrik teckenvikt',
    upperTextFontSize: 'Övre text teckenstorlek',
    upperTextFontWeight: 'Övre text teckenvikt',
    lowerTextFontSize: 'Nedre text teckenstorlek',
    lowerTextFontWeight: 'Nedre text teckenvikt',
    socialMediaFontSize: 'Sociala medier teckenstorlek',
    socialMediaFontWeight: 'Sociala medier teckenvikt',
    subtitle: 'Undertext',
    subtitleFontSize: 'Undertext teckenstorlek',
    subtitleFontWeight: 'Undertext teckenvikt',
    subtitleX: 'Undertext {0}',
    subtitleFontSizeX: 'Undertext ${0} teckenstorlek',
    subtitleFontWeightX: 'Undertext ${0} teckenvikt',
    titleX: 'Titel {0}',
    titleFontSize: 'Titel teckenstorlek',
    titleFontWeight: 'Titel teckenvikt',
    sponsor: 'Sponsor',
    fontFamily: 'Typsnitt'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Scoutrapporter',
      GAME_REPORT: 'Matchrapporter',
      MEDICAL_REPORT: 'Medicinska rapporter',
      PHYSICAL_REPORT: 'Fysiska rapporter',
      PSYCHOLOGICAL_REPORT: 'Psykologiska rapporter',
      OTHER: 'Övrigt',
      QUICK_NOTES: 'Snabbanteckningar',
      PLAYER_REPORT: 'Spelarrapporter',
      GENERAL_COMMENTS: 'Allmänna kommentarer',
      PLAYER_ANALYSIS: 'Spelaranalys'
    },
    uploadDocument: 'Ladda upp dokument',
    notesPlaceholder: 'Skriv beskrivande anteckningar eller kommentarer relaterade till dokumentet',
    notesPlaceholderAlt: 'Skriv beskrivande anteckningar eller kommentarer relaterade till spelaren',
    uploadedBy: 'Uppladdad av',
    updatedBy: 'Uppdaterad av',
    seeNotes: 'Se anteckningar',
    addNote: 'Lägg till anteckning',
    rating: 'Betyg',
    position: 'Bästa position',
    physical: 'Fysiskt',
    onBall: 'Med boll',
    offBall: 'Utan boll',
    mental: 'Mentalt',
    potential: 'Potential',
    conclusion: 'Slutsats',
    recommendation: {
      1: 'Skriv på',
      2: 'Övervaka',
      3: 'Avvisa',
      4: 'Intressant',
      label: 'Rekommendation'
    },
    match: 'Match',
    deleteQuickNote: 'Ta bort anteckning',
    deleteQuickNoteMessage: 'Anteckningen kommer att tas bort permanent. Är du säker?',
    noQuickNotes: 'Ingen data. Börja med att lägga till några snabbanteckningar!',
    deleteDocument: 'Ta bort dokument',
    deleteDocumentMessage: 'Dokumentet kommer att tas bort permanent. Är du säker?',
    noDocuments: 'Ingen data. Börja med att lägga till några dokument!'
  },
  notifications: {
    newReportMessage: 'Det finns ett nytt meddelande i en rapport'
  },
  blog: {
    subtitle: 'Senaste artiklar, uppdateringar och nyheter',
    newEntry: 'Ny post',
    title: 'Titel',
    text: 'Text',
    link: 'Länk',
    image: 'Bild',
    author: 'Författare',
    date: 'Utgivningsdatum',
    deleteEntry: 'Ta bort post',
    deleteEntryMessage: 'Är du säker på att du vill ta bort denna post?',
    readMore: 'Läs mer'
  },
  positionsOrlegi: {
    GK: 'Målvakt',
    DC: 'Försvarare',
    DR: 'Back',
    MC: 'Mittfältare',
    AMC: 'Offensiv mittfältare',
    FW: 'Anfallare',
    FWR: 'Ytter'
  },
  library: {
    subtitle: 'Visa och dela uppladdade dokument',
    mediaSubtitle: 'Visa och dela exporterade diagram',
    charts: 'Diagram',
    goToLibrary: 'Gå till bibliotek'
  },
  scatterPlot: {
    bubbleSize: 'Bubblestorlek',
    byMinutes: 'Efter minuter',
    byAge: 'Efter ålder',
    byMarketValue: 'Efter marknadsvärde'
  },
  eventChart: {
    successfulEvent: 'Framgångsrik',
    unsuccessfulEvent: 'Misslyckad',
    possessionLost: 'Lyckad inte återställd',
    successfulPass: 'Lyckad passning',
    unsuccessfulPass: 'Misslyckad passning',
    successfulCarry: 'Lyckad bärning',
    unsuccessfulCarry: 'Misslyckad bärning',
    carryAndKeyPass: 'Bärning & Nyckelpassning',
    carryAndAssist: 'Bärning & Assist',
    carryAndShot: 'Bärning & Skott',
    ballProgressionAndPass: 'Bollframsteg & Passning',
    ballProgression: 'Bollframsteg',
    ballProgressionAndKeyPass: 'Bollframsteg & Nyckelpassning',
    ballProgressionAndAssist: 'Bollframsteg & Assist',
    ballProgressionAndShot: 'Bollframsteg & Skott',
    ballProgressionAndGoal: 'Bollframsteg & Mål',
    pass: 'Passning',
    carryAndPass: 'Bärning & Passning',
    carryAndGoal: 'Bärning & Mål',
    totalTouches: 'Totalt antal beröringar',
    totalPasses: 'Totala Passningar',
    successful: 'Lyckad',
    unsuccessful: 'Misslyckad',
    tacklePossessionLost: 'Framgångsrik - Förlorad besittning',
    gamesSelected: '{count} matcher valda',
    allGamesOfSeason: 'Alla matcher i säsongen',
    allGamesOfSeasons: 'Alla matcher i säsongerna',
    allEvents: 'Alla händelser',
    eventTypesCount: '{count} händelsstyper',
    totalEvents: 'Totalt antal händelser',
    zoneDominanceNote: 'Toucherna som visas av varje lag i varje zon representerar endast framgångsrika touch',
    selectedEvents: 'Utvalda händelser'
  },
  event: {
    Pass: 'Passning',
    TakeOn: 'Dribbling',
    Takeon: 'Dribbling',
    Foul: 'Foul',
    Error: 'Fel',
    Tackle: 'Tackling',
    Interception: 'Avlyssning',
    Clearance: 'Rädning',
    MissedShot: 'Missat skott',
    ShotOnPost: 'Skott på stolpe',
    SavedShot: 'Räddat skott',
    Goal: 'Mål',
    Aerial: 'Luftspel',
    BallRecovery: 'Bollåtervinning',
    Dispossessed: 'Bolltappad',
    ChanceMissed: 'Chans missad',
    BallTouch: 'Bollberöring',
    BlockedPass: 'Blockerad passning',
    Challenge: 'Utmaning',
    lossPossession: 'Bollförlust',
    OffsidePass: 'Offside Pass',
    groundDuelsLost: 'Förlorade markdueller',
    'Ball touch': 'Bollberöring',
    Smother: 'Kväsning',
    'Keeper pickup': 'Målvakt plockar',
    'Good skill': 'Bra färdighet',
    Punch: 'Slag',
    'Saved shot': 'Räddat skott',
    'Shot on post': 'Skott på stolpe',
    'Missed shot': 'Missat skott',
    Save: 'Räddning',
    'Take on': 'Dribbling',
    'Offside pass': 'Offside passning',
    Claim: 'Göra anspråk',
    'Blocked pass': 'Blockerad passning',
    KeeperPickup: 'Keeper Pickup',
    'Ball recovery': 'Bollen återhämtning',
    'Ball Recovery': 'Bollen återhämtning',
    'Chance missed': 'Chansen missad',
    'Loss possession': 'Förlust av besittning',
    Carries: 'Bära',
    BallProgression: 'Bollen Progression',
    MissedChance: 'Missad chans',
    Event: 'Händelse',
    Shot: 'Skott',
    Assist: 'Hjälpa',
    KeyPass: 'Nyckelpass',
    'Foul taken': 'Fel mottaget'
  },
  leagueTab: {
    leagueTable: 'Ligatabell',
    matchdays: 'Omgångar',
    playerInsights: 'Spelarinsikter',
    onlyLocalPlayers: 'Samo lokalni igralci',
    teamInsights: 'Laginsikter',
    head2head: 'Direktmöten',
    addNewChart: 'Lägg till nytt diagram',
    rounds: {
      16: 'Åttondelsfinal',
      32: 'Trettioandradelsfinal',
      W: 'Vinnare',
      F: 'Final',
      SF: 'Semifinal',
      QF: 'Kvartsfinal',
      GR: 'Gruppspel',
      '4R': 'Fjärde omgången',
      '3R': 'Tredje omgången',
      '2R': 'Andra omgången',
      '1R': 'Första omgången',
      PR: 'Kvalificeringsomgång',
      QPO1: 'Gör trettioandradelsfinal nivå under',
      QPO2: 'Kvalificeringsomgång åttondelsfinal',
      QPO3: 'Kvalomgång om 32'
    },
    positions: 'Positioner',
    prediction: 'Förutsägelser',
    predicted: 'Förutsägelse',
    groups: 'Grupper',
    ranking: 'Ranking',
    numberOfTeams: 'Antal lag',
    statsWithMinimum: {
      message: 'Visar endast spelare med mer än {0} {1} i den valda säsongen',
      dribblesTotal90: 'dribblingar per 90 minuter',
      crosses90: 'inlägg per 90 minuter',
      tacklesAttempted90: 'tacklingar försökta per 90 minuter',
      aerialsTotal90: 'luftdueller per 90 minuter'
    },
    numberOfLeagues: 'Antal ligor',
    position: {
      titleWinner: 'Titelvinnare',
      championsLeague: 'Champions League',
      qualifierChampionsLeague: 'Kval Champions League',
      europeLeague: 'Europa League',
      qualifierEuropeLeague: 'Kval Europa League',
      conferenceLeague: 'Konferensligan',
      qualifierConferenceLeague: 'Qualifier Conference League',
      midTable: 'Mellanbord',
      relegation: 'Nedflyttning',
      promotion: 'Främjande',
      relegationPlayoff: 'Nedflyttningsslutspel',
      promotionPlayoff: 'Kampanj slutspel',
      championshipGroup: 'Mästerskapsgrupp',
      relegationGroup: 'Nedflyttningsgrupp',
      championshipPlayoffs: 'Mästerskapsslutspel',
      preChampionshipPlayoffs2: 'Pre Championship slutspel 2',
      preChampionshipPlayoffs3: 'Pre Championship slutspel 3',
      playoffsQualifierBand3: 'Slutspelskvalband 3',
      continentalGroup: 'Continental Group'
    },
    group: {
      1: 'A',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'E',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'jag',
      10: 'J',
      11: 'K',
      12: 'L'
    }
  },
  similarity: {
    subtitle: 'Hitta liknande spelare',
    searchBarPlaceholder: 'Sök och välj en spelare för att hitta liknande',
    radarFilters: 'Radarfilter',
    similarityFilters: 'Likhetsfilter',
    playersFilters: 'Spelarfilter',
    similarPlayers: 'Liknande spelare',
    seasonWarning: 'Endast de säsonger i Likhetsverktyget där minst 450 minuters speltid har registrerats är tillgängliga'
  },
  squadBuilder: {
    subtitle: 'Skissa dina unika elvor',
    playerSelector: 'Spelarval',
    loadSquad: 'Ladda trupp',
    yearsOld: 'år',
    playersPerPosition: 'Spelare per position',
    custom: 'Anpassad',
    removeSquad: 'Ta bort trupp',
    removeSquadMessage: 'Är du säker på att du vill ta bort truppen?',
    deleteSquadSuccess: 'Truppen har tagits bort framgångsrikt',
    playerDetails: 'Spelardetaljer synlighet',
    ageFormat: 'Åldersformat',
    mainPlayer: 'Huvudspelare',
    showDetails: 'Visa detaljer',
    all: 'Alla',
    squadPosition: 'Truppposition',
    noData: 'Ingen data. Börja med att lägga till några spelare på planen!'
  },
  tours: {
    buttons: {
      dontShowAgain: 'Visa inte igen',
      skipTour: 'Hoppa över guidad tur',
      previous: 'Föregående',
      next: 'Nästa',
      finish: 'Slutför'
    },
    playerRadar: {
      step1: {
        title: 'PERSONLIG FIL',
        message: 'Kontrollera grundläggande spelardata: ålder, längd eller kontraktsdatum'
      },
      step2: {
        title: 'GBE-FILTER',
        message: 'Funktionalitet som gör det möjligt att veta om en spelare har tillräckligt med GBE-poäng för att spela i Storbritannien'
      },
      step3: {
        title: 'TILLGÄNGLIGHET',
        message: 'Procentandel tillgängliga minuter och procentandel spelade minuter'
      },
      step4: {
        title: 'POSITIONER',
        message: 'Ta reda på i vilka positioner spelaren har spelat och hur många minuter han har spelat i varje position'
      },
      step5: {
        title: 'VISNINGSFORMAT',
        message: 'Mät prestationen med 4 olika visualiseringar, Radar, Polar, Lollipop och Text, för att jämföra den med spelarna i hans position'
      },
      step6: {
        title: 'PRESTATIONSRADAR',
        message: 'Här reflekteras prestationen visuellt. Panelen är interaktiv, du kan hovra över varje mätvärde och få dess definition'
      },
      step7: {
        title: 'SÄSONGSVAL',
        message: 'Välj eller lägg till säsonger för att mäta din prestation'
      },
      step8: {
        title: 'ANPASSAT MALVAL',
        message: 'Använd de anpassade mallar du har skapat för att mäta spelaren med olika mätvärden än standardradarn'
      },
      step9: {
        title: 'VAL AV SPELADE POSITIONER',
        message: 'Markera och avmarkera de olika positionerna för att mäta honom i den position du vill mäta honom i'
      },
      step10: {
        title: 'VAL AV MINIMI OCH MAXIMI',
        message: 'Mät spelaren med höjdpunkter och lågpunkter från hans säsong, från de fem bästa ligorna eller från användarkontots egna och standard säsong'
      },
      step11: {
        title: 'JÄMFÖRELser',
        message: 'Jämför spelaren med hans tidigare prestation, med andra spelare i hans position, med genomsnittet för positionen'
      },
      step12: {
        title: 'BILDNEDLADNINGSFORMAT',
        message: 'Tre nedladdningsformat är tillgängliga: png, svg och embed'
      }
    },
    playerRanking: {
      step1: {
        title: 'SÄSONG, TRUPP OCH POSITION',
        message: 'Välj säsong, trupp och position för att jämföra spelaren med'
      },
      step2: {
        title: 'GRUNDLÄGGANDE FILTER',
        message: 'Filtrera spelare efter ålder, spelade minuter eller längd'
      },
      step3: {
        title: 'MARKERA OCH EXKLUDERA',
        message: 'Markera de spelare du vill ha och exkludera lag i visningen'
      },
      step4: {
        title: 'FILTERA EFTER KATEGORI',
        message: 'Filtrera statistik efter kategori: Samarbete, Försvar, Passningar, Bollhantering, etc'
      },
      step5: {
        title: 'BILDNEDLADNINGSFORMAT',
        message: 'Tre nedladdningsformat är tillgängliga: png, svg och embed'
      }
    },
    playerFinishing: {
      step1: {
        title: 'VÄLJ VISNING',
        message: 'Du kan se avslutningskartan i huvudvy, målvy och i en fördelningstabell'
      },
      step2: {
        title: 'VÄLJ SÄSONGER',
        message: 'Lägg till säsonger för att mäta din skotteffektivitet'
      },
      step3: {
        title: 'SKOTTPLATS',
        message: 'Välj möjligheten att se den exakta platsen för skottet (cirklar) eller efter områden i straffområdet och planen (områden)'
      },
      step4: {
        title: 'xG PÅ MÅL',
        message: 'Markera rutorna för xG till Mål och xG Genomförande för att se vilket mervärde spelaren lade till efter skottet'
      },
      step5: {
        title: 'SKOTTTYP',
        message: 'Filtrera efter skottyp, strategi, område eller kroppsdel'
      },
      step6: {
        title: 'FILTERA MINUTER',
        message: 'Minutstång för att välja skott och mål gjorda under specifika matchperioder'
      },
      step7: {
        title: 'BILDNEDLADNINGSFORMAT',
        message: 'Tre nedladdningsformat är tillgängliga: png, svg och embed'
      },
      step8: {
        title: 'SKOTTKARTA',
        message: 'Kartan är interaktiv. Kontrollera varje cirkel med musen för att ta reda på xG för varje skott'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'SÄSONGSVAL',
        message: 'Lägg till säsonger för att mäta din skotteffektivitet'
      },
      step2: {
        title: 'NYCKELPASSNINGSPLATS',
        message: 'Välj möjligheten att se den exakta platsen för nyckelpassningen (cirkel) eller efter områden i området och planen (områden)'
      },
      step3: {
        title: 'TYP AV AVSLUT EFTER NYCKELPASSNING',
        message: 'Filtrera efter typ av skott, strategi, område eller kroppsdel gjord efter nyckelpassning'
      },
      step4: {
        title: 'FILTERA MINUTER',
        message: 'Minutstång för att välja skott och mål gjorda under specifika matchperioder'
      },
      step5: {
        title: 'BILDNEDLADNINGSFORMAT',
        message: 'Tre nedladdningsformat är tillgängliga: png, svg och embed'
      },
      step6: {
        title: 'NYCKELPASSNINGSKARTA',
        message: 'Kartan är interaktiv. Konsultera varje cirkel med musen för att veta xA för varje passning'
      }
    },
    playerThreat: {
      step1: {
        title: 'SÄSONGSVAL',
        message: 'Lägg till säsonger för att mäta din skotteffektivitet'
      },
      step2: {
        title: 'HOTPLATS',
        message: 'Välj möjligheten att se exakt plats för nyckelpassningen (cirkel) eller efter område och planzoner (områden)'
      },
      step3: {
        title: 'HANDLING OCH GENOMFÖRANDE',
        message: 'Markera och avmarkera enligt typ av handling och genomförande du vill visa på kartan'
      },
      step4: {
        title: 'MINUTER OCH HOT',
        message: 'Filtrera efter period, efter minuter och efter hotvärde för handlingarna'
      },
      step5: {
        title: 'BILDNEDLADNINGSFORMAT',
        message: 'Tre nedladdningsformat är tillgängliga: png, svg och embed'
      },
      step6: {
        title: 'HOTKARTA',
        message: 'Kartan är interaktiv. Konsultera varje cirkel med musen för att ta reda på hotet som genererades i varje xT-spel för varje passning'
      }
    },
    playerTouches: {
      step1: {
        title: 'MATCH- OCH HÄNDELSEVAL',
        message: 'Välj match och händelser du vill visa på kartan'
      },
      step2: {
        title: 'HÄNDELSETYP',
        message: 'Markera och avmarkera enligt den defensiva eller offensiva karaktären av spelarens händelse under hela matchen'
      },
      step3: {
        title: 'VISNINGSFILTER',
        message: 'Filtrera karta efter grundläggande handlingar, värmekarta, cirklar eller rutor'
      },
      step4: {
        title: 'BILDNEDLADNINGSFORMAT',
        message: 'Tre nedladdningsformat är tillgängliga: png, svg och embed'
      },
      step5: {
        title: 'BERÖRNINGSKARTA',
        message: 'Kartan är interaktiv. Du kan se varje händelse genom att klicka på varje händelse'
      }
    },
    playerAllGames: {
      step1: {
        title: 'TILLGÄNGLIGHET',
        message: 'Kontrollera tillgänglighet och spelade minuter match för match'
      },
      step2: {
        title: 'POSITIONER',
        message: 'Konsultera positionerna där han har spelat i varje match'
      }
    },
    playerInjuries: {
      step1: {
        title: 'HISTORIK OCH FÖRLORADE DAGAR',
        message: 'Konsultera skador från det senaste året eller hela historiken och omfattningen av skador enligt deras varaktighet i dagar'
      },
      step2: {
        title: 'SKADOR PER KLUBB',
        message: 'Konsultera skadorna separerade efter säsong och/eller klubb i hans karriär'
      }
    },
    playerInfo: {
      step1: {
        title: 'KARRIÄR OCH TRANSFERS',
        message: 'Du kan konsultera minuter, position eller tillgänglighetshistorik med hans klubb, med hans landslag och spelarens transfers under hela hans karriär'
      }
    },
    teamOverview: {
      step1: {
        title: 'LAGÖVERSIKT',
        message: 'Konsultera grundläggande data för laget: genomsnittlig ålder, basformation, ELO eller transferbalans'
      },
      step2: {
        title: 'GRUNDLÄGGANDE STATISTIK',
        message: 'Konsultera bollinnehav, xG, Skott, PPDA eller Vertikalitet'
      },
      step3: {
        title: 'RADAR OCH SÄSONG',
        message: 'Välj radar, säsong och hemma- eller bortamatcher för att mäta lagets prestation'
      },
      step4: {
        title: 'FILTERA EFTER TRÄNARE OCH MATCHER',
        message: 'Välj prestation per etapp för varje tränare'
      },
      step5: {
        title: 'PRESTATIONSRADAR',
        message: 'Panelen är interaktiv, du kan hovra över varje mätvärde och få dess definition'
      },
      step6: {
        title: 'BILDNEDLADNINGSFORMAT',
        message: 'Två nedladdningsformat är tillgängliga: png och svg'
      },
      step7: {
        title: 'KALENDER',
        message: 'Visa lagets matchschema'
      },
      step8: {
        title: 'BÄSTA SPELARE EFTER MÄTVÄRDEN',
        message: 'I denna panel kan du välja olika mätvärden och se vilka spelare som är de viktigaste'
      },
      step9: {
        title: 'NÄSTA MATCH OCH SKADOR',
        message: 'Kontrollera nästa motståndare och lagets skadade och avstängda spelare'
      },
      step10: {
        title: 'GRAFER OCH TRENDER',
        message: 'Visa olika grafer för de senaste 10 eller 20 matcherna'
      }
    },
    teamRoster: {
      step1: {
        title: 'VISNINGSTYP',
        message: 'Visa truppen från 6 olika kategorier: efter position, kontraktsslut, ålder, tillgänglighet, åldersprofil och plan'
      }
    },
    teamLoans: {
      step1: {
        title: 'LÅNSPELARE',
        message: 'Konsultera spelarna som är utlånade till andra lag och vilken position de spelar i'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'SÄSONG OCH TRUPP',
        message: 'Filtrera efter säsong, radartrupp och jämför med ligor du väljer'
      },
      step2: {
        title: 'PRESTATION EFTER MÄTVÄRDEN',
        message: 'Se var laget ligger i varje mätvärde jämfört med alla lag i de tidigare valda ligorna'
      },
      step3: {
        title: 'BILDNEDLADNINGSFORMAT',
        message: 'Tre nedladdningsformat är tillgängliga: png, svg och embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'SÄSONGSVAL',
        message: 'Lägg till säsonger för att mäta skotteffektivitet'
      },
      step2: {
        title: 'EGEN ELLER MOTSTÅNDARENS AVSLUTNING',
        message: 'Välj om du vill se lagets eller alla dess motståndares avslutningskarta'
      },
      step3: {
        title: 'SKOTTPLACERING',
        message: 'Välj hur du vill se lagets skott, efter cirklar eller efter zoner (rutor)'
      },
      step4: {
        title: 'SKOTTTYP',
        message: 'Filtrera efter typ av skott, strategi, område eller kroppsdel'
      },
      step5: {
        title: 'FILTERA MINUTER',
        message: 'Minutstång för att välja skott och mål gjorda under specifika matchperioder'
      },
      step6: {
        title: 'BILDNEDLADNINGSFORMAT',
        message: 'Tre nedladdningsformat är tillgängliga: png, svg och embed'
      },
      step7: {
        title: 'SKOTTKARTA',
        message: 'Kartan är interaktiv. Kontrollera varje cirkel med musen för att ta reda på xG för varje skott'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'SÄSONGSVAL',
        message: 'Lägg till säsonger för att mäta skotteffektivitet'
      },
      step2: {
        title: 'EGNA ELLER RIVALERS NYCKELPASSNINGAR',
        message: 'Välj om du vill se en karta över lagets nyckelpassningar eller alla dess rivalers'
      },
      step3: {
        title: 'NYCKELPASSNINGSPLATS',
        message: 'Välj om du vill se den exakta platsen för nyckelpassningen (cirkel) eller efter område och plan (rutor)'
      },
      step4: {
        title: 'TYP AV AVSLUT EFTER PASSNING',
        message: 'Filtrera efter typ av skott, strategi, område eller kroppsdel gjord efter nyckelpassning'
      },
      step5: {
        title: 'FILTERA MINUTER',
        message: 'Minutstång för att välja skott och mål gjorda under specifika matchperioder'
      },
      step6: {
        title: 'BILDNEDLADNINGSFORMAT',
        message: 'Tre nedladdningsformat är tillgängliga: png, svg och embed'
      },
      step7: {
        title: 'SKOTTKARTA',
        message: 'Kartan är interaktiv. Konsultera varje cirkel med musen för att veta xA för varje passning'
      }
    },
    teamLatestGames: {
      step1: {
        title: 'SENASTE MATCHER',
        message: 'Konsultera resultat, bollinnehav, xG och vinstprocent för alla lagets matcher'
      }
    },
    teamTransfers: {
      step1: {
        title: 'ANKOMSTER',
        message: 'Konsultera alla ankomster (köp + transfers) per kalenderår'
      },
      step2: {
        title: 'AVRESOR',
        message: 'Konsultera alla avresor (försäljningar + transfers) per kalenderår'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'TRENDER',
        message: 'Fråga lagform genom serier, vinster, nollor, comeback, perioder med mål eller typer av mål'
      },
      step2: {
        title: 'STATIONÄRA SITUATIONER',
        message: 'Jämför lagets prestation mellan stationära situationer och öppet spel och få en detaljerad översikt över stationära situationer'
      },
      step3: {
        title: 'BYTEN',
        message: 'Se när laget gör byten och vilka spelare som byts ut mest'
      },
      step4: {
        title: 'KOPPLINGAR',
        message: 'Konsultera de vanligaste kopplingarna mellan spelare. Filtrera efter säsong och typ av spel'
      },
      step5: {
        title: 'ANFALLSZONER',
        message: 'Upptäck lagets anfallszoner och filtrera efter säsong eller typ av anfall'
      },
      step6: {
        title: 'FORMATIONER',
        message: 'Kontrollera de mest använda formationerna och deras % av vinster, oavgjorda och förluster med var och en av dem'
      },
      step7: {
        title: 'SKOTZZONER',
        message: 'Filtrera efter säsong, lag eller motståndare, sätt att visualisera kartan, skottyper eller minuter'
      },
      step8: {
        title: 'INLÄGG',
        message: 'Fråga och filtrera efter säsong, typ av visning, lyckade eller misslyckade, var de börjar och slutar eller inklusive hörnor'
      },
      step9: {
        title: 'SPELARE',
        message: 'Filtrera efter säsong, typ av visning, lyckade eller misslyckade, var de börjar och slutar eller inklusive hörnor'
      }
    },
    teamOnOff: {
      step1: {
        title: 'SÄSONGER OCH MATCHER',
        message: 'Filtrera efter säsong, matcher eller efter hemma- eller bortamatcher'
      },
      step2: {
        title: 'SPELARE',
        message: 'Visa prestationen för alla spelare i truppen genom otaliga mätvärden'
      }
    }
  },
  alerts: {
    numPlayers: 'Antal spelare',
    newPlayersLastWeek: 'Nya spelare senaste veckan',
    subtitle: 'Få varningar när nya spelare uppfyller dina sökkriterier',
    generalSubtitle: 'Ta emot varningar om nya spelare baserat på dina kriterier och nyheter om dina favoritspelare',
    subtitlePlayer: 'Få varningar när vi har nyheter om dina favoritspelare',
    subtitleSearch: 'Få varningar när nya spelare uppfyller dina sökkriterier',
    favorite: 'Favorit',
    newEventCalendar: 'Ny händelse',
    updatedEventCalendar: 'Uppdaterad händelse',
    newShareFrom: 'Ny delning från',
    injuryAlert: 'Skadevarning',
    contractAlert: 'Kontraktsvarning',
    teamAlert: 'Signeringsvarning',
    marketValueAlert: 'Marknadsvärdevarning',
    gameAlert: 'Spelad matchvarning'
  },
  videoEvents: {
    highlights: 'Höjdarpunkter',
    fullGame: 'Hela matchen',
    autoplay: 'Automatisk uppspelning',
    searchBarPlaceholder: 'Sök spelare, match eller lag...',
    subtitle: 'Analysera händelser via video',
    successful: 'Framgång',
    unsuccessful: 'Misslyckad',
    playing: 'Spelar',
    games: 'Matcher',
    moreFilters: 'Fler filter...',
    startArea: 'Startområde',
    endArea: 'Slutområde',
    select: 'Välj',
    selectLastXGames: 'Välj senaste {0} matcherna',
    advancedFilters: 'Avancerade filter',
    freeKicks: 'Frisparkar',
    cornerKicks: 'Hörnor',
    allShots: 'Alla skott',
    generateZip: 'Ladda ner videor',
    zippedModalMessage: 'Vi skapar nu din videolista och skickar den till din e-post inom kort',
    clickToSeeVideo: 'Klicka för att se video'
  },
  videoUpload: {
    subtitle: 'Ladda upp video och skapa ny match',
    uploadVideo: 'Ladda upp video',
    selectPeriod: 'Välj period',
    gameData: 'Matchdata',
    venue: 'Arena',
    matchType: 'Matchtyp',
    matchGroup: 'Matchgrupp',
    roundType: 'Omgångstyp',
    roundNumber: 'Omgångsnummer',
    offsetFh: 'Förskjutning första halvlek',
    offsetSh: 'Förskjutning andra halvlek',
    offsetFhOT: 'Förskjutning förlängning första halvlek',
    offsetShOT: 'Förskjutning förlängning andra halvlek',
    homeLineup: 'Hemmauppställning',
    awayLineup: 'Bortauppställning',
    existingPlayer: 'Befintlig spelare',
    newPlayer: 'Ny spelare',
    startingTeam: 'Startar',
    saveAndUpload: 'Spara och ladda upp',
    existingGame: 'Matchen finns redan',
    sendToKora: 'Skicka',
    invalidForm: 'Ogiltigt formulär',
    warningModalTitle: 'Avvikelser har upptäckts',
    noScoreSheetWarning: 'Ingen matchprotokoll bifogad',
    onlyOnePartUploadedWarning: 'Endast en halvlek bifogad',
    continueQuestion: 'fortsätta?',
    slaLimit: 'Du har laddat upp {0} matcher med {1}. Din gräns är {2}',
    requestedGames: 'Begärda matcher',
    limitClose: 'Endast {0} matcher kvar att begära',
    limitReached: 'Du har nått din videouppladdningsgräns. Uppladdning av ytterligare matcher kan resultera i extra kostnader.',
    seasonFinishedWarning: 'Detta kommer att skapa en match i en säsong som redan har avslutats. Kontrollera att detta är korrekt.',
    teamCountryWarning: 'Detta lag är från ett annat land än den valda ligan. Kontrollera att detta är korrekt.',
    uploading: 'Laddar upp',
    doNotNavigateAway: 'Stäng inte den här fliken, uppdatera sidan eller navigera bort medan uppladdningen pågår.',
    severalMinutes: 'Denna process kan ta flera minuter.'
  },
  videoPlaylists: {
    subtitle: 'Samlingar av videohöjdarpunktfilter',
    savePlaylist: 'Spara spellista',
    seeAllPlaylists: 'Se alla spellistor'
  },
  videoHighlights: {
    recap: 'Sammanfattning',
    homeCondensed: 'Hemma komprimerad match',
    awayCondensed: 'Borta komprimerad match',
    selectedActions: 'Valda handlingar',
    noActions: 'Inga handlingar som matchar de angivna filterkriterierna',
    noGames: 'Inga matcher uppladdade ännu',
    attackingActions: 'Anfallande handlingar',
    defensiveActions: 'Defensiva handlingar',
    groundDuels: 'Markdueller',
    penaltiesProvoked: 'Framprovocerade straffar',
    goalkeeperActions: 'Målvaktshandlingar',
    addSomeGames: 'Börja med att lägga till några matcher!',
    goToVideoUploadTool: 'Gå till videouppladdningsverktyg',
    ballInPlay: 'Boll i spel',
    filterSeasons: 'Filtrera säsonger',
    streaming: 'Streaming',
    clips: 'Klipp',
    qualifiers: {
      Pass: 'Passning',
      Save: 'Räddning',
      'Saved Shot': 'Räddat skott',
      Shot: 'Skott',
      Goal: 'Mål',
      'Missed Shot': 'Missat skott',
      'Shot on Post': 'Skott på stolpe',
      Error: 'Fel',
      Clearance: 'Rädning',
      Aerial: 'Luftspel',
      Challenge: 'Markduell förlorad',
      Dispossessed: 'Bolltappad',
      Foul: 'Foul',
      Card: 'Kort',
      'Offside Pass': 'Offside passning',
      Claim: 'Inlägg anspråk',
      'Keeper Pickup': 'Målvakt plockar',
      'Ball Touch': 'Bollberöring',
      Dribble: 'Dribbling',
      Interception: 'Avlyssning',
      Tackle: 'Tackling',
      'Ball Recovery': 'Bollåtervinning',
      Takeon: 'Dribbling'
    },
    qualifierIds: {
      1: 'Lång boll',
      2: 'Inlägg',
      5: 'Frispark tagen',
      6: 'Hörna tagen',
      9: 'Straff',
      15: 'Huvud',
      20: 'Högerfotad',
      21: 'Annan kroppsdel',
      22: 'Regelbundet spel',
      23: 'Snabbt anfall',
      24: 'Stationär situation',
      25: 'Från hörna',
      26: 'Frispark',
      28: 'Självmål',
      29: 'Assist',
      31: 'Gult kort',
      32: 'Andra gula kortet',
      33: 'Rött kort',
      72: 'Vänsterfotad',
      73: 'Vänster',
      82: 'Räddat skott (ingen MV)',
      94: 'Försvarsblockering',
      123: 'Målvakt kastar',
      124: 'Avspark',
      160: 'Inkast stationär situation',
      170: 'Ledande till mål',
      173: 'Parerad säkert',
      174: 'Parerad farligt',
      177: 'Samlad',
      178: 'Stående',
      179: 'Dykning',
      182: 'Händer',
      183: 'Fötter',
      185: 'Blockerat inlägg',
      210: 'Assist',
      215: 'Individuellt spel',
      279: 'Avspark',
      285: 'Defensivt',
      286: 'Offensivt'
    },
    areas: {
      goalArea: 'Målområde',
      boxLeft: 'Straffområde vänster',
      boxCenter: 'Straffområde mitt',
      boxRight: 'Straffområde höger',
      outBoxDeepLeft: 'Utanför straffområde djupt vänster',
      outBoxDeepRight: 'Utanför straffområde djupt höger',
      outBoxLeft: 'Utanför straffområde vänster',
      outBoxCentreLeft: 'Utanför straffområde mitt-vänster',
      outBoxCentre: 'Utanför straffområde mitt',
      outBoxCentreRight: 'Utanför straffområde mitt-höger',
      outBoxRight: 'Utanför straffområde höger',
      midfieldLeft35: 'Mittfält vänster',
      midfieldCentreLeft35: 'Mittfält mitt-vänster',
      midfieldCentre35: 'Mittfält mitt',
      midfieldCentreRight35: 'Mittfält mitt-höger',
      midfieldRight35: 'Mittfält höger',
      ownGoalArea: 'Eget målområde',
      ownBoxLeft: 'Eget straffområde vänster',
      ownBoxCenter: 'Eget straffområde mitt',
      ownBoxRight: 'Eget straffområde höger',
      ownFieldOutOfBoxDeepLeft: 'Eget fält utanför straffområde djupt vänster',
      ownFieldOutOfBoxDeepRight: 'Eget fält utanför straffområde djupt höger',
      ownFieldOutOfBoxLeft: 'Eget fält utanför straffområde vänster',
      ownFieldOutOfBoxCentreLeft: 'Eget fält utanför straffområde mitt-vänster',
      ownFieldOutOfBoxCentre: 'Eget fält utanför straffområde mitt',
      ownFieldOutOfBoxCentreRight: 'Eget fält utanför straffområde mitt-höger',
      ownFieldOutOfBoxRight: 'Eget fält utanför straffområde höger',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: 'Framgång',
      fail: 'Misslyckad',
      possessionWon: 'Bollinnehav vunnet',
      possessionNotWon: 'Bollinnehav inte vunnet',
      received: 'Mottagen',
      provoked: 'Framprovocerad'
    },
    homePlayerHighlights: 'Hemmaspelarens höjdpunkter',
    awayPlayerHighlights: 'Bortaspelarens höjdpunkter'
  },
  share: {
    shareTo: 'Skicka till',
    viaApp: 'App (Driblab-meddelande)',
    viaEmail: 'E-post',
    description: 'Beskrivning',
    titleTab: 'Delningar',
    toMe: 'Mottagen',
    fromMe: 'Skickad',
    typeInternal: 'Intern',
    typeExternal: 'Extern',
    title: 'Delad',
    subtitle: 'Översikt över objekten i din dellista och dina delningar',
    selectUser: 'Välj användare',
    expired: 'Utgången',
    limitReached: 'Länk nådde användningsgränsen'
  },
  homeStats: {
    data: 'Tillgänglig data',
    players: 'spelare',
    totalPlayers: 'totalt antal spelare',
    teams: 'lag',
    totalTeams: 'totalt antal lag',
    leagues: 'ligor',
    totalLeagues: 'totalt antal ligor',
    seasons: 'säsonger',
    totalSeasons: 'totalt antal säsonger',
    games: 'matcher',
    totalGames: 'totalt antal matcher'
  },
  scoutingCalendar: {
    subtitle: 'Skapa och organisera dina scoutuppgifter',
    myCalendars: 'Privat kalender',
    publicCalendars: 'Offentliga kalendrar',
    otherCalendars: 'Andra kalendrar',
    calendarSettings: 'Kalenderinställningar',
    moreInfo: 'Mer info',
    individualScouting: 'Individuell scouting',
    matchScouting: 'Matchscouting',
    calendarView: {
      type: 'Kalendertyp',
      month: 'Månad',
      week: 'Vecka',
      day: 'Dag'
    },
    weekView: {
      type: 'Veckotyp',
      monSun: 'Måndag - Söndag',
      sunSat: 'Söndag - Lördag',
      monFri: 'Måndag - Fredag'
    },
    tasks: {
      addNew: 'Lägg till ny uppgift',
      myTasks: 'Mina uppgifter',
      filterTasks: 'Filtrera uppgifter',
      sharedWithMe: 'Delad med mig',
      createTask: 'Skapa uppgift',
      newTask: 'Ny uppgift',
      taskName: 'Uppgiftsnamn',
      allDay: 'Hela dagen',
      startDate: 'Startdatum',
      endDate: 'Slutdatum',
      startHour: 'Starttimme',
      endHour: 'Sluttimme',
      assignedTo: 'Tilldelad till',
      assignedToMe: 'Tilldelad till mig',
      color: 'Färg',
      scoutingType: 'Scoutingtyp',
      taskLocation: 'Uppgiftsplats',
      selectLeague: 'Välj liga',
      selectMatch: 'Välj match',
      useMatchdate: 'Använd matchdatum som datum',
      stadium: 'Arena',
      travel: 'Resa',
      hotel: 'Hotell',
      tickets: 'Biljetter',
      taskNotes: 'Skriv beskrivande anteckningar eller kommentarer relaterade till uppgiften',
      states: {
        toDo: 'Att göra',
        inProgress: 'Pågående',
        done: 'Klar'
      },
      type: {
        player: 'Spelarbedömning',
        team: 'Lagbedömning',
        other: 'Övrigt'
      },
      location: {
        stadium: 'I arenan',
        video: 'Video'
      },
      accommodation: {
        accommodationDetails: 'Boendedetaljer',
        ownArrangement: 'Egen arrangemang',
        required: 'Krävs',
        notRequired: 'Krävs inte',
        booked: 'Bokad'
      },
      assignToMe: 'Tilldela till mig',
      addOther: 'Lägg till annan',
      deleteTask: 'Ta bort uppgift',
      deleteTaskMessage: 'Uppgiften kommer att tas bort, är du säker?',
      cancelUpdate: 'Avbryt uppdatering',
      cancelUpdateMessage: 'Ändringar kommer inte att sparas, är du säker?',
      selectGame: 'Vänligen, välj en match för att lägga till filer',
      noData: 'Ingen data. Börja med att lägga till några uppgifter!',
      widgetSubtitle: 'Kolla in dina nästa uppgifter',
      scoutingDetails: 'Scoutingdetaljer',
      taskDetails: 'Uppgiftsdetaljer',
      playerDocuments: 'Spelardokument',
      teamDocuments: 'Lagdokument',
      gameDocuments: 'Matchdokument',
      taskDocuments: 'Uppgiftsdokument',
      task: 'Uppgift'
    },
    nextGames: 'Nästa matcher'
  },
  scoutingTasksBoard: {
    period: {
      week: 'Denna vecka',
      month: 'Denna månad',
      year: 'Detta år'
    },
    noTasks: 'Skapa nya uppgifter eller dra en hit!',
    goToBoard: 'Gå till tavla'
  },
  profile: {
    title: 'Profil',
    subtitle: 'Anpassa ditt konto och prenumerationsdetaljer'
  },
  hub: {
    onlyHub: 'Endast tillgängligt i Driblab Hub',
    blue: 'blå',
    purple: 'purpur',
    orange: 'orange',
    grey: 'grå',
    indigo: 'indigo',
    teal: 'kricka',
    lightBlue: 'ljusblå',
    brown: 'brun'
  },
  uploadedGames: {
    subtitle: 'Alla uppladdade matcher',
    timeRequested: 'Tidpunkt det begärdes',
    timeReceived: 'När det mottogs',
    diffHours: 'Skillnad i timmar',
    collectionCompleted: 'Insamling slutförd',
    dateFrom: 'Datum från',
    dateTo: 'Datum till',
    goToUploadedGames: 'Gå till uppladdade matcher',
    sla: 'Serviceavtal',
    matchDate: 'Matchdatum',
    rejectedGame: 'Avvisad',
    reviewed: 'Recenserad',
    requested: 'Begärde',
    koraStatus: 'Kora Status',
    aws: 'AWS',
    fullVideo: 'Hela videon',
    offset: 'Offset',
    updateFullVideo: 'Uppdatera hela videon?'
  },
  gameMap: {
    title: 'Karta över matcher',
    subtitle: 'Utforska matcherna för de kommande dagarna',
    warning: 'Tiden och platsen kanske inte är korrekt. Bekräfta denna information.',
    taskAdded: 'Uppgift skapad framgångsrikt. Kontrollera Scoutkalendern.'
  },
  leagueRequestAccess: {
    sendSuccess: 'Meddelat framgångsrikt',
    notPermissions: 'Du har inte behörighet att se',
    notPermissionsLeague: 'Du har inte behörighet att se denna liga',
    notPermissionsGame: 'Du har inte behörighet att se denna match',
    requestAccessTo: 'Begär åtkomst till',
    sendRequest: 'Skicka begäran'
  },
  videoTeams: {
    subtitle: 'Hitta de senaste matcherna taggade per lag',
    noGamesUploaded: 'Inga matcher uppladdade ännu'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Scoutanalys',
    scoutingAnalyses: 'Scoutanalyser',
    playerScoutingAnalyses: 'Spelarscoutanalyser',
    gameScoutingAnalyses: 'Matchscoutanalyser',
    analyses: 'Analyser',
    addReport: 'Lägg till analys',
    technical: 'Teknisk',
    tactical: 'Taktisk',
    physical: 'Fysisk',
    mental: 'Mental',
    technicalNotes: 'Tekniska anteckningar',
    tacticalNotes: 'Taktiska anteckningar',
    physicalNotes: 'Fysiska anteckningar',
    mentalNotes: 'Mentala anteckningar',
    conclusion: 'Slutsats',
    charactersMax: 'Max 1000 tecken',
    globalRating: 'Global betyg',
    noData: 'Ingen data. Börja med att lägga till några scoutanalyser!',
    deleteAnalysis: 'Ta bort scoutanalys',
    deleteAnalysisMessage: 'Analysen kommer att tas bort permanent. Är du säker?',
    avgTooltip: 'Genomsnitt baserat på slutbetyg av analyser synliga för dig',
    avgOverallScoreTooltip: 'Genomsnitt baserat på spelarens totala poäng synliga för dig',
    scouter: 'Scout',
    lastEdited: 'Senast redigerad',
    analysisFilters: 'Analysfilter',
    generalFilters: 'Allmänna filter',
    widgetSubtitle: 'Senaste analyser tillagda',
    addPlayerReport: 'Lägg till spelarscoutanalys',
    seeReports: 'Se rapporter',
    addGameReport: 'Lägg till matchscoutanalys',
    keyPlayers: 'Nyckelspelare',
    formation: 'Formation',
    inPossession: 'Med bollinnehav',
    notesIP: 'Med bollinnehav anteckningar',
    outOfPossession: 'Utan bollinnehav',
    notesOP: 'Utan bollinnehav anteckningar',
    transitions: 'Övergångar',
    notesTransitions: 'Övergångsanteckningar',
    notesSP: 'Stationära situationer anteckningar',
    finalRating: 'Slutbetyg',
    gameNotesPlaceholder: 'Skriv beskrivande anteckningar eller kommentarer relaterade till matchen',
    avgPotentialTooltip: 'Genomsnitt baserat på potential för analyser som är synliga för dig',
    potential: 'Potential',
    tags: 'Taggar',
    tagsPlaceholder: 'Lägg till några taggar',
    tagsHint: 'Skriv och tryck på Enter för att lägga till en tagg',
    exampleTags: {
      leadership: 'Ledarskap',
      resilience: 'Elasticitet',
      competitiveMindset: 'Konkurrenstänk',
      calmUnderPressure: 'Lugn under press',
      focus: 'Fokus',
      discipline: 'Disciplin',
      coachability: 'Coachbarhet',
      poorBodyLanguage: 'Dåligt kroppsspråk',
      lowConfidence: 'Lågt självförtroende',
      easilyFrustrated: 'Lätt frustrerad'
    },
    totals: 'Totals',
    byPossession: 'By Possession'
  },
  addPlayerForm: {
    noLeague: 'Att skapa ett lag utan liga kan ha en negativ effekt på dess indexering och efterföljande sökning inom applikationen.'
  },
  expenses: {
    expense: 'Kostnad',
    expenses: 'Kostnader',
    addExpense: 'Lägg till kostnad',
    transportation: 'Transport',
    accommodation: 'Boende',
    dietary: 'Kost',
    eventTicket: 'Evenemangsbiljett',
    expenseType: 'Kostnadstyp',
    amount: 'Belopp',
    expenseDate: 'Kostnadsdatum',
    expenseFilters: 'Kostnadsfilter',
    noData: 'Ingen data. Börja med att lägga till några kostnader!',
    deleteExpense: 'Ta bort kostnad',
    deleteExpenseMessage: 'Kostnaden kommer att tas bort permanent. Är du säker?'
  },
  disabledTooltips: {
    general: 'Denna funktion är för närvarande inaktiverad',
    youth: 'Det måste vara ungdomslag för att sätta en ålder',
    unit: 'Statistik måste vara Runs, HSR eller SPR',
    seasonsWithout60MinsGames: 'Spelaren har inte spelat mer än 60 minuter i en enda match i den valda säsongen/säsongerna',
    notEditable: 'Detta kan inte redigeras',
    noMatchdate: 'Matchdatum otillgängligt',
    selectGame: 'Välj en match först',
    selectPlayer: 'Välj en spelare först',
    selectTeam: 'Välj ett lag först',
    selectBoxes: 'Rutor-visualisering måste vara vald',
    selectYear: 'Välj ett år först',
    pdScoreNotAvailable: 'Poäng ej tillgänglig för spelare som inte spelat 60 minuter i en match',
    pdSeasonNotAvailable: 'Fysisk data är inte tillgänglig för denna säsong',
    pdGameNotAvailable: 'Fysisk data är inte tillgänglig för denna match'
  },
  leagueTypes: {
    regular: 'Regelbunden',
    continental: 'Kontinental',
    nationalTeam: 'Landslag',
    countryCup: 'Landscup',
    qualifier: 'Kvalificering',
    playOff: 'Kvalificering',
    regionalLeague: 'Regional liga',
    friendly: 'Träningsmatch',
    nationalFriendly: 'Nationell träningsmatch',
    nationaQualifier: 'Nationell kvalificering'
  },
  playerSides: {
    'Left/Right': 'Vänster/Höger',
    'Left/Centre/Right': 'Vänster/Mitt/Höger',
    Right: 'Höger',
    Centre: 'Mitt',
    'Centre/Right': 'Mitt/Höger',
    Left: 'Vänster',
    'Left/Centre': 'Vänster/Mitt'
  },
  areaSelector: {
    selectAreas: 'Välj områden',
    filterAreas: 'Filtrera områden'
  },
  spatialCoverage: {
    lastDefenderDist: 'Sista försvararens avstånd',
    defensiveLineDist: 'Försvarslinjens avstånd',
    fullBackAvgDist: 'Back genomsnittligt avstånd',
    offensiveLineDist: 'Anfallslinjens avstånd',
    distanceToGoal: 'Avstånd till mål',
    avgLineWidth: 'Snitt linjebredd',
    leagueAvgDistanceToGoal: 'Snitt ligaavstånd till mål',
    leagueAvgLineWidth: 'Snitt ligalinjebredd',
    avgShort: 'Snitt',
    meters: 'meter',
    leagueAvgDist: 'Genomsnittligt ligaavstånd',
    distance: 'Avstånd',
    avgPositionYAxis: 'Snittavstånd på planen (Y)',
    leagueAvgPositionYAxis: 'Snitt ligans avstånd på planen (Y)',
    lbRbDistanceSeparation: 'LB–RB-avstånd',
    leagueAvgLbRbDistanceSeparation: 'Snitt liga LB–RB-avstånd',
    legendTeam: 'Lag',
    legendLeagueAvg: 'Ligasnitt',
    maxLength: 'Max längd',
    maxWidth: 'Max bredd',
    avgBlockDistance: 'Genomsnittlig blockavstånd'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Intelligent data',
    passesUnderPressureSubtitle: 'Analysera framgångsfrekvensen för passningar gjorda under defensivt tryck',
    onBallPressureSubtitle: 'Analysera försvarsdruckhändelser och deras framgångsgrad per fältzon',
    ballReceiptsInSpaceSubtitle: 'Analysera passningar som tas emot i rymden efter fältzon',
    ballReceipts: 'kvitton',
    totalBallReceipts: 'Totalt Bollmottagningar',
    totalBallReceiptsCompleted: 'Totalt Bollmottagningar Slutförda',
    completed: 'Slutförda',
    lineBreakingPassesSubtitle: 'Analysera passningar som bryter linjer och skapar fördelar',
    bypassed: 'Spela ut',
    oppsBypassed: 'Motståndarna utspelade',
    passer: 'Passningsspelare',
    passedTo: 'Passa till',
    receivedFrom: 'Mottagen från',
    distanceToNearestDefender: 'Avstånd till närmaste försvarare',
    lineBreaking: 'Linjebrytning {0}',
    keyPass: 'Nyckelpass',
    receiver: 'Mottagare',
    dynamicTracking: 'Dynamisk spårning',
    eventLockTooltip: 'Vissa spelare var inte synliga under spelningen',
    bypassedPlayers: '{0} passerade spelare',
    playersCount: '{0} spelare',
    bothTeams: 'Båda lagen',
    matchesCount: '{0} matcher',
    lbpType: {
      F: 'Anfallslinje',
      M: 'Mittfält',
      B: 'Försvarslinje',
      MF: 'Mittfält och anfallslinje',
      BM: 'Försvarslinje och mittfält',
      BF: 'Försvarslinje och anfallslinje',
      BMF: 'Försvarslinje, mittfält och anfallslinje'
    },
    lbpCategory: {
      'G-IN-T': 'Längs marken Inuti (bryter försvarslinjen)',
      'G-IN-NT': 'Längs marken Inuti (bryter inte försvarslinjen)',
      'G-OUT-T': 'Längs marken Utsida (bryter försvarslinjen)',
      'G-OUT-NT': 'Längs marken Utsida (bryter inte försvarslinjen)',
      'O-IN-T': 'Högt Inuti (bryter försvarslinjen)',
      'O-IN-NT': 'Högt Inuti (bryter inte försvarslinjen)',
      'O-OUT-T': 'Högt Utsida (bryter försvarslinjen)',
      'O-OUT-NT': 'Högt Utsida (bryter inte försvarslinjen)',
      ground: 'Längs marken',
      over: 'Högt',
      inside: 'Inuti',
      outside: 'Utsida',
      through: 'Bryter försvarslinjen',
      notThrough: 'Bryter inte försvarslinjen',
      throughAbbr: 'Breaking def. linje',
      notThroughAbbr: 'Bryter inte deff. linje'
    },
    lbpCategorySplit: {
      G: 'Mark: Passet var slipat',
      O: 'Över: Bollen slogs i luften',
      OUT: 'Utanför: Passet gick utanför',
      IN: 'Inuti: Passet gick in',
      T: 'Bryter försvarslinjen: passningen bryter försvarslinjen inifrån',
      NT: 'Bryter inte försvarslinjen: passningen bryter inte linjen inifrån utan kringgår den utifrån'
    },
    obrType: {
      OL: 'Överlappning',
      UL: 'Underlappning',
      RA: 'Spring framåt',
      RB: 'Springa bakom',
      CR: 'Korsmottagare',
      SP: 'Stöd',
      CS: 'Kommer kort'
    },
    visualization: 'Visualisering',
    points: 'Circles',
    zones: 'Värmekarta',
    pressureIntensity: 'Trycksättningens intensitet',
    pressureOutcome: 'Trycksättningens resultat',
    passesOutcome: 'Resultat av Passningar',
    strong: 'Stark',
    light: 'Ljust',
    normal: 'Normal',
    successful: 'Lyckades',
    unsuccessful: 'Misslyckades',
    presses: 'Trycksättningar',
    passes: 'Passerar',
    passUnder: 'Pass Under',
    successRate: 'Framgångsfrekvens',
    pressureOn: 'Trycksättning på',
    pressureOf: 'Press från',
    pressure: 'Trycksättning',
    totalLabel: 'totalt',
    totalPasses: 'Totalt antal Pass',
    unknown: 'okänd',
    selectGameToViewMap: 'Välj en match för att se tryckkartan',
    noEventsFoundForGame: 'Inga trycksättningar hittades för denna match',
    noEventsFoundForTeamAndSeason: 'Inga trycksättningar hittades för detta lag och säsong',
    noEventsFoundForPlayerAndSeason: 'Inga trycksättningar hittades för denna spelare och säsong',
    noEventsMatchFilters: 'Inga trycksättningar hittades som matchar de aktuella filtren',
    totalEventsAvailable: 'totalt antal trycksättningar',
    passType: {
      P: 'Passera',
      A: 'Hjälpa',
      KP: 'Nyckelpass',
      PiOB: 'Passera in i Opp. Låda',
      PiFT: 'Passera till sista tredje',
      SoPP: 'Byt av Play Pass'
    },
    minFrom: 'Min Från',
    minTo: 'Min Till',
    secondFrom: 'Seg From',
    secondTo: 'Seg To',
    positionPlayed: 'Spelad position',
    highlight: 'Markera',
    passTypeLabel: 'Typ av pass',
    offBallRunSubtitle: 'Analysera bort bollkörningar',
    insights: 'Insikter',
    insightsSubtitle: 'Rankning bäst med Advanced Arrigo Analytics',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: 'Hur kan jag hjälpa dig idag?',
    chatSubtext: 'Fråga vad som helst om fotbollsdata!',
    thinking: 'Tänkande...',
    giveFeedback: 'Ge feedback',
    disclaimer: 'DriblabAI kan göra misstag. Se till att verifiera informationen.',
    recent: 'Ny',
    noConversations: 'Här kommer du att se dina senaste konversationer!',
    rename: 'Döpa om',
    deleteConversation: 'Ta bort konversation',
    confirmDelete: 'Är du säker på att du vill ta bort den här konversationen?',
    feedback: 'Feed-back',
    feedbackQuestion: 'Var det här svaret till hjälp?',
    feedbackComments: 'Ytterligare kommentarer',
    feedbackPlaceholder: 'Berätta för oss vad som var användbart eller vad som kan förbättras...',
    errorMessage: 'Meddelandet kunde inte bearbetas. Försök igen.',
    newConversation: 'Ny chatt',
    write: 'Skriv ett meddelande...'
  },
  periodId: {
    1: 'Första halvlek',
    2: 'Andra halvlek',
    3: 'Förlängning - 1º',
    4: 'Förlängning - 2º',
    5: 'Straffläggning',
    6: 'Heltid',
    7: 'Förmatch',
    8: 'Övergiven',
    9: 'Bo',
    10: '0-15',
    11: '16-30',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76+',
    '-1': 'Andra'
  }
};
